var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBandera = function SvgBandera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "261 709.5 231 144"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F47AF",
    d: "M261 709.5h231v144H261z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M261 757.617h231v47.766H261z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.086,
    d: "M376.294 794.242c.363 0 .756 0 2.414-.404 1.658-.394 3.026-1.399 3.347-1.544.321-.145.787-.104.787-.104-.176-.187-.684-.653-1.399-.653-.725 0-.435 0-1.047.259-.611.249-1.886 1.026-4.041 1.026h-.041c-2.155 0-3.503-.777-4.114-1.026-.611-.259-.332-.259-1.047-.259-.726 0-1.223.466-1.409.653 0 0 .477-.041.798.104.321.145 1.689 1.15 3.347 1.544 1.649.404 2.053.404 2.405.404z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.086,
    d: "M369.931 792.83c.176-.104-.042-.394-.042-.394l.653-.145c-.321-.145-.798-.104-.798-.104-.125.104-.104.228-.125.321-.01.094-.01.239.062.311.064.063.25.011.25.011z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.086,
    d: "m370.541 792.293-.653.145s.218.29.042.394l1.15-.218c-.001 0-.177-.124-.539-.321zM382.666 792.83c-.176-.104.031-.394.031-.394l-.642-.145c.321-.145.787-.104.787-.104.135.104.114.228.135.321.01.094.01.239-.062.311-.073.063-.249.011-.249.011z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.086,
    d: "m382.055 792.293.643.145s-.207.29-.031.394l-1.15-.218c-.001 0 .175-.124.538-.321z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m371.716 791.844-.291.724.134.052c.218.093.434.044.537-.194.093-.249-.032-.432-.239-.515l-.141-.067zm.06.149.022.007c.166.072.266.191.194.388-.083.186-.248.192-.403.119l-.03-.008.217-.506zM372.044 792.84l.321-.713.083.032-.321.713zM372.76 792.314a.427.427 0 0 0-.366.261.39.39 0 0 0 .194.522.398.398 0 0 0 .522-.224.415.415 0 0 0-.202-.53.365.365 0 0 0-.148-.029zm-.007.12c.035 0 .076.007.112.022.155.062.197.228.134.373-.062.145-.231.219-.366.157a.277.277 0 0 1-.119-.373c.046-.109.134-.178.239-.179zM373.619 792.811c-.01-.052-.031-.093-.083-.114-.052-.021-.135 0-.155.062-.021.062.021.114.052.145l.052.042c.083.073.135.156.083.28a.241.241 0 0 1-.311.145c-.104-.042-.166-.166-.135-.29l.093.021c-.031.073.01.155.083.186.073.031.156-.021.187-.093.031-.083-.021-.135-.073-.187l-.041-.042c-.062-.062-.114-.135-.073-.238a.201.201 0 0 1 .269-.114c.083.031.124.093.135.176l-.083.021zM374.19 792.852l-.124.435c-.031.124-.031.249.104.29.145.042.207-.062.249-.187l.124-.446.083.031-.135.466c-.042.166-.176.269-.342.217-.166-.041-.228-.197-.176-.363l.135-.477.082.034zM375.236 793.929l-.435-.714-.114.568-.083-.01.156-.807.425.704.114-.558.083.01-.146.807zM375.433 793.909l.093-.768.083.01-.093.778-.083-.02zM376.097 793.174a.39.39 0 0 0-.403.381c-.01.239.156.415.373.425a.39.39 0 0 0 .403-.388c.01-.218-.166-.418-.373-.418zm-.015.112a.28.28 0 0 1 .261.306.272.272 0 0 1-.276.276c-.145-.01-.261-.143-.261-.299.01-.155.12-.283.276-.283zM377.267 793.951l-.601-.56.042.58h-.093l-.062-.807.601.558-.042-.571.094-.01.061.81zM377.754 793.836l-.145-.766.093-.01.135.672.218-.039.021.091-.322.052zM378.168 793.754l-.176-.758.093-.02.176.756-.093.022zM378.411 792.897a.572.572 0 0 0-.097.015l-.082.03.209.746.164-.037c.124-.042.228-.135.187-.291-.021-.083-.101-.152-.194-.142.041-.041.048-.12.037-.172-.039-.124-.127-.154-.224-.149zm.015.097c.049-.008.096.012.119.09.031.093-.032.121-.104.142l-.022.007-.075-.224h.03a.216.216 0 0 1 .052-.015zm.119.313c.061-.007.126.004.142.082.031.093-.039.136-.112.157l-.067.022-.06-.239.045-.007c.018-.005.032-.012.052-.015zM379.215 792.956l.031.081-.28.094.093.279.29-.104.031.094-.373.126-.259-.736.383-.136.021.082-.29.104.072.208.281-.092zM379.545 792.531a.315.315 0 0 0-.194.037l-.104.045.291.724.082-.03-.112-.313.03-.007.321.216.112-.037-.351-.231c.093-.052.123-.165.082-.269a.21.21 0 0 0-.157-.135zm-.022.098c.04.004.076.03.097.082.041.103-.044.155-.127.187l-.015.008-.097-.239.022-.008a.257.257 0 0 1 .12-.03zM379.692 792.428l.405-.178.04.074-.165.072.291.632-.084.042-.289-.632-.156.072-.042-.082zM380.403 792.054l.052.888.097-.052-.015-.201.306-.157.164.134.082-.052-.686-.56zm.104.209.239.194-.216.112-.023-.306zM381.143 791.741a.477.477 0 0 0-.231.075l-.134.075.41.672.119-.067c.207-.124.299-.332.164-.56-.084-.143-.201-.202-.328-.195zm.037.119a.269.269 0 0 1 .202.134c.104.176.006.31-.149.403l-.015.007-.284-.463.022-.022a.423.423 0 0 1 .224-.059z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E60000",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M369.143 794.676a.212.212 0 0 0 .218-.218.21.21 0 0 0-.218-.207c-.114 0-.218.093-.218.207a.22.22 0 0 0 .218.218zM367.92 796.188a.213.213 0 0 0 .218-.217.22.22 0 0 0-.218-.218.226.226 0 0 0-.217.218c0 .124.104.217.217.217zM365.081 791.442a.227.227 0 0 0 .218-.217.22.22 0 0 0-.218-.218.213.213 0 0 0-.218.218c0 .114.093.217.218.217zM363.318 792.324a.241.241 0 0 0 .238-.239.248.248 0 0 0-.238-.238.24.24 0 0 0-.238.238c0 .135.103.239.238.239zM362.998 786.998a.241.241 0 0 0 .238-.238.247.247 0 0 0-.238-.238.24.24 0 0 0-.238.238c0 .134.103.238.238.238zM361.515 787.432a.234.234 0 0 0 .238-.238.234.234 0 0 0-.238-.238.241.241 0 0 0-.238.238.24.24 0 0 0 .238.238zM362.272 782.687a.24.24 0 0 0 .238-.238.234.234 0 0 0-.238-.239.234.234 0 0 0-.238.239c0 .124.104.238.238.238zM360.947 778.323c.124 0 .238-.104.238-.228a.24.24 0 0 0-.238-.238.234.234 0 0 0-.238.238.23.23 0 0 0 .238.228zM362.635 778.758a.234.234 0 0 0 .238-.238.241.241 0 0 0-.238-.238.24.24 0 0 0-.238.238c0 .134.103.238.238.238zM364.293 775.123a.241.241 0 0 0 .238-.238c0-.125-.114-.228-.238-.228a.232.232 0 0 0-.238.228c0 .134.103.238.238.238zM363.029 774.117a.234.234 0 0 0 .238-.238.24.24 0 0 0-.238-.238.24.24 0 0 0-.238.238c0 .135.104.238.238.238zM365.547 771.672a.234.234 0 0 0 .238-.238.234.234 0 0 0-.238-.238.234.234 0 0 0-.238.238.234.234 0 0 0 .238.238zM360.407 782.718a.232.232 0 0 0 .238-.228.233.233 0 0 0-.238-.228.23.23 0 0 0-.228.228.23.23 0 0 0 .228.228z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M369.349 795.567s-.176-.756-.145-.932l.187-.145M369.06 795.856s-.674.031-.891.104c0 0 0 .041-.072.187M364.895 792.438s-.042-.901.145-.974c0 0 .176-.072.28-.218M364.209 792.147s-.508-.073-.653 0c0 0-.031.145-.145.187M363.237 786.862l-.176.104c-.187.072-.539.943-.539.943s-.58-.435-.829-.477h-.259M360.283 782.613s.145.145.29.073c0 0 .715.466.756.653 0 0 .757-.756.901-.684 0 0 .072.104.218-.042M361.08 778.19s.073.103.207.176c0 0 .332.477.332.829 0 0 .612-.539.788-.497 0 0 .217.073.362 0M362.843 774.055s.145.176.249.031c0 0 .435.539.176.943 0 0 .612-.145.798-.042 0 0 .072.249.29.104"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M380.54 800.21s-.932-.072-1.078-.072c-.145 0-.466-.643-.611-.756-.145-.104-2.591-1.295-4.176-1.544-1.586-.249-4.021-1.192-4.528-1.44-2.632-1.264-5.575-3.606-6.228-4.57-.684-1.005-1.409-3.347-1.73-4.601-.145-.581-.933-2.953-.933-4.57 0-1.875.217-3.42.508-4.643.28-1.223 2.383-4.808 3.668-6.404 0 0-2.891 4.476-3.388 6.186-.497 1.762-.643 3.907-.612 5.13.031 1.005.87 4.684 2.093 7.388.974 2.166 1.824 2.425 3.347 3.637.715.57 2.083 1.471 3.233 2.052 1.15.57 3.596 1.295 4.249 1.399.643.114 3.917 1.078 4.352 1.296.436.217 1.544 1.191 1.834 1.512z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M364.137 791.867c.073-.332.104-.58.218-.684.104-.114.466-.549.539-.829.073-.29 0-.508 0-.653 0-.145.104-.643.104-.643s-.176-.611-.321-.726c-.145-.104-.508-.612-.58-.756 0 0 .041.29-.073.435-.104.145-.145.508-.145.715 0 .218.072.726 0 .974-.073.28-.176.508-.104.829.062.261.362 1.338.362 1.338z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M364.023 791.505s-.819-1.047-.819-1.482c0-.425-.072-.684-.145-.787-.073-.104-.539-.653-.114-1.326.187-.29.218-.269.321-.581.145-.394.435-.394.477-.787 0 0 .104.466.135.86.041.394-.031.539-.062.756-.041.218.104.466.104.788 0 .332-.041.456-.041.653-.001.103-.136 1.47.144 1.906zM373.247 797.122s-.695-.073-.953-.114a4.418 4.418 0 0 1-.85-.218c-.207-.073-.612-.29-.964-.663-.663-.705-.601-1.078-.715-1.109-.238-.041.373-.104.663-.062.28.031.674.238.933.487.269.249.684.529.829.632.145.114.249.155.404.363.155.207.145.342.653.684z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M374.199 797.628s-1.741-.777-1.917-.922a5.958 5.958 0 0 1-.663-.612c-.176-.197-.912-.57-1.036-.808-.083-.166-.539-.798-.808-1.295-.135-.259 1.161.083 1.161.083 1.057.425.58.124 1.161.56.352.269.591.497.684.694.135.311.29.849.446 1.13.143.279.423.641.972 1.17z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M375.143 797.848s-1.44-.373-2.093-1.264c-.466-.611-.466-.425-.663-.632-.238-.259-.611-.539-.922-1.067.031.052-.415-1.409-.394-1.586.011-.104.549.073.984.259.373.156.591.456.912.653.384.249.435.87.612 1.161.249.425.28.643.28.849-.01.321.176.425.28.694.123.321.507.27 1.004.933zM372.843 797.37s-1.223-.539-1.399-.58c-.186-.031-.259-.145-.508-.218-.207-.052-.394-.207-.901-.103-.218.052-1.109.249-1.326.145-.218-.114.321.612.57.756.259.145.684.218 1.047.176.362-.031.86 0 1.047 0 .176 0 .28.042.539-.031.247-.072.319-.186.931-.145z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M373.672 797.37s-1.368-.342-1.596-.342c-.228 0-.881.042-1.15.093-.259.042-1.078-.042-1.316.083-.249.114-1.337.269-1.627.197-.29-.062.58.777.922.871 1.109.311.777.269 1.492.083.435-.114 1.057-.145 1.275-.176.217-.042.176-.166.466-.29.29-.125.777-.436 1.534-.519zM374.789 797.941s-1.368-.57-2.435-.28c-.736.207-.715.176-1.005.228-.342.052-.632-.125-1.192.104-.28.114-1.471.601-1.803.581-.301-.021.953.798 1.295.746 1.098-.156 2.135.218 2.642.01.456-.176.726-.301.953-.373.228-.083.352-.29.497-.394.147-.114.24-.394 1.048-.622zM367.486 794.8s-.788-.87-.943-.984c-.145-.114-.518-.384-.715-.56-.166-.145-.332-.466-.839-.591-.218-.052-.746-.156-.901-.342-.145-.197.031.694.197.932.166.238.518.487.86.612.342.124.777.373.932.456.166.073.249.156.508.197.258.053.372-.02.901.28z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M368.231 795.163s-1.337-.943-1.544-1.047a11.29 11.29 0 0 0-.839-.311c-.259-.073-.933-.56-1.202-.56-.269 0-.777-.021-1.005-.197-.238-.187-.031.653.228.891.86.767.269.539.984.684.435.093 1.016.332 1.223.394.218.062.238-.072.549-.052.311.012.891-.05 1.606.198z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M368.551 795.412s-.549-.363-1.637-.549c-.746-.135-.715-.166-.995-.238-.332-.104-.404-.104-1.016-.135-.3-.021-1.482.363-1.762.197-.259-.145.29.362.622.487.477.176.415.487.933.653.549.176 1.13.394 1.451.332.249-.052.435-.166.787-.197.343-.043.944-.54 1.617-.55zM368.666 795.132s.269-1.305.042-1.616a1.236 1.236 0 0 1-.29-.684c-.031-.321-.249-.86-.394-1.036-.145-.187-.435-1.016-.363-1.223 0 0-.756.746-.715 1.223.031.466.031.352 0 .57-.042.218.176.932.321 1.15.145.218.073.87.218 1.005.145.145 1.005.725 1.181.611z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M368.551 795.412c.083.041-.456-.414-.715-.529-.249-.104-1.254-.394-1.327-.643-.072-.259-.901-1.119-.932-1.337-.031-.166-.187-.508-.145-.684.031-.176.104-.611.218-.86.103-.259.352-.86.611-.974 0 0 .207.684.28.933.073.259.145.549.259.684.104.145.466.829.497 1.088.042.249.218 1.078.259 1.254.031.176.705.912.995 1.068zM364.137 791.867c.031.187-.539-.186-.829-.186-.29 0-1.15.114-1.368-.104-.218-.218-.539-.611-.653-.684-.104-.073-.497-.725-.611-1.078-.104-.363-.86-1.016-.964-1.088 0 0 1.036-.207 1.689.218.643.435.684.332.829.394.145.073 1.254 1.015 1.326 1.368.074.363.54.974.581 1.16z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M364.137 791.867s-.933-.653-1.15-.622c-.218.042-1.233-.715-1.295-1.181-.042-.249-.529-.601-.612-.756-.259-.435-.404-1.399-.756-1.658 0 0 .974.249 1.223.29.466.073.86.145 1.036.539.186.394.332.726.477.756.145.042.352.539.425 1.047.072.497.652 1.585.652 1.585zM362.375 786.967c.155.249.145-1.441.207-1.617.073-.176.259-.539.404-.684.145-.145.145-.643.218-.787.062-.145.031-1.119-.072-1.368 0 0-.29.217-.435.393-.145.176-.394.249-.466.466-.073.218-.218.218-.321.435-.114.218-.218.57-.145.86.073.29.031.394.031.653-.001.25.361 1.327.579 1.649z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M362.406 787.11s-.073-.466.114-.643c.176-.187.352-.187.425-.29.073-.114.041-.249.114-.394.073-.145.228-.383.249-.508.073-.394.29-.829.104-1.254 0 0-.394.135-.497.207-.114.073-.435.363-.466.653-.041.321-.072.363-.186.539-.104.176-.249.715-.073 1.047.185.322.216.643.216.643zM361.36 781.61s-.073-1.047.218-1.368c.29-.321.363-.932 1.005-1.264 0 0-.031.259 0 .435.042.176.114.684 0 .86-.104.187-.466.508-.466.653 0 .145-.249.508-.425.58-.187.062-.332.104-.332.104z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M361.36 782.178s0-.746.218-.963c.218-.218.332-.332.435-.466.104-.145.218-.508.466-.653.249-.145.684-.508.726-.643 0 0 .103.891-.145 1.368-.259.466-.259.715-.539.819-.29.114-.332.187-.435.259-.114.073-.29.176-.435.176-.146 0-.291.103-.291.103zM362.189 787.079c.042.207.187-.466-.57-.466s-1.368-.29-1.627-.549c-.249-.249-.394-.425-.498-.539-.114-.103-.394-.539-.435-.756-.031-.207-.249-1.005-.218-1.15 0 0 .404.072.58.217.176.145.508.145.684.259.176.104.321.394.435.497.104.114.425.114.57.321.145.218.394.684.435.901.031.218.29.435.466.539.178.115.146.54.178.726z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M362.117 786.79s-.497-.612-.756-.612c-.249 0-.891-.653-.933-.932-.031-.29-.249-.829-.394-.943a.867.867 0 0 1-.363-.787c.041-.435.041-1.15.041-1.15s.145.435.352.539c.218.104.612.249.684.394.072.145.363.145.477.58.104.425.104.394.176.539.073.145.249.322.321.612.074.289.467 1.034.395 1.76zM361.372 782.821c-.021.197.29-.383-.394-.591-.695-.207-1.171-.642-1.326-.943-.156-.29-.238-.497-.311-.622-.062-.135-.207-.601-.176-.808.021-.207.052-.984.125-1.109 0 0 .342.176.456.352.125.186.425.28.56.425.125.145.176.445.249.58.073.124.363.218.435.446.073.238.166.736.135.943-.021.207.145.466.28.622.133.145-.023.528-.033.705z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M361.381 782.532s-.29-.695-.518-.756c-.228-.073-.601-.663-.622-.933-.031-.311-.072-.829-.176-.963-.103-.135-.29-.58-.145-.964.155-.383.394-.891.394-.891s.207.321.321.518c.186.373.373.404.404.549.021.155.249.249.332.549.114.404-.011.384.01.539.031.145.145.363.124.643-.01.278.146 1.076-.124 1.709zM361.94 778.19c.031-.104.249-.218.508-.29.249-.073.643-.643.819-.788.166-.156.259-.383.477-.508.218-.125.352-.57.425-1.005 0 0-.611.145-.787.176-.176.042-.539.259-.684.435-.145.176-.29.466-.435.539-.145.073-.321.508-.321.798-.002.28-.002.643-.002.643z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M361.909 777.867s-.041-.425-.041-.611c0-.218-.135-.798.176-1.264.218-.321 1.016-.933 1.223-.964 0 0 .145.57.114.746-.041.187-.228.902-.394.974-.166.072-.58.933-1.078 1.119z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M361.723 778.19c-.093.155-.031-.539-.249-.715-.217-.187-.249-.435-.249-.726 0-.29.062-.497.104-.684.031-.176.58-.932.539-1.15 0 0 .311.705.394.901.114.249-.073.508-.031.715.031.218.207.612.072.829-.114.187-.435.581-.58.83zM363.629 774.481s.042-.104.363-.104.788-.031.933-.177c.145-.145.394-.332.539-.404.145-.062.394-.393.435-.539.031-.145.29-.425.394-.425 0 0-.394-.042-.829.073-.425.104-1.036.321-1.181.612-.147.28-.654.964-.654.964z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M363.743 774.406c.083.249.684-.249.818-.424l.363-.466s.342-.414.435-.58c.218-.394.166-1.109.072-1.047a7.33 7.33 0 0 1-.611.332c-.114.031-.321.103-.394.28-.073.186-.145.435-.259.549-.102.103-.755.465-.424 1.356z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M363.526 774.406s.497-.352.684-.539c.218-.207.104-.497.218-.643.093-.135.352-.466.28-.684-.072-.218-.207-.829-.207-.829s-.259.249-.435.435c-.186.176-.218.321-.29.539-.072.218-.218.363-.29.539s0 .539.041.756c.03.219-.001.426-.001.426z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M371.474 797.079s-2.373-.031-2.591-.321M372.843 797.37s-1.544.425-2.373.321c-.829-.103-1.223.073-1.409.073-.176 0-1.078-.363-1.078-.363M374.426 797.941s-1.192.218-1.44.29c-.249.073-1.471.539-1.834.539-.29 0-.995-.031-1.192 0-.352.073-1.296 0-1.513-.104M369.931 795.101s.902.539 1.047.715c.135.187.933.829 1.078.829M369.931 793.981s1.544 1.337 1.793 1.513c.259.187 1.772 1.658 1.948 1.876M371.183 793.41s1.223.974 1.368 1.368c.145.394.508.86.508.86s.508 1.005.684 1.15c.176.145.539.528.974.798M364.209 792.51s1.285 1.088 1.637 1.295M363.672 793.193s1.296.901 1.865 1.119c.58.208 1.047.394 2.3.57M368.346 795.39s-1.44-.073-1.689 0c-.249.072-1.368-.187-1.658-.259-.29-.062-1.44-.28-1.585-.321M366.148 790.53s-.072.787.042 1.119c.104.321.612 1.254.57 1.471-.031.218.29 1.191.58 1.368M367.629 790.676s-.259.788-.145 1.047c.103.249.28.715.28 1.005 0 .29.186.715.259.901.073.176-.042.787.145.964.176.186.394.508.394.508M359.929 788.841s1.15.435 1.295.715c.135.29.352.363.466.508M364.168 787.764s.29 1.15.218 1.44c-.073.28-.073.86-.073 1.078 0 .218-.321 1.078-.29 1.223M363.703 786.79s-.104.684-.145.974c-.031.28 0 .756-.073.932-.073.176-.176 1.15 0 1.585M360.543 787.764s.933.787 1.15 1.005c.217.218 1.181 1.254 1.223 1.513.031.249.715 1.036.933 1.223M358.957 783.733s.932.932 1.005 1.15c.072.218.466.57.653.684M363.34 784.127s-.352.539-.352.715c0 .187-.145.653-.29.829-.093.124-.394.653-.363.974M363.06 782.613s-.145.508-.218.86c-.073.363-.259.725-.321.943-.073.218-.363 1.254-.259 1.907M359.786 782.582s.104.497.352.756c.259.249.653.612.684.819.042.217.363 1.295.726 1.658s.394.726.394.726M359.423 778.916s.104.611.176.787c.073.176.363.974.653 1.223M362.521 779.09s-.187.497-.218.715c-.042.218-.259.466-.29.58-.042.104-.176.466-.176.466M363.163 779.587c-.031.218-.435.87-.466.974-.042.114-.249.611-.466.756-.217.145-.86.611-.829.798M360.354 778.19s-.031.787.114 1.078c.145.29.321.726.394.943.073.207.073.57.103.819.042.259.145.725.29.901M364.066 775.744s-.518.591-.757.829c-.238.238-1.15 1.223-1.192 1.399M363.206 775.204s-.508 1.109-.622 1.285a3.899 3.899 0 0 0-.207.477M361.909 775.164s.031.87 0 1.088c-.041.207-.041.57 0 .684.031.104-.114.891-.145 1.078M366.074 772.935s-1.15.684-1.327.86"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.035,
    d: "m365.392 772.034-.788 1.15-.176.332"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M364.501 771.93s-.259.611-.29.86c-.042.259-.394 1.047-.539 1.337"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M365.36 771.464s-.114.249.321.176"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#E60000",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M383.452 794.676a.212.212 0 0 1-.218-.218.21.21 0 0 1 .218-.207c.114 0 .217.093.217.207a.218.218 0 0 1-.217.218zM384.675 796.188a.213.213 0 0 1-.218-.217.22.22 0 0 1 .218-.218c.114 0 .217.104.217.218a.219.219 0 0 1-.217.217zM387.514 791.442a.227.227 0 0 1-.218-.217.22.22 0 0 1 .218-.218c.124 0 .218.093.218.218a.218.218 0 0 1-.218.217zM389.277 792.324a.241.241 0 0 1-.238-.239c0-.124.114-.238.238-.238a.24.24 0 0 1 .238.238.234.234 0 0 1-.238.239zM389.597 786.998a.241.241 0 0 1-.238-.238c0-.125.114-.238.238-.238a.24.24 0 0 1 .238.238.234.234 0 0 1-.238.238zM391.08 787.432a.234.234 0 0 1-.238-.238c0-.135.103-.238.238-.238.124 0 .238.104.238.238a.24.24 0 0 1-.238.238zM390.323 782.687a.24.24 0 0 1-.238-.238c0-.135.103-.239.238-.239s.238.104.238.239a.241.241 0 0 1-.238.238zM391.648 778.323c-.124 0-.238-.104-.238-.228a.24.24 0 0 1 .238-.238c.135 0 .238.104.238.238a.23.23 0 0 1-.238.228zM389.96 778.758a.234.234 0 0 1-.238-.238c0-.124.104-.238.238-.238a.24.24 0 0 1 .238.238.234.234 0 0 1-.238.238zM388.302 775.123a.24.24 0 0 1-.238-.238c0-.125.114-.228.238-.228.135 0 .238.103.238.228a.234.234 0 0 1-.238.238zM389.566 774.117a.234.234 0 0 1-.238-.238c0-.124.104-.238.238-.238a.24.24 0 0 1 .238.238.234.234 0 0 1-.238.238zM387.049 771.672a.234.234 0 0 1-.238-.238c0-.135.104-.238.238-.238.135 0 .238.104.238.238a.235.235 0 0 1-.238.238zM392.188 782.718a.232.232 0 0 1-.238-.228c0-.124.103-.228.238-.228a.23.23 0 0 1 .228.228.23.23 0 0 1-.228.228z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M383.246 795.567s.176-.756.145-.932l-.187-.145M383.535 795.856s.674.031.891.104c0 0 0 .041.072.187M387.701 792.438s.042-.901-.145-.974c0 0-.176-.072-.28-.218M388.386 792.147s.508-.073.653 0c0 0 .031.145.145.187M389.358 786.862l.176.104c.186.072.539.943.539.943s.58-.435.829-.477h.259M392.312 782.613s-.145.145-.29.073c0 0-.715.466-.756.653 0 0-.757-.756-.901-.684 0 0-.073.104-.218-.042M391.515 778.19s-.073.103-.207.176c0 0-.332.477-.332.829 0 0-.612-.539-.788-.497 0 0-.217.073-.362 0M389.752 774.055s-.145.176-.249.031c0 0-.435.539-.176.943 0 0-.612-.145-.798-.042 0 0-.072.249-.29.104"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M372.055 800.21s.932-.072 1.078-.072c.145 0 .466-.643.611-.756.145-.104 2.591-1.295 4.176-1.544 1.586-.249 4.021-1.192 4.529-1.44 2.632-1.264 5.575-3.606 6.228-4.57.684-1.005 1.409-3.347 1.73-4.601.145-.581.933-2.953.933-4.57 0-1.875-.218-3.42-.508-4.643-.28-1.223-2.383-4.808-3.668-6.404 0 0 2.891 4.476 3.388 6.186.497 1.762.643 3.907.612 5.13-.031 1.005-.87 4.684-2.093 7.388-.974 2.166-1.824 2.425-3.347 3.637-.715.57-2.083 1.471-3.233 2.052-1.15.57-3.596 1.295-4.249 1.399-.643.114-3.917 1.078-4.352 1.296-.437.217-1.545 1.191-1.835 1.512z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M388.458 791.867c-.073-.332-.104-.58-.218-.684-.104-.114-.466-.549-.539-.829-.073-.29 0-.508 0-.653 0-.145-.104-.643-.104-.643s.176-.611.321-.726c.145-.104.508-.612.58-.756 0 0-.041.29.073.435.104.145.145.508.145.715 0 .218-.072.726 0 .974.073.28.176.508.104.829a75.398 75.398 0 0 1-.362 1.338z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M388.572 791.505s.819-1.047.819-1.482c0-.425.072-.684.145-.787.073-.104.539-.653.114-1.326-.186-.29-.217-.269-.321-.581-.145-.394-.435-.394-.476-.787 0 0-.104.466-.135.86-.041.394.031.539.062.756.042.218-.103.466-.103.788 0 .332.041.456.041.653 0 .103.134 1.47-.146 1.906zM379.349 797.122s.695-.073.953-.114c.187-.021.612-.124.85-.218.207-.073.612-.29.964-.663.663-.705.601-1.078.715-1.109.238-.041-.373-.104-.663-.062-.28.031-.674.238-.933.487-.269.249-.684.529-.829.632-.145.114-.249.155-.404.363-.156.207-.146.342-.653.684z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M378.396 797.628s1.741-.777 1.917-.922c.186-.135.477-.415.663-.612.176-.197.912-.57 1.036-.808.083-.166.539-.798.808-1.295.135-.259-1.161.083-1.161.083-1.057.425-.58.124-1.161.56-.352.269-.591.497-.684.694-.135.311-.29.849-.446 1.13-.143.279-.423.641-.972 1.17z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M377.452 797.848s1.44-.373 2.093-1.264c.466-.611.466-.425.663-.632.238-.259.612-.539.922-1.067-.031.052.415-1.409.394-1.586-.01-.104-.549.073-.984.259-.373.156-.591.456-.912.653-.383.249-.435.87-.611 1.161-.249.425-.28.643-.28.849.01.321-.176.425-.28.694-.124.321-.507.27-1.005.933zM379.752 797.37s1.223-.539 1.399-.58c.186-.031.259-.145.508-.218.207-.052.394-.207.902-.103.218.052 1.109.249 1.326.145.218-.114-.321.612-.57.756-.259.145-.684.218-1.047.176-.362-.031-.86 0-1.047 0-.176 0-.28.042-.539-.031-.248-.072-.32-.186-.932-.145z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M378.924 797.37s1.368-.342 1.596-.342c.228 0 .881.042 1.15.093.259.042 1.078-.042 1.316.083.249.114 1.337.269 1.627.197.29-.062-.58.777-.922.871-1.109.311-.777.269-1.492.083-.435-.114-1.057-.145-1.275-.176-.217-.042-.176-.166-.466-.29-.291-.125-.778-.436-1.534-.519z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M377.806 797.941s1.368-.57 2.435-.28c.736.207.715.176 1.005.228.342.052.632-.125 1.192.104.28.114 1.471.601 1.803.581.301-.021-.953.798-1.295.746-1.098-.156-2.135.218-2.642.01-.456-.176-.726-.301-.953-.373-.228-.083-.352-.29-.497-.394-.147-.114-.24-.394-1.048-.622zM385.109 794.8s.788-.87.943-.984c.145-.114.518-.384.715-.56.166-.145.331-.466.839-.591.218-.052.746-.156.901-.342.145-.197-.031.694-.197.932-.166.238-.518.487-.86.612-.342.124-.777.373-.933.456-.166.073-.249.156-.508.197-.257.053-.371-.02-.9.28z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M384.364 795.163s1.337-.943 1.544-1.047c.207-.093.591-.228.839-.311.259-.073.933-.56 1.202-.56s.777-.021 1.005-.197c.238-.187.031.653-.228.891-.86.767-.269.539-.984.684-.435.093-1.016.332-1.223.394-.218.062-.238-.072-.549-.052-.311.012-.891-.05-1.606.198z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M384.044 795.412s.549-.363 1.637-.549c.746-.135.715-.166.995-.238.332-.104.404-.104 1.016-.135.3-.021 1.482.363 1.762.197.259-.145-.29.362-.622.487-.477.176-.415.487-.933.653-.549.176-1.13.394-1.451.332-.249-.052-.435-.166-.787-.197-.342-.043-.943-.54-1.617-.55zM383.929 795.132s-.269-1.305-.042-1.616c.114-.145.259-.352.29-.684.031-.321.249-.86.394-1.036.145-.187.435-1.016.363-1.223 0 0 .756.746.715 1.223-.031.466-.031.352 0 .57.042.218-.176.932-.321 1.15-.145.218-.073.87-.218 1.005-.145.145-1.005.725-1.181.611z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M384.044 795.412c-.083.041.456-.414.715-.529.249-.104 1.254-.394 1.327-.643.072-.259.901-1.119.932-1.337.031-.166.187-.508.145-.684-.031-.176-.104-.611-.218-.86-.103-.259-.352-.86-.611-.974 0 0-.207.684-.28.933-.073.259-.145.549-.259.684-.104.145-.466.829-.497 1.088a39.576 39.576 0 0 1-.259 1.254c-.031.176-.705.912-.995 1.068zM388.458 791.867c-.031.187.539-.186.829-.186.29 0 1.15.114 1.368-.104.218-.218.539-.611.653-.684.104-.073.497-.725.611-1.078.104-.363.86-1.016.964-1.088 0 0-1.036-.207-1.689.218-.643.435-.684.332-.829.394-.145.073-1.254 1.015-1.326 1.368-.074.363-.54.974-.581 1.16z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M388.458 791.867s.933-.653 1.15-.622c.218.042 1.233-.715 1.295-1.181.042-.249.529-.601.612-.756.259-.435.404-1.399.756-1.658 0 0-.974.249-1.223.29-.466.073-.86.145-1.036.539-.186.394-.332.726-.477.756-.145.042-.352.539-.425 1.047-.072.497-.652 1.585-.652 1.585zM390.22 786.967c-.155.249-.145-1.441-.207-1.617-.073-.176-.259-.539-.404-.684-.145-.145-.145-.643-.217-.787-.062-.145-.031-1.119.072-1.368 0 0 .29.217.435.393.145.176.394.249.466.466.073.218.218.218.321.435.114.218.218.57.145.86-.073.29-.031.394-.031.653.001.25-.362 1.327-.58 1.649z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M390.189 787.11s.073-.466-.114-.643c-.176-.187-.352-.187-.425-.29-.073-.114-.041-.249-.114-.394-.073-.145-.228-.383-.249-.508-.073-.394-.29-.829-.104-1.254 0 0 .394.135.497.207.114.073.435.363.466.653.041.321.072.363.186.539.104.176.249.715.072 1.047-.184.322-.215.643-.215.643zM391.235 781.61s.073-1.047-.218-1.368c-.29-.321-.363-.932-1.005-1.264 0 0 .031.259 0 .435-.042.176-.114.684 0 .86.104.187.466.508.466.653 0 .145.249.508.425.58.187.062.332.104.332.104z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M391.235 782.178s0-.746-.218-.963a4.933 4.933 0 0 1-.435-.466c-.104-.145-.218-.508-.466-.653-.249-.145-.684-.508-.726-.643 0 0-.104.891.145 1.368.259.466.259.715.539.819.29.114.332.187.435.259.114.073.29.176.435.176s.291.103.291.103zM390.407 787.079c-.042.207-.187-.466.57-.466.756 0 1.368-.29 1.627-.549.249-.249.394-.425.498-.539.114-.103.394-.539.435-.756.031-.207.249-1.005.218-1.15 0 0-.404.072-.58.217-.176.145-.508.145-.684.259-.176.104-.321.394-.435.497-.103.114-.424.114-.57.321-.145.218-.394.684-.435.901-.031.218-.29.435-.466.539-.178.115-.147.54-.178.726z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M390.478 786.79s.497-.612.756-.612c.249 0 .891-.653.932-.932.031-.29.249-.829.394-.943a.864.864 0 0 0 .362-.787c-.041-.435-.041-1.15-.041-1.15s-.145.435-.352.539c-.218.104-.612.249-.684.394-.072.145-.363.145-.477.58-.104.425-.104.394-.176.539-.073.145-.249.322-.321.612-.072.289-.466 1.034-.393 1.76zM391.223 782.821c.021.197-.29-.383.394-.591.695-.207 1.171-.642 1.326-.943.156-.29.238-.497.311-.622.062-.135.207-.601.176-.808-.021-.207-.052-.984-.125-1.109 0 0-.342.176-.456.352-.125.186-.425.28-.56.425-.125.145-.176.445-.249.58-.073.124-.363.218-.435.446-.073.238-.166.736-.135.943.021.207-.145.466-.28.622-.133.145.023.528.033.705z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M391.214 782.532s.29-.695.518-.756c.228-.073.601-.663.622-.933.031-.311.072-.829.176-.963.103-.135.29-.58.145-.964-.155-.383-.394-.891-.394-.891s-.207.321-.321.518c-.186.373-.373.404-.404.549-.021.155-.249.249-.332.549-.114.404.01.384-.01.539-.031.145-.145.363-.124.643.01.278-.146 1.076.124 1.709zM390.655 778.19c-.031-.104-.249-.218-.508-.29-.249-.073-.643-.643-.819-.788-.166-.156-.259-.383-.477-.508-.218-.125-.352-.57-.425-1.005 0 0 .611.145.787.176.176.042.539.259.684.435.145.176.29.466.435.539.145.073.321.508.321.798.002.28.002.643.002.643z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M390.686 777.867s.041-.425.041-.611c0-.218.135-.798-.176-1.264-.218-.321-1.016-.933-1.223-.964 0 0-.145.57-.114.746.041.187.228.902.394.974.166.072.581.933 1.078 1.119z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M390.872 778.19c.093.155.031-.539.249-.715.217-.187.249-.435.249-.726 0-.29-.062-.497-.104-.684-.031-.176-.58-.932-.539-1.15 0 0-.311.705-.394.901-.114.249.073.508.031.715-.031.218-.207.612-.073.829.115.187.436.581.581.83zM388.966 774.481s-.042-.104-.363-.104-.788-.031-.933-.177a2.594 2.594 0 0 0-.539-.404c-.145-.062-.394-.393-.435-.539-.031-.145-.29-.425-.394-.425 0 0 .394-.042.829.073.424.104 1.036.321 1.181.612.147.28.654.964.654.964z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M388.852 774.406c-.083.249-.684-.249-.818-.424l-.363-.466s-.342-.414-.435-.58c-.218-.394-.166-1.109-.073-1.047.114.073.508.29.612.332.114.031.321.103.394.28.073.186.145.435.259.549.102.103.755.465.424 1.356z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F601A",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M389.069 774.406s-.497-.352-.684-.539c-.217-.207-.103-.497-.217-.643-.093-.135-.352-.466-.28-.684.072-.218.207-.829.207-.829s.259.249.435.435c.186.176.218.321.29.539.072.218.218.363.29.539.073.176 0 .539-.041.756-.031.219 0 .426 0 .426z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M381.121 797.079s2.373-.031 2.591-.321M379.752 797.37s1.544.425 2.373.321c.829-.103 1.223.073 1.41.073.176 0 1.078-.363 1.078-.363M378.169 797.941s1.192.218 1.44.29c.249.073 1.471.539 1.834.539.29 0 .995-.031 1.192 0 .352.073 1.295 0 1.513-.104M382.664 795.101s-.902.539-1.047.715c-.134.187-.932.829-1.078.829M382.664 793.981s-1.544 1.337-1.793 1.513c-.259.187-1.772 1.658-1.948 1.876M381.412 793.41s-1.223.974-1.368 1.368c-.145.394-.508.86-.508.86s-.508 1.005-.684 1.15c-.176.145-.539.528-.974.798M388.386 792.51s-1.285 1.088-1.637 1.295M388.923 793.193s-1.295.901-1.865 1.119c-.58.208-1.047.394-2.3.57M384.249 795.39s1.44-.073 1.689 0c.249.072 1.368-.187 1.658-.259.29-.062 1.44-.28 1.585-.321M386.447 790.53s.072.787-.042 1.119c-.104.321-.612 1.254-.57 1.471.031.218-.29 1.191-.58 1.368M384.966 790.676s.259.788.145 1.047c-.103.249-.28.715-.28 1.005 0 .29-.186.715-.259.901-.073.176.042.787-.145.964-.176.186-.394.508-.394.508M392.666 788.841s-1.15.435-1.296.715c-.135.29-.352.363-.466.508M388.427 787.764s-.29 1.15-.218 1.44c.073.28.073.86.073 1.078 0 .218.321 1.078.29 1.223M388.892 786.79s.104.684.145.974c.031.28 0 .756.073.932.073.176.176 1.15 0 1.585M392.052 787.764s-.933.787-1.15 1.005c-.217.218-1.181 1.254-1.223 1.513-.031.249-.715 1.036-.932 1.223M393.638 783.733s-.932.932-1.005 1.15c-.072.218-.466.57-.653.684M389.255 784.127s.352.539.352.715c0 .187.145.653.29.829.093.124.394.653.363.974M389.535 782.613s.145.508.218.86c.073.363.259.725.321.943.073.218.363 1.254.259 1.907M392.809 782.582s-.104.497-.352.756c-.259.249-.653.612-.684.819-.041.217-.363 1.295-.725 1.658-.363.363-.394.726-.394.726M393.172 778.916s-.104.611-.176.787c-.073.176-.363.974-.653 1.223M390.074 779.09s.187.497.218.715c.042.218.259.466.29.58.042.104.176.466.176.466M389.432 779.587c.031.218.435.87.466.974.042.114.249.611.466.756.218.145.86.611.829.798M392.241 778.19s.031.787-.114 1.078c-.145.29-.321.726-.394.943-.073.207-.073.57-.103.819-.042.259-.145.725-.29.901M388.529 775.744s.518.591.757.829c.238.238 1.15 1.223 1.192 1.399M389.389 775.204s.508 1.109.622 1.285c.104.187.207.477.207.477M390.686 775.164s-.031.87 0 1.088c.041.207.041.57 0 .684-.031.104.114.891.145 1.078M386.521 772.935s1.15.684 1.327.86"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.035,
    d: "m387.204 772.034.787 1.15.176.332"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M388.095 771.93s.259.611.29.86c.042.259.394 1.047.539 1.337"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M387.235 771.464s.114.249-.321.176"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M376.189 797.296s.176-.435.539-.042c0 0 .435 1.016.104 1.047-.321.042-.643.104-.674-.072-.042-.176.031-.933.031-.933z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M376.655 797.153s.114-1.544.321-1.617c.218-.073.87-.435 1.264-.114.394.331.031 1.927-.114 2.073-.135.145-.352.591-1.181.487l-.114-.393s.435-.042.725-.187.384-.28.363-.425c-.042-.218-.021-1.015-.238-1.088-.218-.073-.56-.176-.56-.176s-.321 1.202-.394 1.544l-.072-.104z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.158 798.23s-1.482.86-.725 2.156l-.508-.321s-.28.508-.031.798c0 0-1.005-.902-.217-1.979.798-1.088 1.44-1.016 1.44-1.016l.041.362z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.158 797.516s-.653-.435-1.586-.187c0 0-.415-1.337-.259-1.762.073-.197.218-.217.218-.217s-.466-.28-.321.974c.145 1.264.393 1.617.393 1.617s1.223.072 1.513-.073l.042-.352z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.158 797.516s-1.295-2.166-1.627-2.166c0 0-.373-.052.466-.145.29-.031.756 0 .974.404.217.394.393 1.326.466 1.471.001.001-.248.073-.279.436z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#011322",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.158 797.516s-.87-.404-.974-.508c-.114-.104-.29-1.326-.186-1.254 0 0-.352-.404-.466-.404-.073 0-.321.186-.249.611.072.435.176 1.088.29 1.368 0 0 .683-.279 1.585.187z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.946 798.23s.466.29.466.829c0 .539.218 1.513.653 1.73 0 0 .103-.404.249-.477 0 0 .435.508.57.508 0 0-.249-.466-.249-.684 0-.218-.218-1.047-.435-1.254-.207-.218-.643-.726-1.254-.902v.25z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#011322",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m377.123 795.713-.394 1.544.104.332s.145-.042.218-.218c.073-.186.29-1.513.404-1.555l-.332-.103z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#011D33",
    d: "M376.136 798.053s-.705.218-.974.767c0 0-.093-.352.953-.86l.021.093zM376.967 798.053s.487.197.612.487c0 0-.466-.311-.612-.363v-.124zM376.136 797.64s-1.098.176-1.337.125c0 0 .332.073 1.358-.021l-.021-.104zM377.92 796.976s.125.549.207.518c.093-.042.28-.922.29-1.337.021-.404-.176-.498-.342-.477-.156.01-.249.373-.228.539.011.156.053.664.073.757z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#011D33",
    d: "M376.729 797.256s.445.995.104 1.047c-.332.052.145.042-.083-.643-.093-.259-.238-.58-.311-.58-.001-.001.259.093.29.176z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.189 797.296s.176-.435.539-.042c0 0 .435 1.016.104 1.047-.321.042-.643.104-.674-.072-.042-.176.031-.933.031-.933z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.655 797.153s.114-1.544.321-1.617c.218-.073.87-.435 1.264-.114.394.331.031 1.927-.114 2.073-.135.145-.352.591-1.181.487l-.114-.393s.435-.042.725-.187.384-.28.363-.425c-.042-.218-.021-1.015-.238-1.088-.218-.073-.56-.176-.56-.176s-.321 1.202-.394 1.544l-.072-.104z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M375.059 770.967c-.093-.228-.114-1.762-.093-2 .031-.414.746-2.446.891-2.684.156-.238.114-.29.176-.435l.207-.28c.156.259.269.663.3.985 0 0-.135.974-.249 1.409-.104.435-.383 1.036-.435 1.161-.135.3-.124.58-.041.601l-.756 1.243z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m376.294 768.925.114.124c.321-.342.342-1.057.342-1.057l-.207-1.44s-.135.974-.249 1.409c-.104.435-.383 1.036-.435 1.161-.207.518-.052.58-.041.601l.476-.798z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M376.406 769.049c.321-.342.342-1.057.342-1.057s.228 1.171.104 1.42c-.124.249-.124.176-.104.301l-.342-.664z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.073,
    d: "M376.748 769.714c-.021-.125-.021-.052.104-.301s-.104-1.42-.104-1.42l-.207-1.44c-.031-.321-.145-.726-.3-.984l-.207.28c-.062.145-.021.197-.176.435-.145.238-.86 2.269-.891 2.684-.02.238 0 1.772.094 2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.294 765.763s-.021-.228-.042-.311c-.011-.042.124.207.238.176.207.062.435.342.497.415-.093.135-.311.394-.466.342-.135-.042-.104-.238-.145-.363-.02-.062-.092-.145-.082-.259z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.304 765.577c.01.01.072.083.083.093.052.031.104 0 .166.042.155.104.207.197.373.363"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.449 765.734c.197.093.301.249.435.414 0 0 .01-.021 0-.021"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.074 765.598s.207-.103.28-.145c.042-.021-.155.186-.083.28.01.218-.166.529-.228.612-.155-.042-.311-.042-.435-.28-.052-.083.093-.176.186-.259.052-.042.167-.176.28-.208z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.26 765.536c-.01.021-.062.093-.062.124-.01.052.031.093.021.166-.042.176-.114.259-.207.476"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.158 765.734c-.021.218-.125.362-.238.549 0-.01.031 0 .031 0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.397 765.453c.145-.176.404-.332.529-.228.01.01.114.072.145.135.062.073.052.104.021.187-.093.186-.342.093-.497.01-.031-.021-.124-.104-.176-.083-.083.031-.052.031-.083.031.031.021.062.01.083.021.145.041.249.124.425.207.125.052.352-.114.342-.228 0-.135-.217-.373-.321-.373-.238 0-.425.145-.591.332.04-.032.091.03.123-.011z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.26 765.453c-.135-.176-.394-.332-.518-.228-.01.01-.114.072-.145.135-.062.062-.062.104-.021.187.083.186.342.093.487.01.042-.021.135-.104.187-.083.083.031.052.031.083.031-.031.021-.062.01-.094.021-.135.041-.238.124-.425.207-.124.052-.342-.114-.342-.228.01-.145.228-.373.332-.373.238 0 .425.145.58.332-.03-.032-.082.03-.124-.011z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.313 765.35c-.062-.021-.135.041-.155.083-.021.052.021.135.083.145.083.031.197.01.218-.083.02-.083-.073-.104-.146-.145z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M376.304 763.91s.093.56.373.964c.28.404-.342.352-.383.497 0 0-.186-.404-.383-.508 0 0 .311-.487.394-.943v-.01h-.001z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.304 763.91s.093.56.373.964c0 0-.342.352-.383.497 0 0-.186-.404-.383-.508 0 0 .311-.487.394-.943"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.294 764.5s.072.249.155.415c0 0-.135.104-.155.166 0 0-.072-.166-.145-.207 0-.001.135-.219.145-.374z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M376.294 792.137c-.021 0-.052-.042-.083-.052-.093-.062-.269-.062-.311-.114-.249-.28-.083-.819.021-1.15.207-.622.238-1.192.373-1.782h.01c.135.591.166 1.161.363 1.782.114.332.28.87.031 1.15-.052.052-.218.052-.311.114-.031.011-.062.052-.093.052z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M376.294 789.018c.135.591.176 1.192.373 1.813.103.311.259.808.073 1.088v-.01c.093 0 .176-.031.259-.062.031-.01.062-.021.073-.052a.442.442 0 0 1 .114-.124c.062-.042.135-.01.197-.052.021-.021.031-.042.042-.042.124-.062.249-.135.3-.269a.587.587 0 0 0 .021-.301c-.01-.072-.042-.124-.062-.186l-.124-.28c-.042-.093-.104-.176-.145-.27a.582.582 0 0 0-.073-.135c-.021-.042-.052-.083-.073-.124-.021-.042-.073-.073-.104-.114-.042-.041-.052-.041-.083-.072-.01-.01-.062-.021-.052-.042-.021 0-.052-.021-.062-.031-.083-.176-.156-.269-.238-.446-.042-.073-.052-.207-.052-.29l-.384.001z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M376.294 789.018c-.124.591-.166 1.192-.373 1.813-.093.311-.249.808-.062 1.088l-.01-.01h.01c-.093 0-.176-.031-.269-.062-.021-.01-.052-.021-.073-.052a.324.324 0 0 0-.114-.124c-.052-.042-.124-.01-.186-.052-.021-.021-.031-.042-.052-.042-.124-.062-.238-.135-.29-.269a.587.587 0 0 1-.021-.301c.011-.072.041-.124.062-.186l.124-.28c.041-.093.093-.176.145-.27a.582.582 0 0 1 .073-.135c.021-.042.041-.083.073-.124.021-.042.073-.073.104-.114.042-.041.052-.041.083-.072.01-.01.062-.021.052-.042.021 0 .052-.021.052-.031.094-.176.166-.269.249-.446.042-.073.052-.207.052-.29l.371.001z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011322",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.117 789.04s-.238.974-.373 1.223c-.145.249-.705.705-.342 1.409"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.136 789.04s-.228.984-.373 1.233c-.145.259-.694.726-.321 1.43"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.167 789.04s-.238.995-.383 1.254c-.135.249-.684.736-.301 1.441"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.189 789.04s-.228 1.015-.373 1.264c-.145.249-.684.746-.3 1.471"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.22 789.04s-.238 1.026-.383 1.285c-.145.249-.673.756-.28 1.482"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.096 789.04s-.228.943-.383 1.212c-.145.259-.705.715-.332 1.409"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.065 789.049s-.218.901-.383 1.202c-.145.249-.705.705-.332 1.399"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.043 789.049s-.218.87-.394 1.192c-.135.249-.705.705-.332 1.409"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.012 789.049s-.197.849-.394 1.181c-.135.259-.694.705-.331 1.409"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.993 789.059s-.197.808-.394 1.171c-.145.249-.705.705-.332 1.399"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.241 789.04s-.228 1.047-.373 1.295c-.145.249-.663.777-.28 1.513"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011322",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.478 789.04s.238.974.373 1.223c.145.249.705.705.342 1.409"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.459 789.04s.228.984.373 1.233c.145.259.694.726.321 1.43"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.428 789.04s.238.995.383 1.254c.135.249.684.736.301 1.441"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.406 789.04s.228 1.015.373 1.264c.145.249.684.746.3 1.471"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.375 789.04s.238 1.026.383 1.285c.145.249.673.756.28 1.482"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.499 789.04s.228.943.383 1.212c.145.259.705.715.332 1.409"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.53 789.049s.218.901.383 1.202c.145.249.705.705.332 1.399"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.552 789.049s.218.87.394 1.192c.135.249.705.705.332 1.409"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.583 789.049s.197.849.394 1.181c.135.259.694.705.331 1.409"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.602 789.059s.197.808.394 1.171c.145.249.705.705.332 1.399"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.354 789.04s.228 1.047.373 1.295c.145.249.663.777.28 1.513"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.163 789.899c.031.042.083.073.104.114.021.042.052.083.073.125a.582.582 0 0 1 .073.135c.041.093.104.176.145.27l.124.28c.021.062.052.114.062.186a.576.576 0 0 1-.021.301c-.052.135-.176.207-.3.269-.01 0-.021.021-.042.041-.062.042-.135.01-.197.052a.44.44 0 0 0-.114.124c-.01.031-.041.042-.072.052-.083.031-.166.062-.259.062v.01-.01c-.01.021-.031.042-.042.062-.052.052-.218.052-.311.114-.031.01-.062.052-.093.052-.021 0-.052-.042-.083-.052-.093-.062-.269-.062-.311-.114-.021-.021-.031-.042-.041-.062v.01l-.01-.01h.01c-.093 0-.176-.031-.27-.062-.021-.01-.052-.021-.073-.052a.324.324 0 0 0-.114-.124c-.052-.042-.124-.01-.186-.052-.021-.021-.031-.041-.052-.041-.125-.062-.238-.135-.29-.269a.598.598 0 0 1-.021-.301c.01-.072.041-.124.062-.186l.124-.28c.042-.093.093-.176.145-.27a.582.582 0 0 1 .073-.135c.021-.042.041-.083.072-.125.021-.041.073-.073.104-.114"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M369.693 779.962c-.352-.881-.725-2.684-.705-3.099.072-1.699.052-2.207.207-3.948l1.751 2c-.042.674-.052.881 0 1.306.021.156.114.922.238 1.223l-1.491 2.518z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M371.183 777.442c-.124-.301-.218-1.067-.238-1.223-.052-.425-.041-.632 0-1.306l1.078 1.192-.84 1.337zM366.729 779.09a18.092 18.092 0 0 1-.062-1.026c.01-1.223-.135-1.907 0-3.202.104-1.015.352-2.352.3-3.451-.021-.311.041-.622.052-.922l2.176 2.425c-.155 1.741-.135 2.249-.207 3.948-.021.414.352 2.217.705 3.098l-.456.767-2.508-1.637zM368.253 782.376c-.145-.238-.269-.922-.301-1.057-.072-.363-.072-.57-.052-1.192l1.202.787-.849 1.462zM364.821 788.115c-.135-.083-.363-.321-.435-.529-.145-.414-.114-.404-.217-.86-.062-.259-.062-.549-.125-.819-.052-.269-.435-1.13-.445-1.482-.041-1.129-.415-1.896-.321-3.13.062-.953.28-2.249.176-3.244-.031-.269.01-.581.021-.85l2.446 1.596c-.093 1.637-.052 2.093-.052 3.678-.01.384.332 1.938.746 2.632l-1.794 3.008zM368.883 789.018c.456.414 1.295.632 1.43.725.301.218.746.539 1.503.58.56.042.808-.103 1.378-.176.653-.083-.083.021.549-.114.321-.083.321-.135.756-.238.321-.073.643-.156.839-.425.073-.104.135-.187.145-.352h.435c.041.124-.083.363-.124.446l-.114.155c-.062.135-.052.104-.166.207-.031.021-.166.135-.207.155-.083.062-.166.145-.259.156-.425.073-.601.166-1.005.28-.384.114-.176.093-.466.166-.145.031-.435.145-.58.166-.259.042-.301.083-.57.145-.694.155-1.368.114-2.052.073-.28-.021-.964-.166-1.202-.332-.425-.3-1.358-.414-1.772-.704-.062-.042-.321-.166-.373-.218-.404-.332-.725-.425-1.15-.694h3.005v-.001z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M372.169 789.018h3.316c-.01.166-.073.249-.145.352-.197.269-.518.352-.839.425-.342.083-.694-.104-1.057-.104-.87-.268-.974-.538-1.275-.673z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M372.169 789.018c.301.156.446.414 1.275.674.321 0 .674.145.974.135-.363.083-.373.135-.674.207-.632.135.104.031-.549.114-.57.073-.818.218-1.378.176-.756-.042-1.202-.363-1.503-.58-.135-.093-.974-.311-1.43-.725h3.285v-.001z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M367.132 771.877s.404 3.575 1.793 3.441"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.926 775.297c-.694.031-1.15-.85-1.409-1.679a11.141 11.141 0 0 1-.383-1.751"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.926 775.288c-.694-.021-1.15-.912-1.388-1.689-.28-.818-.404-1.73-.404-1.741"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.936 775.278c-.694-.062-1.161-.974-1.388-1.699-.269-.798-.404-1.71-.415-1.731"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.936 775.266c-.694-.114-1.161-1.047-1.378-1.71-.27-.777-.415-1.699-.425-1.73"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.945 775.247c-.705-.145-1.171-1.098-1.368-1.71-.269-.756-.435-1.689-.446-1.72"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.945 775.235c-.694-.197-1.171-1.161-1.358-1.72a10.987 10.987 0 0 1-.445-1.71"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.957 775.226c-.705-.238-1.181-1.223-1.357-1.741a11.652 11.652 0 0 1-.456-1.689"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.957 775.216c-.705-.29-1.181-1.285-1.337-1.751-.269-.674-.466-1.627-.477-1.689"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.957 775.195c-.694-.321-1.181-1.347-1.326-1.751-.269-.653-.477-1.617-.487-1.679"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.967 775.183c-.705-.363-1.192-1.409-1.326-1.762-.259-.632-.487-1.596-.497-1.668"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.967 775.173c-.705-.415-1.192-1.471-1.306-1.772-.269-.611-.508-1.586-.518-1.658"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.976 775.164c-.705-.456-1.202-1.534-1.306-1.793-.259-.57-.508-1.565-.529-1.648"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M367.142 771.713c.021.093.28 1.088.539 1.637.093.197.591 1.295 1.295 1.793"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M367.185 771.07s1.161 2.84 1.896 2.518"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.081 773.587c-.321.135-.798-.435-1.181-1.098-.415-.726-.715-1.43-.715-1.43"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.081 773.578c-.28.124-.777-.425-1.171-1.109-.425-.756-.725-1.419-.725-1.419"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.081 773.568c-.238.104-.756-.414-1.161-1.119-.446-.798-.726-1.409-.726-1.409"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.081 773.568c-.197.083-.746-.414-1.14-1.14-.466-.829-.746-1.399-.746-1.399"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.091 773.556c-.166.073-.736-.404-1.14-1.15a56.599 56.599 0 0 1-.746-1.399"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.091 773.556c-.124.052-.715-.404-1.13-1.171-.487-.902-.756-1.389-.756-1.389"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.091 773.547c-.083.042-.694-.394-1.119-1.181-.508-.943-.756-1.378-.756-1.378"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.091 773.547c-.041.01-.674-.394-1.109-1.192a23.028 23.028 0 0 0-.767-1.378"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M367.216 770.967s.249.342.777 1.368c.435.819 1.099 1.202 1.099 1.202M371.009 776.418l.9-.167M370.946 775.496l.974.528"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.925 775.536.996.487"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.925 775.577 1.005.456"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.925 775.629 1.005.416"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.935 775.67 1.005.385"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.935 775.713 1.017.341"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.935 775.754 1.027.31"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.935 775.794 1.036.282"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.935 775.847 1.049.239"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.935 775.89 1.058.205"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.997 776.374.924-.134"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.997 776.324.934-.105"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.987 776.272.953-.062"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.987 776.231.965-.031"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M370.978 776.179h.984"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.978 776.126.993.043"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.978 776.085 1.005.062"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.966 776.033 1.036.105"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.966 775.983 1.049.143"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m370.956 775.94 1.068.167M366.729 776.2s.052.756.217 1.078c.238.446.933 1.13 1.731 1.627"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.697 778.904a6.474 6.474 0 0 1-1.305-1.109 3.379 3.379 0 0 1-.415-.539c-.166-.332-.238-1.078-.238-1.078"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.718 778.904a6.515 6.515 0 0 1-1.295-1.129 2.266 2.266 0 0 1-.404-.549c-.186-.332-.28-1.067-.28-1.067"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.728 778.904c-.508-.342-.974-.808-1.275-1.14a2.948 2.948 0 0 1-.404-.56c-.197-.352-.311-1.067-.311-1.067"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.749 778.894c-.508-.342-.974-.818-1.275-1.15a3.26 3.26 0 0 1-.394-.56c-.207-.363-.342-1.067-.342-1.067"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.769 778.894c-.508-.342-.964-.85-1.264-1.171a3.052 3.052 0 0 1-.394-.56c-.218-.373-.363-1.067-.363-1.067"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.79 778.894c-.508-.352-.964-.881-1.254-1.192a3.579 3.579 0 0 1-.394-.56c-.228-.394-.394-1.067-.394-1.067"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.8 778.894c-.487-.363-.953-.912-1.233-1.212a3.283 3.283 0 0 1-.394-.56c-.238-.404-.425-1.068-.425-1.068"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.821 778.885c-.487-.352-.953-.922-1.223-1.223a3.517 3.517 0 0 1-.394-.56c-.249-.414-.456-1.067-.456-1.067"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.842 778.885c-.487-.363-.953-.953-1.212-1.243a3.263 3.263 0 0 1-.394-.56c-.259-.435-.477-1.068-.477-1.068"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.852 778.885c-.477-.363-.933-.984-1.192-1.264a4.012 4.012 0 0 1-.394-.56c-.259-.445-.508-1.067-.508-1.067"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.873 778.885c-.477-.373-.933-1.005-1.181-1.275a4.46 4.46 0 0 1-.394-.57 12.299 12.299 0 0 1-.539-1.067"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.895 778.873c-.477-.373-.933-1.026-1.171-1.285-.114-.124-.249-.342-.384-.57-.29-.477-.58-1.067-.58-1.067"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.76 775.93s.674 1.275.995 1.637c.228.249.684.933 1.161 1.306"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.779 779.09c.736.487.922.612 2.445 1.585l.466-.715s-.176-.425-.249-.622"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011E34",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.791 779.08c.705.477.943.632 2.435 1.565l.021-.021c0-.01.414-.694.414-.694s-.021-.083-.072-.186c-.052-.135-.114-.29-.145-.404"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022037",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.791 779.08c.684.456.984.653 2.435 1.544l.021-.031c0-.021.393-.694.393-.694s-.021-.072-.062-.176a4.278 4.278 0 0 1-.135-.383"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022139",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.791 779.08c.663.435 1.026.663 2.435 1.513l.021-.031c0-.021.373-.684.362-.684 0 0-.011-.073-.052-.166-.041-.124-.093-.269-.124-.373"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02223B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.791 779.071c.643.425 1.067.684 2.435 1.492l.021-.031c0-.031.342-.684.342-.684s0-.062-.042-.156a1.98 1.98 0 0 1-.114-.352"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.8 779.071c.611.404 1.098.705 2.424 1.461.01 0 .021-.031.021-.031 0-.042.321-.674.321-.684-.01 0 0-.052-.042-.145a2.144 2.144 0 0 1-.093-.332"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022540",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.8 779.059c.591.394 1.14.726 2.435 1.44 0 0 .01-.031.021-.031 0-.052.29-.674.28-.674 0 0 .01-.052-.021-.145a1.122 1.122 0 0 1-.083-.311"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022541",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.8 779.059c.57.383 1.181.736 2.435 1.409l.021-.031c0-.052.259-.663.259-.674 0 0 .021-.042-.021-.124a1.158 1.158 0 0 1-.073-.3"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.8 779.059c.549.363 1.223.756 2.435 1.388 0-.01.021-.041.021-.041 0-.062.238-.663.228-.674 0 0 .031-.031 0-.114a.946.946 0 0 1-.062-.28"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.81 779.049c.518.352 1.254.777 2.425 1.368 0-.01.021-.031.021-.041 0-.073.207-.663.207-.663s.031-.031 0-.114c-.042-.093-.042-.166-.042-.259"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.81 779.049c.497.332 1.285.798 2.425 1.337a.08.08 0 0 0 .021-.042c0-.083.187-.653.176-.663 0 0 .052-.031.021-.103-.042-.093-.031-.145-.031-.238"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032A4A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.81 779.049c.476.311 1.326.808 2.425 1.306.01-.01.021-.031.031-.042-.011-.083.155-.653.145-.653 0-.01.052-.031.021-.103-.031-.083-.021-.125-.021-.218"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.822 779.04c.445.301 1.357.829 2.415 1.285.01-.01.021-.031.031-.041 0-.093.124-.643.114-.653 0 0 .062-.021.041-.083-.041-.083-.021-.114-.01-.207"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.822 779.04c.425.28 1.399.85 2.415 1.254.01 0 .031-.031.031-.042 0-.103.104-.642.093-.653 0 0 .072-.01.041-.072-.031-.083 0-.093.01-.186"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.822 779.04c.404.259 1.44.86 2.425 1.233 0-.01.021-.041.021-.052 0-.104.083-.632.072-.643h-.01s.083-.01.062-.073c-.031-.072 0-.072.021-.166"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.822 779.028c.383.259 1.482.881 2.425 1.212a.11.11 0 0 0 .021-.052c0-.114.052-.632.041-.643l.062-.062c-.031-.062.011-.062.041-.145"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033156",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.831 779.028c.352.238 1.513.901 2.415 1.181a.115.115 0 0 0 .021-.052c0-.124.031-.632.02-.643 0 0 .094.01.073-.041-.031-.073.021-.052.041-.135"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.831 779.018c.332.228 1.554.922 2.415 1.161.01-.01.021-.042.031-.052a9.22 9.22 0 0 0-.021-.632s.104.01.083-.041c-.021-.062.031-.031.062-.114"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.831 779.018c.311.207 1.596.933 2.415 1.13.01-.01.021-.042.031-.052 0-.135-.031-.622-.041-.632 0 0 .104.021.093-.031-.031-.052.031-.01.072-.093"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.831 779.018c.29.186 1.627.953 2.415 1.098.01-.01.031-.031.031-.052 0-.145-.052-.612-.073-.632 0 0 .124.031.104-.021-.021-.052.052.01.093-.073"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.841 779.009c.259.176 1.658.974 2.404 1.088.01-.021.031-.041.031-.062 0-.155-.083-.611-.093-.622 0 0 .124.021.103-.01-.01-.052.062.021.104-.062"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.841 779.009c.238.155 1.699.995 2.404 1.057.021-.021.031-.041.031-.062a2.87 2.87 0 0 0-.124-.622s.135.031.124 0c-.021-.041.073.031.114-.041"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.841 779.009c.218.135 1.741 1.005 2.414 1.026l.031-.062a2.989 2.989 0 0 0-.155-.622s.145.042.124.01c-.01-.041.083.052.135-.021"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.853 778.997c.187.124 1.772 1.026 2.404 1.005.01-.01.02-.042.031-.062 0-.176-.166-.601-.176-.611h-.01s.156.041.145.01c-.01-.031.083.072.145 0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.853 778.997c.166.114 1.813 1.047 2.404.974.01-.01.031-.041.031-.062 0-.187-.186-.591-.207-.612 0 0 .156.052.145.031-.01-.031.104.083.166.01"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.853 778.997c.145.093 1.855 1.057 2.404.943.01-.01.031-.042.031-.062 0-.187-.207-.591-.228-.601v-.01s.166.062.155.042c-.01-.031.104.103.166.031"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.853 778.987c.125.083 1.896 1.078 2.404.933a.117.117 0 0 0 .031-.073c0-.197-.238-.58-.259-.601 0 0 .176.062.166.042-.01-.021.114.124.186.052"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.863 778.987c.093.062 1.927 1.099 2.394.901.02-.021.031-.052.041-.073-.01-.207-.269-.58-.29-.601 0 0 .176.073.176.052-.01-.01.124.145.197.073"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.863 778.987c.073.042 1.959 1.109 2.394.87.02-.021.031-.052.041-.073 0-.207-.3-.58-.321-.591 0 0 .197.073.186.062 0-.021.135.145.218.083"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.863 778.975c.052.031 2 1.129 2.394.85a.174.174 0 0 0 .041-.073c0-.217-.321-.57-.342-.591 0 0 .197.083.197.073-.011-.01.145.166.218.104"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064374",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.863 778.975c.031.01 2.042 1.15 2.404.818.01-.021.031-.042.031-.073 0-.228-.342-.57-.373-.591l.207.083s.155.187.238.125"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.874 778.966s2.321 1.306 2.425.725c0-.238-.394-.58-.394-.58l.218.083s.155.207.249.145"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m366.605 785.111-1.803 3.005c-.135-.083-.363-.321-.435-.529-.135-.414-.114-.414-.218-.86-.052-.259-.062-.549-.114-.819-.062-.269-.446-1.13-.456-1.482"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.352.394 1.192.456 1.461.052.27.062.56.114.819.103.446.083.435.228.85.062.207.3.446.425.528.01 0 1.793-2.974 1.803-2.974"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011E34",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.342.394 1.181.446 1.451.062.27.073.549.135.808.104.435.072.435.218.85.073.197.3.435.425.518.01 0 1.782-2.933 1.803-2.943"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011E34",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.342.383 1.171.446 1.44.062.259.073.539.135.798.104.435.072.425.218.839.073.197.3.425.425.508.021.01 1.782-2.891 1.803-2.901"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011F36",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.332.383 1.161.446 1.419.062.27.073.539.135.798.104.425.083.425.218.829.073.197.3.425.425.508.031.01 1.772-2.86 1.803-2.87"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011F36",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.332.383 1.15.446 1.409.062.259.073.539.135.787.104.425.083.415.228.819.072.197.29.425.425.508.021.01 1.751-2.829 1.793-2.839"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022037",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.332.373 1.129.446 1.389.062.259.073.539.135.787.104.415.083.415.228.808.072.197.29.425.425.508.031.01 1.751-2.798 1.793-2.808"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022037",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.321.373 1.119.446 1.378.062.259.073.529.135.777.104.414.093.414.228.798.072.197.29.425.425.497.041.021 1.741-2.746 1.793-2.767"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022139",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.321.373 1.109.446 1.368.062.249.073.518.135.767.104.404.093.404.238.798.072.187.29.404.414.487.041.01 1.741-2.715 1.793-2.736"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022139",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.311.373 1.098.446 1.347.062.259.073.518.135.767.104.404.093.404.238.787.072.187.29.404.414.487.052.01 1.731-2.684 1.793-2.704"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022139",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.311.363 1.088.446 1.337.062.249.073.508.145.756.104.404.083.394.228.777.072.187.29.404.414.487.062.01 1.72-2.653 1.793-2.673"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02223B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.311.363 1.067.446 1.326.062.238.073.508.145.736.104.404.093.404.228.777.072.186.29.404.414.477.062.021 1.72-2.611 1.793-2.632"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02223B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.301.363 1.057.446 1.306.062.249.073.508.145.736.104.404.093.404.238.767.072.187.28.394.404.477.072.021 1.71-2.57 1.793-2.601"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.301.363 1.047.446 1.295.062.238.073.497.145.725.104.394.093.394.238.767.072.176.28.383.415.466.072.021 1.689-2.539 1.782-2.57"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.29.352 1.036.446 1.285.062.238.073.487.145.715.104.394.104.394.238.756.072.176.29.383.415.466.072.021 1.689-2.508 1.782-2.539"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.29.352 1.026.446 1.264.062.238.083.487.145.715.104.384.104.384.238.746.083.176.29.383.415.456.083.031 1.679-2.466 1.782-2.497"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.428c.01.28.352 1.005.446 1.254.062.238.083.477.145.705.104.384.104.384.249.736.072.176.28.384.404.456.093.031 1.679-2.435 1.782-2.466"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022540",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.29.352 1.005.435 1.254.073.228.093.477.155.694.104.373.104.383.249.725.072.176.28.373.404.456.093.031 1.668-2.394 1.782-2.435"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022540",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.29.342.995.435 1.233.073.228.093.477.155.694.114.373.114.373.249.725.072.166.28.363.404.435.103.031 1.658-2.352 1.782-2.394"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022540",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.28.342.984.435 1.223.062.228.093.466.166.684.104.363.104.373.249.715.072.166.269.363.394.435.114.031 1.658-2.321 1.782-2.362"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022541",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.28.342.964.435 1.213.062.217.093.456.166.674.104.363.104.363.249.705.072.166.28.363.394.435.114.031 1.648-2.29 1.782-2.331"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022541",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.27.342.953.435 1.192.062.228.093.456.166.674.104.352.114.363.249.695.072.166.28.362.404.435.114.031 1.637-2.259 1.772-2.3"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.27.332.943.435 1.181.062.218.093.446.166.663.104.352.114.352.249.684.083.166.28.352.404.425.124.042 1.627-2.207 1.772-2.259"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.27.332.933.435 1.171.062.207.093.446.166.653.104.342.114.352.259.684.072.156.269.342.394.414.124.042 1.617-2.176 1.772-2.227"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022845",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.259.332.922.435 1.15.062.218.093.446.166.653.104.342.114.352.259.674.072.155.269.342.394.415.135.041 1.617-2.145 1.772-2.197"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022845",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.259.332.902.435 1.14.062.208.093.435.166.643.104.332.125.342.259.663.083.155.269.342.394.415.145.041 1.606-2.114 1.772-2.166"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.249.321.891.435 1.13.062.207.093.425.166.632.114.332.125.342.259.653.083.155.269.342.394.404.145.052 1.596-2.073 1.772-2.124"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.249.321.881.435 1.109.062.207.093.425.176.632.104.321.114.332.259.643.072.156.269.332.383.404.155.052 1.596-2.042 1.772-2.104"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.249.321.87.435 1.099.062.207.093.414.176.612.104.332.124.342.259.643.072.155.269.332.383.404.166.042 1.585-2 1.772-2.073"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.239.321.86.435 1.088.062.197.093.415.176.601.104.321.124.342.259.643.083.145.269.321.394.394.155.042 1.575-1.969 1.762-2.041"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.239.311.839.435 1.068.062.197.093.414.176.601.104.321.124.332.259.632.083.145.269.321.394.384.166.052 1.565-1.928 1.762-2"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032A4A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.228.311.829.435 1.057.062.197.103.404.176.591.104.311.124.332.269.622.073.145.259.321.384.383.176.052 1.554-1.896 1.762-1.969"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032A4A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 784.416c.01.228.311.819.425 1.047.073.187.114.394.186.58.104.311.135.321.269.612.083.145.259.311.384.383.176.052 1.554-1.865 1.762-1.938"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .228.29.808.415 1.026.073.197.114.394.186.581.104.301.135.321.269.601.083.145.269.311.383.373.187.062 1.544-1.813 1.762-1.896"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .218.29.798.415 1.016.073.186.114.383.186.57.114.301.135.321.28.601.073.135.259.301.373.363.197.062 1.534-1.783 1.762-1.865"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .218.29.777.415.995.073.186.114.394.186.57.114.3.135.311.28.591.073.135.259.301.373.362.197.062 1.534-1.751 1.762-1.834"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .208.29.767.415.984.073.187.114.384.197.56.104.29.135.311.27.581.083.135.259.3.373.363.207.062 1.523-1.72 1.762-1.803"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .208.28.756.415.974.073.176.114.373.197.549.104.29.135.301.27.57.083.135.259.29.383.352.207.072 1.513-1.679 1.751-1.762"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .208.28.746.415.953.073.186.114.373.197.549.104.28.135.301.28.56.073.135.249.29.373.352.207.062 1.503-1.638 1.751-1.731"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .197.28.736.415.943.073.176.114.363.197.539.104.28.145.29.28.56.083.124.249.28.373.342.217.062 1.492-1.606 1.751-1.699"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .197.28.715.415.933.073.176.114.352.197.529.104.27.145.29.28.55.083.124.259.28.373.342.228.062 1.492-1.575 1.751-1.668"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .187.269.705.415.912.073.176.114.363.197.529.104.27.145.29.28.539.083.125.259.28.373.332.228.073 1.482-1.534 1.751-1.627"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .187.269.695.415.902.073.166.114.352.197.518.104.259.145.28.29.529.083.124.249.269.363.332.238.073 1.482-1.503 1.751-1.596"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .176.269.684.415.891.073.166.114.342.197.508.114.259.155.28.29.518.083.125.249.269.363.332.249.073 1.471-1.461 1.751-1.565"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .176.269.674.415.87.073.166.114.342.197.508.114.249.155.269.29.518.083.114.249.259.373.321.238.073 1.451-1.43 1.741-1.534"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .176.259.653.415.86.073.166.114.332.207.497.104.249.145.269.28.508.083.114.249.259.373.311.249.083 1.451-1.388 1.741-1.492"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .166.259.643.415.85.062.156.124.321.207.477.104.249.155.28.29.508.083.114.249.249.363.311.259.083 1.44-1.357 1.741-1.461"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033156",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .166.259.633.404.829.073.156.135.332.218.477.103.249.155.269.29.497.083.114.249.249.363.311.259.083 1.43-1.326 1.741-1.43"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033156",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .156.259.622.404.819.073.156.135.321.218.466.103.238.155.269.29.487.083.114.249.249.363.311.269.073 1.43-1.285 1.741-1.399"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .156.249.612.404.808.073.145.135.311.218.456.103.238.155.259.3.487.083.114.238.238.352.29.28.083 1.42-1.244 1.741-1.357"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.416c0 .156.249.591.404.788.073.156.135.311.218.456.103.228.166.259.3.477.083.114.238.238.352.29.28.083 1.42-1.213 1.741-1.326"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .156.249.591.404.788.073.145.135.301.218.446.114.228.166.259.3.466.083.114.238.228.352.29.29.083 1.409-1.181 1.741-1.295"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .156.249.581.404.777.073.145.135.29.218.435.114.218.166.249.3.456.094.114.238.228.363.28.29.093 1.388-1.14 1.73-1.254"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .145.238.57.404.756.073.145.135.301.228.435.104.218.166.249.301.446.083.114.238.228.352.28.29.094 1.388-1.098 1.73-1.222"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .145.238.549.404.746.073.135.135.29.228.425.104.207.166.239.301.435.083.114.238.228.352.28.3.093 1.378-1.067 1.73-1.191"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .145.238.539.404.736.073.135.135.28.228.415.104.207.166.239.301.435.083.104.238.218.352.27.311.093 1.378-1.036 1.73-1.16"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .135.228.529.404.715.073.135.135.28.228.415.104.197.166.228.301.425.093.104.238.208.352.259.311.103 1.368-.995 1.73-1.119"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .135.228.518.404.705.073.135.135.269.228.404.104.197.176.228.311.415.083.104.228.207.342.259.321.104 1.358-.964 1.73-1.088"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .125.228.508.404.695.073.124.135.259.228.394.104.197.176.228.311.404.083.104.228.208.342.259.332.104 1.358-.933 1.73-1.057"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .125.228.487.404.674.073.124.135.269.228.394.114.187.176.218.311.394.093.104.238.207.342.259.332.093 1.347-.891 1.73-1.026"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .125.218.477.404.664.073.124.135.259.228.383.114.187.187.218.311.394.093.093.238.197.352.239.332.103 1.327-.85 1.72-.984"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .114.218.466.404.653.073.114.135.249.228.373.114.176.187.207.321.384.083.093.228.186.342.238.342.104 1.327-.818 1.72-.953"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .114.218.456.394.633.083.124.155.249.249.373.104.176.176.207.311.373.083.093.228.187.342.238.342.104 1.316-.787 1.72-.932"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .104.218.446.394.622.083.114.155.238.249.352.104.176.176.218.311.373.093.093.228.186.342.238.352.104 1.316-.756 1.72-.901"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .104.207.425.394.601.083.124.155.238.249.352.104.176.187.207.321.363a.894.894 0 0 0 .332.228c.363.114 1.306-.705 1.72-.86"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043963",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .104.207.415.394.591.083.114.155.238.249.342.104.166.187.207.321.363.083.083.218.176.332.217.363.114 1.295-.674 1.72-.829"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043963",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .094.207.404.394.581.083.104.155.228.249.332.104.166.187.197.321.352.093.083.228.166.332.218.373.114 1.295-.643 1.72-.798"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .094.207.394.394.56.083.114.155.228.249.331.114.155.197.197.321.342.093.083.228.166.332.218.383.114 1.285-.612 1.72-.767"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .083.197.384.394.549.083.104.155.218.249.321.114.156.197.197.332.332.083.083.218.166.332.208.383.124 1.264-.57 1.71-.726"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .083.197.363.394.539.083.104.155.207.249.311.114.145.197.187.332.321a1.1 1.1 0 0 0 .332.207c.383.114 1.264-.529 1.71-.694"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .083.197.353.394.518.083.104.155.207.259.311.104.145.187.187.321.321.093.073.217.156.332.197.394.114 1.254-.498 1.71-.663"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .073.197.342.394.508.083.093.155.207.259.301.104.135.197.176.321.311.093.073.217.145.332.187.404.125 1.254-.456 1.71-.622"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .073.186.332.394.498.083.093.155.197.259.29.104.135.197.176.332.301.083.072.218.145.321.187.404.124 1.243-.425 1.71-.591"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .062.186.322.394.477.073.093.155.197.259.29.104.124.197.166.332.29.093.072.218.145.321.186.414.125 1.233-.394 1.71-.56"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .062.186.301.394.466.073.094.155.187.259.28.104.124.208.166.332.28.093.073.218.145.321.187.425.124 1.233-.352 1.71-.529"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .052.186.29.394.456.073.083.155.176.259.269.114.114.208.166.332.27.093.073.218.145.321.176.425.135 1.223-.311 1.71-.487"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .052.176.28.394.435.073.093.155.176.259.27.114.114.208.155.342.269.093.062.207.124.321.166.425.135 1.212-.28 1.699-.456"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .052.176.27.383.425.083.083.176.166.269.259.114.104.208.155.342.259.093.062.207.124.321.166.435.135 1.202-.249 1.699-.425"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .042.176.259.383.415.083.073.176.166.269.249.114.104.218.145.342.249.093.062.207.124.321.166.435.135 1.192-.218 1.699-.394"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .042.176.239.383.394.083.083.176.166.28.249.104.093.207.145.342.238.083.062.207.125.311.155.446.135 1.192-.166 1.699-.352"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .031.166.228.383.384.083.073.176.156.28.228.104.103.207.155.342.238.093.062.207.114.311.156.456.135 1.181-.135 1.699-.321"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .031.166.218.383.373.083.073.176.145.28.218.104.093.207.145.342.238.093.052.207.104.311.145.456.135 1.171-.104 1.699-.29"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .031.166.208.383.353.083.072.176.145.28.218.104.093.217.145.342.228.093.052.207.104.311.145.466.135 1.171-.073 1.699-.259"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .021.155.187.383.342.083.062.176.135.28.207.114.093.217.135.352.218.093.052.197.104.3.135.476.145 1.161-.031 1.699-.218"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .021.155.176.383.332.083.062.176.135.28.197.114.083.217.135.352.207.093.052.197.104.311.135.466.145 1.15 0 1.689-.186"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.406c0 .01.155.166.383.311.083.062.176.135.28.197.114.083.228.135.352.197.093.052.207.093.311.135.477.145 1.14.042 1.689-.155"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.397c0 .021.155.166.383.311.083.062.176.124.28.187.114.073.228.124.352.197l.311.124c.487.145 1.13.073 1.689-.124"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064374",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.397c0 .021.145.156.383.301.083.052.176.114.28.176.114.073.228.124.363.187.093.042.197.083.3.114.487.156 1.13.114 1.689-.083"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064374",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.397c0 .01.145.135.383.28.083.062.176.114.29.176.104.062.218.114.352.176.093.042.197.083.301.114.497.156 1.119.145 1.689-.052"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.397c0 .01.145.125.383.27.083.052.176.104.29.166.104.062.228.114.352.166.093.042.197.083.301.114a2.85 2.85 0 0 0 1.689-.021"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.588 784.397s1.544 1.213 3.016.695"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.526 779.63s.3 1.938.414 2.218c.104.249.715 1.358 1.648 1.617"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.526 779.63s.321 1.917.446 2.197c.104.249.674 1.305 1.627 1.627"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.536 779.62s.332 1.907.456 2.197c.104.249.643 1.243 1.606 1.637"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.536 779.62s.352 1.896.477 2.176c.114.249.601 1.191 1.585 1.648"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.548 779.62s.363 1.875.487 2.156c.124.259.57 1.14 1.575 1.658"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.548 779.62s.383 1.865.518 2.145c.114.259.529 1.067 1.544 1.668"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.548 779.608s.404 1.855.539 2.135c.124.259.487 1.016 1.523 1.679"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.557 779.608s.414 1.845.549 2.124c.124.259.456.953 1.502 1.689"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.557 779.608s.435 1.824.57 2.104c.135.259.425.901 1.492 1.699"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.567 779.599s.445 1.824.591 2.093c.135.269.373.84 1.461 1.72"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.567 779.599s.477 1.803.611 2.083c.135.259.342.777 1.44 1.72"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 779.599s.487 1.793.622 2.062c.145.269.311.725 1.43 1.73"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.579 779.587s.508 1.782.643 2.052c.145.269.28.674 1.409 1.751"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.65 778.438s.249 2.736 2.197 3.492"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.65 778.438c.01.01.114.881.508 1.73.311.653.829 1.399 1.689 1.751"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.66 778.438c0 .01.124.901.518 1.72.29.601.808 1.378 1.668 1.762"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.66 778.438c.01.021.155.932.539 1.699.28.56.788 1.368 1.648 1.772"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.672 778.438c0 .021.176.953.56 1.689.249.518.756 1.347 1.617 1.772"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.672 778.438c.01.031.207.974.58 1.668.228.477.746 1.337 1.596 1.793"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.681 778.438c0 .031.228.995.591 1.658.218.425.725 1.316 1.575 1.793"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.681 778.429c.01.052.259 1.036.612 1.658.197.373.705 1.295 1.554 1.792"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.681 778.429c.021.052.29 1.057.632 1.637.186.342.684 1.285 1.534 1.803"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.693 778.429c.01.062.311 1.078.642 1.627.166.29.663 1.264 1.513 1.813"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.693 778.429c.02.062.342 1.099.674 1.606.145.249.632 1.254 1.482 1.823"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.703 778.429c.011.073.363 1.13.684 1.596.124.197.612 1.233 1.461 1.824"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.703 778.429c.021.073.394 1.15.705 1.575.114.155.591 1.223 1.44 1.844"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.672 777.681s.57 2.197 2.156 2.736"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.672 777.681s.218.777.736 1.534c.342.508.839 1.005 1.42 1.202"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032A4A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.672 777.671s.228.767.746 1.523c.363.518.87 1.036 1.409 1.223"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.672 777.662s.238.756.767 1.513c.373.529.891 1.067 1.388 1.233"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.681 777.65s.238.746.777 1.513c.383.529.922 1.088 1.368 1.244"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033156",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.681 777.65s.249.726.798 1.492c.394.539.943 1.119 1.358 1.254"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.681 777.64s.259.726.808 1.482c.414.56.984 1.15 1.347 1.275"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.681 777.628s.269.715.829 1.471c.425.57 1.005 1.181 1.326 1.295"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.693 777.628s.259.694.839 1.461c.435.57 1.036 1.202 1.306 1.295"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043963",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.693 777.619s.269.684.86 1.451c.445.58 1.057 1.244 1.285 1.316"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.693 777.609s.28.674.87 1.44c.456.591 1.098 1.275 1.275 1.337"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.693 777.597s.29.663.891 1.44c.466.601 1.119 1.295 1.254 1.337"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.703 777.597s.29.643.902 1.42c.477.611 1.15 1.326 1.233 1.358"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.703 777.588s.301.632.922 1.409c.487.622 1.171 1.358 1.223 1.378"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M363.703 777.578s.311.622.933 1.399a30.554 30.554 0 0 0 1.213 1.389M367.909 780.676l1.089.198M368.023 781.505l.974-.413"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.899 780.707 1.089.167"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.899 780.748 1.099.136"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.909 780.791 1.099.093"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.909 780.831 1.111.062"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.909 780.874 1.12.019"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.92 780.915 1.118-.009"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.92 780.946 1.13-.041"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.92 780.986 1.139-.072"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.93 781.029 1.139-.115"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m368.014 781.455.994-.385"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m368.002 781.411 1.018-.363"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m368.002 781.371 1.027-.332"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.992 781.328 1.046-.31"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.983 781.287 1.068-.279"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.983 781.247 1.077-.26"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.971 781.194 1.099-.217"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.961 781.153 1.12-.198"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.961 781.11 1.13-.165"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m367.952 781.07 1.149-.146"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.945 789.04s-.58.031-.632.052c-.062.01-2.363-.042-2.363-.042"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.957 789.049s-.57.052-.653.073c-.093.01-2.331-.062-2.331-.062"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.957 789.059s-.549.072-.663.093c-.125.021-2.3-.083-2.3-.083"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.967 789.071s-.539.083-.684.114c-.155.031-2.28-.104-2.28-.104"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.967 789.071s-.518.114-.705.145c-.176.041-2.238-.124-2.238-.124"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.967 789.08s-.498.124-.715.166c-.207.052-2.207-.145-2.207-.145"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.976 789.09s-.487.145-.736.197c-.238.042-2.176-.176-2.176-.176"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.976 789.102s-.477.166-.746.218c-.269.052-2.156-.187-2.156-.187"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.988 789.111s-.466.176-.767.238c-.3.062-2.124-.208-2.124-.208"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.988 789.121s-.446.197-.777.259c-.332.073-2.093-.228-2.093-.228"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.136 789.164s1.699.321 2.062.249c.363-.073.798-.28.798-.28"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.38 790.353s1.088.166 1.13.156c.021 0 .632-.042.653-.042.01 0 .529-.125.529-.125"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.318 790.334s1.119.176 1.202.156c.041-.01.601-.042.632-.042.031 0 .497-.114.497-.114"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.255 790.303s1.15.197 1.264.166c.062-.01.57-.042.622-.042.042 0 .456-.104.456-.104"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.193 790.272s1.171.207 1.337.176c.083-.01.539-.042.601-.042l.415-.083"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.131 790.251s1.202.217 1.399.176c.104-.021.518-.042.591-.052.073 0 .373-.062.373-.062"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.069 790.22s1.233.238 1.471.186c.124-.021.477-.042.57-.052.083 0 .332-.052.332-.052"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M369.007 790.188s1.254.259 1.533.207c.155-.031.456-.052.56-.062.104-.01.29-.042.29-.042"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.945 790.167s1.285.269 1.606.207c.166-.042.415-.062.539-.062l.259-.021"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.047,
    d: "m369.443 790.386 1.057.146.673-.032.57-.146"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M368.883 790.136s1.316.29 1.679.218c.352-.073.736-.073.736-.073M374.085 790.291l1.026-.373c.643-.239.715-.881.715-.881"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.013 790.086s.414-.166.756-.29c.912-.342.808-.777.808-.777"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M373.951 790.126s.539-.207.819-.311c.145-.052.332-.135.425-.197.124-.073.28-.217.321-.29.083-.124.083-.3.083-.3"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M373.889 790.179s.674-.259.881-.332c.104-.041.352-.145.414-.187.093-.062.311-.238.342-.29.062-.104.103-.342.103-.342"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M373.827 790.22s.808-.301.943-.353c.073-.021.363-.145.404-.166.062-.042.342-.269.363-.3.042-.062.114-.373.114-.373"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M373.765 790.272s.932-.352 1.005-.373c.031-.021.383-.145.404-.166.031-.01.363-.28.373-.301.021-.031.135-.394.135-.394"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m374.013 790.303 1.109-.415c.197-.072.404-.249.497-.373.135-.197.187-.477.187-.477"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M373.93 790.303s.995-.363 1.202-.446c.145-.052.404-.259.466-.352.104-.145.176-.466.176-.466"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M373.858 790.313s1.15-.435 1.285-.477c.104-.041.404-.28.446-.342.073-.104.166-.456.166-.456"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M373.784 790.313s1.295-.487 1.368-.508c.052-.021.394-.29.425-.321.031-.052.155-.446.155-.446"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m373.702 790.312 1.461-.538.394-.299.145-.437"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.401 789.04s-.601.031-.663.052c-.062.01-2.456-.042-2.456-.042"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.413 789.049s-.591.052-.684.073c-.093.01-2.425-.062-2.425-.062"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.413 789.059s-.57.072-.694.093c-.125.021-2.394-.083-2.394-.083"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.413 789.071s-.549.083-.705.114c-.156.031-2.363-.104-2.363-.104"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.422 789.071s-.539.114-.725.145c-.187.041-2.332-.124-2.332-.124"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.422 789.08s-.518.124-.736.166c-.217.052-2.311-.145-2.311-.145"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.432 789.09s-.508.145-.756.197c-.259.042-2.28-.176-2.28-.176"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.432 789.102s-.487.166-.777.218c-.28.052-2.238-.187-2.238-.187"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.444 789.111s-.487.176-.798.238c-.311.062-2.207-.208-2.207-.208"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.444 789.121s-.466.197-.808.259c-.342.073-2.176-.228-2.176-.228"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M372.468 789.164s1.782.321 2.156.249c.373-.073.829-.28.829-.28"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M366.729 779.09a8.183 8.183 0 0 1-.042-.767c.01-1.233-.155-2.166-.021-3.461.104-1.016.352-2.352.3-3.451-.021-.311.041-.622.052-.922l5.005 5.617M364.821 788.115c-.135-.083-.363-.321-.435-.529-.145-.414-.114-.404-.217-.86-.062-.259-.062-.549-.125-.819-.052-.269-.435-1.13-.445-1.482-.041-1.129-.415-1.896-.321-3.13.062-.953.28-2.249.176-3.244-.031-.269.01-.581.021-.85l5.627 3.72M375.919 789.018c.042.124-.083.363-.124.446l-.114.155c-.062.135-.052.104-.166.207-.031.021-.166.135-.207.155-.083.062-.166.145-.259.156-.425.073-.601.166-1.005.28-.383.114-.176.093-.466.166-.145.031-.435.145-.58.166-.259.042-.3.083-.57.145-.695.155-1.368.114-2.052.073-.28-.021-.964-.166-1.202-.332-.425-.3-1.358-.414-1.772-.704-.062-.042-.321-.166-.373-.218-.404-.332-.726-.425-1.15-.694"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.035,
    d: "m369.236 780.728-5.71-3.731-.103.156 5.678 3.772z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M363.433 776.936c-.041-.218.021-.508.176-.539.01 0 .124-.041.197-.021.093 0 .114.031.155.103.083.197-.155.321-.321.384-.042.01-.155.031-.176.083-.031.083-.01.052-.031.083.031-.01.042-.042.073-.062.124-.072.249-.093.425-.176.135-.062.156-.332.062-.414-.103-.083-.425-.073-.497.01-.155.176-.166.415-.135.653-.001-.052.082-.042.072-.104z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M363.34 777.038c-.218-.01-.497.083-.508.238 0 .021-.021.145 0 .207.011.093.041.114.124.135.207.062.3-.186.332-.363.01-.042.01-.155.062-.187.083-.041.062-.021.083-.041-.01.031-.042.052-.052.073-.052.135-.062.269-.124.456-.041.135-.311.187-.394.104-.104-.083-.135-.404-.062-.487.156-.176.394-.218.632-.218-.041.011-.031.094-.093.083z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M363.299 776.945c-.062.031-.062.114-.031.166.021.052.114.062.155.041.083-.052.135-.145.083-.228-.051-.072-.134-.01-.207.021z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M362.095 776.188s.601.238 1.088.249c0 0 .021.425.124.549 0 0-.435-.083-.632.021 0 0-.258-.591-.58-.819z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M362.583 776.489s.238.104.435.104c0 0 .01.166.052.218 0 0-.176-.031-.249.011 0-.001-.104-.24-.238-.333z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M363.34 777.411s.114-.197.145-.269c.021-.041-.01.238.093.269.135.176.166.539.166.632-.155.052-.29.145-.529.031-.083-.052-.021-.207.01-.332.021-.062.042-.238.115-.331z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M363.454 777.256c0 .031.021.155.01.135 0-.052.062.052.072.073.083.155.114.269.145.57M363.505 777.516c.052.238.093.228.093.56l.021-.021M363.495 777.734c.041.166.031.249.041.332-.01 0-.062.041-.072.041"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.035,
    d: "m372.179 775.961-5.099-5.668-.103.124 5.046 5.689z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M367.123 770.294c.01-.228.135-.497.29-.487.01 0 .135-.01.197.021.093.021.104.062.124.145.041.207-.218.269-.394.29-.042 0-.166-.01-.197.042-.052.073-.021.052-.052.073.031 0 .062-.031.083-.042.145-.041.269-.041.466-.072.135-.021.218-.29.145-.383-.073-.104-.383-.176-.477-.114-.197.135-.259.363-.28.611.012-.053.085-.033.095-.084z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M367.008 770.365c-.218-.062-.508-.031-.56.114 0 .01-.052.135-.041.197-.01.093.01.124.093.166.176.104.332-.114.404-.28.021-.042.052-.145.104-.166.083-.021.062 0 .083-.021-.01.031-.041.041-.062.062-.083.124-.125.238-.228.414-.073.114-.342.114-.414.01-.072-.114-.021-.425.062-.487.187-.145.435-.135.663-.062-.042-.008-.052.074-.104.053z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M366.987 770.263c-.073.01-.083.104-.073.155.01.052.093.093.145.073.083-.031.166-.103.135-.197-.031-.083-.135-.041-.207-.031z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M366.003 769.245s.518.373.984.497c0 0-.073.425 0 .56 0 0-.415-.176-.622-.124 0 0-.103-.632-.362-.933z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M366.397 769.661s.207.145.394.197c0 0-.031.166 0 .218 0 0-.166-.062-.249-.042 0 0-.041-.259-.145-.373z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M366.915 770.729s.155-.166.207-.228c.031-.042-.073.228.021.29.093.197.031.549.01.653-.166.01-.311.062-.508-.104-.073-.062.021-.197.083-.311.031-.062.094-.228.187-.3z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M367.061 770.614c0 .021-.01.104-.01.124.01.062.062.083.072.156.031.176-.01.29-.021.518M367.039 770.822c.052.218.01.394-.021.601-.01 0 .021 0 .021-.01M367.008 771.185c-.031.083-.031.135-.041.228-.01-.01-.052.031-.062.021"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M382.903 779.962c.352-.881.725-2.684.705-3.099-.072-1.699-.052-2.207-.207-3.948l-1.751 2c.042.674.052.881 0 1.306-.021.156-.114.922-.238 1.223l1.491 2.518z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M381.412 777.442c.124-.301.218-1.067.238-1.223.052-.425.041-.632 0-1.306l-1.078 1.192.84 1.337zM385.866 779.09c.031-.394.062-.829.062-1.026-.01-1.223.135-1.907 0-3.202-.104-1.015-.352-2.352-.3-3.451.021-.311-.041-.622-.052-.922l-2.176 2.425c.155 1.741.135 2.249.207 3.948.021.414-.352 2.217-.705 3.098l.456.767 2.508-1.637zM384.343 782.376c.145-.238.269-.922.301-1.057.072-.363.072-.57.052-1.192l-1.202.787.849 1.462zM387.775 788.115c.135-.083.363-.321.435-.529.145-.414.114-.404.217-.86.062-.259.062-.549.125-.819.052-.269.435-1.13.445-1.482.041-1.129.415-1.896.321-3.13-.062-.953-.28-2.249-.176-3.244.031-.269-.01-.581-.021-.85l-2.446 1.596c.093 1.637.052 2.093.052 3.678.01.384-.332 1.938-.746 2.632l1.794 3.008zM383.712 789.018c-.456.414-1.295.632-1.43.725-.301.218-.746.539-1.503.58-.56.042-.808-.103-1.378-.176-.653-.083.083.021-.549-.114-.321-.083-.321-.135-.756-.238-.321-.073-.643-.156-.839-.425-.073-.104-.135-.187-.145-.352h-.435c-.041.124.083.363.124.446l.114.155c.062.135.052.104.166.207.031.021.166.135.207.155.083.062.166.145.259.156.425.073.601.166 1.005.28.384.114.176.093.466.166.145.031.435.145.58.166.259.042.301.083.57.145.694.155 1.368.114 2.052.073.28-.021.964-.166 1.202-.332.425-.3 1.358-.414 1.772-.704.062-.042.321-.166.373-.218.404-.332.725-.425 1.15-.694h-3.005v-.001z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209F",
    d: "M380.426 789.018h-3.316c.01.166.073.249.145.352.197.269.518.352.839.425.342.083.694-.104 1.057-.104.871-.268.974-.538 1.275-.673z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M380.426 789.018c-.301.156-.446.414-1.275.674-.321 0-.674.145-.974.135.363.083.373.135.674.207.632.135-.103.031.549.114.57.073.818.218 1.378.176.756-.042 1.202-.363 1.503-.58.135-.093.974-.311 1.43-.725h-3.285v-.001z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.463 771.877s-.404 3.575-1.793 3.441"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.669 775.297c.694.031 1.15-.85 1.409-1.679.269-.85.383-1.741.383-1.751"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.669 775.288c.694-.021 1.15-.912 1.388-1.689.28-.818.404-1.73.404-1.741"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.66 775.278c.694-.062 1.161-.974 1.388-1.699.269-.798.404-1.71.415-1.731"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.66 775.266c.694-.114 1.161-1.047 1.378-1.71.27-.777.415-1.699.425-1.73"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.65 775.247c.705-.145 1.171-1.098 1.368-1.71.269-.756.435-1.689.446-1.72"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.65 775.235c.694-.197 1.171-1.161 1.358-1.72.269-.736.445-1.668.445-1.71"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.638 775.226c.705-.238 1.181-1.223 1.357-1.741.259-.694.456-1.648.456-1.689"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.638 775.216c.705-.29 1.181-1.285 1.337-1.751.269-.674.466-1.627.477-1.689"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.638 775.195c.694-.321 1.181-1.347 1.326-1.751.269-.653.476-1.617.487-1.679"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.629 775.183c.705-.363 1.192-1.409 1.326-1.762.259-.632.487-1.596.497-1.668"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.629 775.173c.705-.415 1.192-1.471 1.306-1.772.269-.611.508-1.586.518-1.658"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.619 775.164c.705-.456 1.202-1.534 1.306-1.793.259-.57.508-1.565.529-1.648"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.453 771.713c-.021.093-.28 1.088-.539 1.637-.093.197-.591 1.295-1.295 1.793"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.41 771.07s-1.161 2.84-1.896 2.518"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.514 773.587c.321.135.798-.435 1.181-1.098.415-.726.715-1.43.715-1.43"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.514 773.578c.28.124.777-.425 1.171-1.109.425-.756.725-1.419.725-1.419"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.514 773.568c.238.104.756-.414 1.161-1.119.446-.798.726-1.409.726-1.409"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.514 773.568c.197.083.746-.414 1.14-1.14.466-.829.746-1.399.746-1.399"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.504 773.556c.166.073.736-.404 1.14-1.15.477-.87.746-1.399.746-1.399"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.504 773.556c.124.052.715-.404 1.13-1.171.487-.902.756-1.389.756-1.389"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.504 773.547c.083.042.694-.394 1.119-1.181.508-.943.756-1.378.756-1.378"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.504 773.547c.041.01.674-.394 1.109-1.192.518-.984.767-1.378.767-1.378"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.379 770.967s-.249.342-.777 1.368c-.435.819-1.099 1.202-1.099 1.202M381.586 776.418l-.9-.167M381.649 775.496l-.974.528"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.67 775.536-.996.487"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.67 775.577-1.005.456"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.67 775.629-1.005.416"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.661 775.67-1.005.385"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.661 775.713-1.017.341"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.661 775.754-1.027.31"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.661 775.794-1.036.282"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.661 775.847-1.048.239"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.661 775.89-1.058.205"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.599 776.374-.924-.134"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.599 776.324-.934-.105"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.608 776.272-.953-.062"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.608 776.231-.965-.031"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M381.617 776.179h-.984"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.617 776.126-.993.043"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.617 776.085-1.005.062"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.63 776.033-1.036.105"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.63 775.983-1.049.143"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m381.639 775.94-1.068.167M385.866 776.2s-.052.756-.218 1.078c-.238.446-.933 1.13-1.731 1.627"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.898 778.904a6.474 6.474 0 0 0 1.305-1.109c.176-.187.321-.384.415-.539.166-.332.238-1.078.238-1.078"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.877 778.904a6.515 6.515 0 0 0 1.295-1.129c.176-.187.321-.373.404-.549.186-.332.28-1.067.28-1.067"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.867 778.904c.508-.342.974-.808 1.275-1.14.166-.186.311-.383.404-.56.197-.352.311-1.067.311-1.067"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.846 778.894c.508-.342.974-.818 1.275-1.15a3.26 3.26 0 0 0 .394-.56c.207-.363.342-1.067.342-1.067"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.827 778.894c.508-.342.964-.85 1.264-1.171.145-.166.29-.363.394-.56.218-.373.363-1.067.363-1.067"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.805 778.894c.508-.352.964-.881 1.254-1.192.145-.166.28-.362.394-.56.228-.394.394-1.067.394-1.067"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.796 778.894c.487-.363.953-.912 1.233-1.212.135-.155.28-.352.394-.56.238-.404.425-1.068.425-1.068"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.774 778.885c.487-.352.953-.922 1.223-1.223.135-.145.269-.352.394-.56.249-.414.456-1.067.456-1.067"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.753 778.885c.487-.363.953-.953 1.213-1.243a3.32 3.32 0 0 0 .394-.56c.259-.435.477-1.068.477-1.068"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.743 778.885c.477-.363.933-.984 1.192-1.264.124-.135.259-.342.394-.56.259-.445.508-1.067.508-1.067"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.722 778.885c.477-.373.933-1.005 1.181-1.275a4.46 4.46 0 0 0 .394-.57c.269-.456.539-1.067.539-1.067"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.7 778.873c.477-.373.933-1.026 1.171-1.285.114-.124.249-.342.384-.57.29-.477.58-1.067.58-1.067"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.835 775.93s-.674 1.275-.995 1.637c-.228.249-.684.933-1.161 1.306"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.816 779.09c-.736.487-.922.612-2.445 1.585l-.466-.715s.176-.425.249-.622"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011E34",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.804 779.08c-.705.477-.943.632-2.435 1.565l-.021-.021c0-.01-.414-.694-.414-.694s.021-.083.072-.186c.052-.135.114-.29.145-.404"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022037",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.804 779.08c-.684.456-.984.653-2.435 1.544l-.021-.031c0-.021-.393-.694-.393-.694s.021-.072.062-.176c.052-.124.104-.28.135-.383"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022139",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.804 779.08c-.663.435-1.026.663-2.435 1.513l-.021-.031c0-.021-.373-.684-.362-.684 0 0 .01-.073.052-.166.042-.124.093-.269.124-.373"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02223B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.804 779.071c-.643.425-1.067.684-2.435 1.492l-.021-.031c0-.031-.342-.684-.342-.684s0-.062.042-.156a1.98 1.98 0 0 0 .114-.352"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.795 779.071c-.611.404-1.098.705-2.424 1.461-.01 0-.021-.031-.021-.031 0-.042-.321-.674-.321-.684.01 0 0-.052.042-.145.042-.114.073-.228.093-.332"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022540",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.795 779.059c-.591.394-1.14.726-2.435 1.44 0 0-.01-.031-.021-.031 0-.052-.29-.674-.28-.674 0 0-.01-.052.021-.145.042-.104.073-.207.083-.311"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022541",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.795 779.059c-.57.383-1.181.736-2.435 1.409l-.021-.031c0-.052-.259-.663-.259-.674 0 0-.021-.042.021-.124.042-.114.062-.197.073-.3"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.795 779.059c-.549.363-1.223.756-2.435 1.388a.153.153 0 0 0-.021-.041c0-.062-.238-.663-.228-.674 0 0-.031-.031 0-.114a.946.946 0 0 0 .062-.28"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.785 779.049c-.518.352-1.254.777-2.425 1.368 0-.01-.021-.031-.021-.041 0-.073-.207-.663-.207-.663s-.031-.031 0-.114c.042-.093.042-.166.042-.259"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.785 779.049c-.497.332-1.285.798-2.425 1.337a.08.08 0 0 1-.021-.042c0-.083-.187-.653-.176-.663 0 0-.052-.031-.021-.103.042-.093.031-.145.031-.238"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032A4A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.785 779.049c-.477.311-1.326.808-2.425 1.306-.01-.01-.021-.031-.031-.042.01-.083-.155-.653-.145-.653 0-.01-.052-.031-.021-.103.031-.083.021-.125.021-.218"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.773 779.04c-.445.301-1.357.829-2.414 1.285-.01-.01-.021-.031-.031-.041 0-.093-.124-.643-.114-.653 0 0-.062-.021-.041-.083.041-.083.021-.114.01-.207"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.773 779.04c-.425.28-1.399.85-2.414 1.254-.01 0-.031-.031-.031-.042 0-.103-.104-.642-.093-.653 0 0-.072-.01-.041-.072.031-.083 0-.093-.01-.186"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.773 779.04c-.404.259-1.44.86-2.425 1.233 0-.01-.021-.041-.021-.052 0-.104-.083-.632-.072-.643h.01s-.083-.01-.062-.073c.031-.072 0-.072-.021-.166"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.773 779.028c-.383.259-1.482.881-2.425 1.212a.11.11 0 0 1-.021-.052c0-.114-.052-.632-.041-.643l-.062-.062c.031-.062-.01-.062-.041-.145"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033156",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.764 779.028c-.352.238-1.513.901-2.415 1.181a.115.115 0 0 1-.021-.052c0-.124-.031-.632-.021-.643 0 0-.094.01-.073-.041.031-.073-.021-.052-.041-.135"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.764 779.018c-.332.228-1.554.922-2.415 1.161-.01-.01-.021-.042-.031-.052 0-.135.01-.622.021-.632 0 0-.104.01-.083-.041.021-.062-.031-.031-.062-.114"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.764 779.018c-.311.207-1.596.933-2.415 1.13-.01-.01-.021-.042-.031-.052 0-.135.031-.622.041-.632 0 0-.104.021-.093-.031.031-.052-.031-.01-.072-.093"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.764 779.018c-.29.186-1.627.953-2.415 1.098-.01-.01-.031-.031-.031-.052 0-.145.052-.612.073-.632 0 0-.124.031-.104-.021.021-.052-.052.01-.093-.073"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.754 779.009c-.259.176-1.658.974-2.404 1.088-.011-.021-.031-.041-.031-.062 0-.155.083-.611.093-.622 0 0-.124.021-.103-.01.01-.052-.062.021-.104-.062"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.754 779.009c-.238.155-1.699.995-2.404 1.057-.021-.021-.031-.041-.031-.062 0-.155.104-.601.124-.622 0 0-.135.031-.124 0 .021-.041-.073.031-.114-.041"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.754 779.009c-.218.135-1.741 1.005-2.414 1.026l-.031-.062c.01-.166.135-.601.155-.622 0 0-.145.042-.124.01.01-.041-.083.052-.135-.021"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.742 778.997c-.187.124-1.772 1.026-2.404 1.005-.01-.01-.02-.042-.031-.062 0-.176.166-.601.176-.611h.01s-.156.041-.145.01c.01-.031-.083.072-.145 0"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.742 778.997c-.166.114-1.813 1.047-2.404.974-.01-.01-.031-.041-.031-.062 0-.187.186-.591.207-.612 0 0-.156.052-.145.031.01-.031-.104.083-.166.01"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.742 778.997c-.145.093-1.855 1.057-2.404.943-.01-.01-.031-.042-.031-.062 0-.187.207-.591.228-.601v-.01s-.166.062-.155.042c.01-.031-.104.103-.166.031"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.742 778.987c-.125.083-1.896 1.078-2.404.933a.117.117 0 0 1-.031-.073c0-.197.238-.58.259-.601 0 0-.176.062-.166.042.01-.021-.114.124-.186.052"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.733 778.987c-.093.062-1.927 1.099-2.394.901-.02-.021-.031-.052-.041-.073.01-.207.269-.58.29-.601 0 0-.176.073-.176.052.01-.01-.124.145-.197.073"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.733 778.987c-.073.042-1.959 1.109-2.394.87-.02-.021-.031-.052-.041-.073 0-.207.3-.58.321-.591 0 0-.197.073-.186.062 0-.021-.135.145-.218.083"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.733 778.975c-.052.031-2 1.129-2.394.85a.174.174 0 0 1-.041-.073c0-.217.321-.57.342-.591 0 0-.197.083-.197.073.01-.01-.145.166-.217.104"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064374",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.733 778.975c-.031.01-2.041 1.15-2.404.818-.01-.021-.031-.042-.031-.073 0-.228.342-.57.373-.591l-.207.083s-.155.187-.238.125"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.721 778.966s-2.321 1.306-2.425.725c0-.238.394-.58.394-.58l-.218.083s-.155.207-.249.145"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m385.991 785.111 1.803 3.005c.135-.083.363-.321.435-.529.135-.414.114-.414.218-.86.052-.259.062-.549.114-.819.062-.269.446-1.13.456-1.482"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011D33",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.352-.394 1.192-.456 1.461-.052.27-.062.56-.114.819-.103.446-.083.435-.228.85-.062.207-.3.446-.425.528-.01 0-1.793-2.974-1.803-2.974"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011E34",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.342-.394 1.181-.446 1.451-.062.27-.073.549-.135.808-.104.435-.072.435-.218.85-.073.197-.3.435-.425.518-.01 0-1.782-2.933-1.803-2.943"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011E34",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.342-.383 1.171-.446 1.44-.062.259-.073.539-.135.798-.104.435-.072.425-.218.839-.073.197-.3.425-.425.508-.021.01-1.782-2.891-1.803-2.901"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011F36",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.332-.383 1.161-.446 1.419-.062.27-.073.539-.135.798-.104.425-.083.425-.218.829-.073.197-.3.425-.425.508-.031.01-1.772-2.86-1.803-2.87"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#011F36",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.332-.383 1.15-.446 1.409-.062.259-.073.539-.135.787-.104.425-.083.415-.228.819-.072.197-.29.425-.425.508-.021.01-1.751-2.829-1.793-2.839"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022037",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.332-.373 1.129-.446 1.389-.062.259-.073.539-.135.787-.104.415-.083.415-.228.808-.072.197-.29.425-.425.508-.031.01-1.751-2.798-1.793-2.808"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022037",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.321-.373 1.119-.446 1.378-.062.259-.073.529-.135.777-.104.414-.093.414-.228.798-.072.197-.29.425-.425.497-.041.021-1.741-2.746-1.793-2.767"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022139",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.321-.373 1.109-.446 1.368-.062.249-.073.518-.135.767-.104.404-.093.404-.238.798-.072.187-.29.404-.414.487-.041.01-1.741-2.715-1.793-2.736"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022139",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.311-.373 1.098-.446 1.347-.062.259-.073.518-.135.767-.104.404-.093.404-.238.787-.072.187-.29.404-.414.487-.052.01-1.731-2.684-1.793-2.704"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022139",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.311-.363 1.088-.446 1.337-.062.249-.073.508-.145.756-.104.404-.083.394-.228.777-.072.187-.29.404-.414.487-.062.01-1.72-2.653-1.793-2.673"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02223B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.311-.363 1.067-.446 1.326-.062.238-.073.508-.145.736-.104.404-.093.404-.228.777-.072.186-.29.404-.414.477-.062.021-1.72-2.611-1.793-2.632"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02223B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.301-.363 1.057-.446 1.306-.062.249-.073.508-.145.736-.104.404-.093.404-.238.767-.072.187-.28.394-.404.477-.072.021-1.71-2.57-1.793-2.601"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.301-.363 1.047-.446 1.295-.062.238-.073.497-.145.725-.104.394-.093.394-.238.767-.072.176-.28.383-.415.466-.072.021-1.689-2.539-1.782-2.57"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.29-.352 1.036-.446 1.285-.062.238-.073.487-.145.715-.104.394-.104.394-.238.756-.072.176-.29.383-.415.466-.072.021-1.689-2.508-1.782-2.539"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.29-.352 1.026-.446 1.264-.062.238-.083.487-.145.715-.104.384-.104.384-.238.746-.083.176-.29.383-.415.456-.083.031-1.679-2.466-1.782-2.497"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#02233E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.428c-.01.28-.352 1.005-.446 1.254-.062.238-.083.477-.145.705-.104.384-.104.384-.249.736-.072.176-.28.384-.404.456-.093.031-1.679-2.435-1.782-2.466"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022540",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.29-.352 1.005-.435 1.254-.073.228-.094.477-.155.694-.104.373-.104.383-.249.725-.072.176-.28.373-.404.456-.093.031-1.668-2.394-1.782-2.435"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022540",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.29-.342.995-.435 1.233-.073.228-.094.477-.155.694-.114.373-.114.373-.249.725-.072.166-.28.363-.404.435-.103.031-1.658-2.352-1.782-2.394"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022540",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.28-.342.984-.435 1.223-.062.228-.094.466-.166.684-.103.363-.103.373-.249.715a1.139 1.139 0 0 1-.394.435c-.114.031-1.658-2.321-1.782-2.362"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022541",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.28-.342.964-.435 1.213-.062.217-.094.456-.166.674-.103.363-.103.363-.249.705-.072.166-.28.363-.394.435-.114.031-1.648-2.29-1.782-2.331"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022541",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.27-.342.953-.435 1.192-.062.228-.094.456-.166.674-.103.352-.114.363-.249.695-.072.166-.28.362-.404.435-.114.031-1.637-2.259-1.772-2.3"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.27-.332.943-.435 1.181-.062.218-.094.446-.166.663-.103.352-.114.352-.249.684-.083.166-.28.352-.404.425-.124.042-1.627-2.207-1.772-2.259"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.27-.332.933-.435 1.171-.062.207-.094.446-.166.653-.103.342-.114.352-.259.684a1.148 1.148 0 0 1-.394.414c-.124.042-1.617-2.176-1.772-2.227"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022845",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.259-.332.922-.435 1.15-.062.218-.094.446-.166.653-.103.342-.114.352-.259.674a1.167 1.167 0 0 1-.394.415c-.135.041-1.617-2.145-1.772-2.197"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022845",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.259-.332.902-.435 1.14-.062.208-.094.435-.166.643-.103.332-.124.342-.259.663a1.27 1.27 0 0 1-.394.415c-.145.041-1.606-2.114-1.772-2.166"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.249-.321.891-.435 1.13-.062.207-.094.425-.166.632-.114.332-.124.342-.259.653a1.133 1.133 0 0 1-.394.404c-.145.052-1.596-2.073-1.772-2.124"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.249-.321.881-.435 1.109-.062.207-.094.425-.176.632-.104.321-.114.332-.259.643-.072.156-.269.332-.383.404-.155.052-1.596-2.042-1.772-2.104"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.249-.321.87-.435 1.099-.062.207-.094.414-.176.612-.104.332-.124.342-.259.643-.072.155-.269.332-.383.404-.166.042-1.585-2-1.772-2.073"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.239-.321.86-.435 1.088-.062.197-.094.415-.176.601-.104.321-.124.342-.259.643a1.298 1.298 0 0 1-.394.394c-.155.042-1.575-1.969-1.762-2.041"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.239-.311.839-.435 1.068-.062.197-.094.414-.176.601-.104.321-.124.332-.259.632a1.161 1.161 0 0 1-.394.384c-.166.052-1.565-1.928-1.762-2"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032A4A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.228-.311.829-.435 1.057-.062.197-.104.404-.176.591-.104.311-.124.332-.269.622a1.044 1.044 0 0 1-.384.383c-.176.052-1.554-1.896-1.762-1.969"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032A4A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 784.416c-.01.228-.311.819-.425 1.047-.073.187-.114.394-.186.58-.104.311-.135.321-.269.612a1.22 1.22 0 0 1-.384.383c-.176.052-1.554-1.865-1.762-1.938"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .228-.29.808-.415 1.026-.073.197-.114.394-.186.581-.104.301-.135.321-.269.601a1.187 1.187 0 0 1-.383.373c-.187.062-1.544-1.813-1.762-1.896"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .218-.29.798-.415 1.016-.073.186-.114.383-.186.57-.114.301-.135.321-.28.601a1.13 1.13 0 0 1-.373.363c-.197.062-1.534-1.783-1.762-1.865"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .218-.29.777-.415.995-.073.186-.114.394-.186.57-.114.3-.135.311-.28.591a1.117 1.117 0 0 1-.373.362c-.197.062-1.534-1.751-1.762-1.834"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .208-.29.767-.415.984-.073.187-.114.384-.197.56-.104.29-.135.311-.27.581-.083.135-.259.3-.373.363-.207.062-1.523-1.72-1.762-1.803"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .208-.28.756-.415.974-.073.176-.114.373-.197.549-.104.29-.135.301-.27.57-.083.135-.259.29-.383.352-.207.072-1.513-1.679-1.751-1.762"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .208-.28.746-.415.953-.073.186-.114.373-.197.549-.104.28-.135.301-.28.56-.073.135-.249.29-.373.352-.207.062-1.503-1.638-1.751-1.731"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .197-.28.736-.415.943-.073.176-.114.363-.197.539-.104.28-.145.29-.28.56-.083.124-.249.28-.373.342-.217.062-1.492-1.606-1.751-1.699"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .197-.28.715-.415.933-.073.176-.114.352-.197.529-.104.27-.145.29-.28.55-.083.124-.259.28-.373.342-.228.062-1.492-1.575-1.751-1.668"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .187-.269.705-.415.912-.073.176-.114.363-.197.529-.104.27-.145.29-.28.539-.083.125-.259.28-.373.332-.228.073-1.482-1.534-1.751-1.627"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .187-.269.695-.415.902-.073.166-.114.352-.197.518-.104.259-.145.28-.29.529a1.235 1.235 0 0 1-.363.332c-.238.073-1.482-1.503-1.751-1.596"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .176-.269.684-.415.891-.073.166-.114.342-.197.508-.114.259-.155.28-.29.518a1.221 1.221 0 0 1-.363.332c-.249.073-1.471-1.461-1.751-1.565"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .176-.269.674-.415.87-.073.166-.114.342-.197.508-.114.249-.155.269-.29.518a1.233 1.233 0 0 1-.373.321c-.238.073-1.451-1.43-1.741-1.534"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .176-.259.653-.415.86-.073.166-.114.332-.207.497-.103.249-.145.269-.28.508a1.078 1.078 0 0 1-.373.311c-.249.083-1.451-1.388-1.741-1.492"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .166-.259.643-.415.85-.062.156-.124.321-.207.477-.103.249-.155.28-.29.508a1.288 1.288 0 0 1-.363.311c-.259.083-1.44-1.357-1.741-1.461"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033156",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .166-.259.633-.404.829-.073.156-.135.332-.218.477-.103.249-.155.269-.29.497a1.288 1.288 0 0 1-.363.311c-.259.083-1.43-1.326-1.741-1.43"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033156",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .156-.259.622-.404.819-.073.156-.135.321-.218.466-.103.238-.155.269-.29.487a1.288 1.288 0 0 1-.363.311c-.269.073-1.43-1.285-1.741-1.399"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .156-.249.612-.404.808-.073.145-.135.311-.218.456-.103.238-.155.259-.3.487a1.038 1.038 0 0 1-.352.29c-.28.083-1.42-1.244-1.741-1.357"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.416c0 .156-.249.591-.404.788-.073.156-.135.311-.218.456-.103.228-.166.259-.3.477a1.038 1.038 0 0 1-.352.29c-.28.083-1.42-1.213-1.741-1.326"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .156-.249.591-.404.788-.073.145-.135.301-.218.446-.114.228-.166.259-.3.466a1.17 1.17 0 0 1-.352.29c-.29.083-1.409-1.181-1.741-1.295"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .156-.249.581-.404.777-.073.145-.135.29-.218.435-.114.218-.166.249-.3.456a1.042 1.042 0 0 1-.363.28c-.29.093-1.388-1.14-1.73-1.254"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .145-.238.57-.404.756-.073.145-.135.301-.228.435-.104.218-.166.249-.301.446a1.006 1.006 0 0 1-.352.28c-.29.094-1.388-1.098-1.73-1.222"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .145-.238.549-.404.746-.073.135-.135.29-.228.425-.104.207-.166.239-.301.435a1.006 1.006 0 0 1-.352.28c-.3.093-1.378-1.067-1.73-1.191"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04345B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .145-.238.539-.404.736-.073.135-.135.28-.228.415-.104.207-.166.239-.301.435a1.102 1.102 0 0 1-.352.27c-.311.093-1.378-1.036-1.73-1.16"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .135-.228.529-.404.715-.073.135-.135.28-.228.415-.104.197-.166.228-.301.425a1.164 1.164 0 0 1-.352.259c-.311.103-1.368-.995-1.73-1.119"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .135-.228.518-.404.705-.073.135-.135.269-.228.404-.104.197-.176.228-.311.415a1.03 1.03 0 0 1-.342.259c-.321.104-1.358-.964-1.73-1.088"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .125-.228.508-.404.695-.073.124-.135.259-.228.394-.104.197-.176.228-.311.404a1.018 1.018 0 0 1-.342.259c-.331.104-1.358-.933-1.73-1.057"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04365E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .125-.228.487-.404.674-.073.124-.135.269-.228.394-.114.187-.176.218-.311.394a1.283 1.283 0 0 1-.342.259c-.331.093-1.347-.891-1.73-1.026"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .125-.218.477-.404.664-.073.124-.135.259-.228.383-.114.187-.187.218-.311.394a1.127 1.127 0 0 1-.352.239c-.332.103-1.326-.85-1.72-.984"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .114-.218.466-.404.653-.073.114-.135.249-.228.373-.114.176-.187.207-.321.384a1.136 1.136 0 0 1-.342.238c-.342.104-1.326-.818-1.72-.953"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .114-.218.456-.394.633-.083.124-.155.249-.249.373-.104.176-.176.207-.311.373a1.119 1.119 0 0 1-.342.238c-.342.104-1.316-.787-1.72-.932"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .104-.218.446-.394.622-.083.114-.155.238-.249.352-.104.176-.176.218-.311.373a1.276 1.276 0 0 1-.342.238c-.352.104-1.316-.756-1.72-.901"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .104-.207.425-.394.601-.083.124-.155.238-.249.352-.104.176-.187.207-.321.363a.894.894 0 0 1-.332.228c-.363.114-1.306-.705-1.72-.86"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043963",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .104-.207.415-.394.591-.083.114-.155.238-.249.342-.104.166-.187.207-.321.363a1.016 1.016 0 0 1-.332.217c-.363.114-1.295-.674-1.72-.829"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043963",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .094-.207.404-.394.581-.083.104-.155.228-.249.332-.104.166-.187.197-.321.352a1.651 1.651 0 0 1-.332.218c-.373.114-1.295-.643-1.72-.798"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .094-.207.394-.394.56-.083.114-.155.228-.249.331-.114.155-.197.197-.321.342a1.651 1.651 0 0 1-.332.218c-.383.114-1.285-.612-1.72-.767"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .083-.197.384-.394.549-.083.104-.155.218-.249.321-.114.156-.197.197-.332.332a.999.999 0 0 1-.332.208c-.383.124-1.264-.57-1.71-.726"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .083-.197.363-.394.539-.083.104-.155.207-.249.311-.114.145-.197.187-.332.321a1.088 1.088 0 0 1-.332.207c-.383.114-1.264-.529-1.71-.694"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .083-.197.353-.394.518-.083.104-.155.207-.259.311-.104.145-.187.187-.321.321a1.29 1.29 0 0 1-.332.197c-.394.114-1.254-.498-1.71-.663"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .073-.197.342-.394.508-.083.093-.155.207-.259.301-.104.135-.197.176-.321.311a1.287 1.287 0 0 1-.332.187c-.404.125-1.254-.456-1.71-.622"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .073-.186.332-.394.498-.083.093-.155.197-.259.29-.104.135-.197.176-.332.301a1.285 1.285 0 0 1-.321.187c-.404.124-1.243-.425-1.71-.591"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .062-.186.322-.394.477a2.18 2.18 0 0 1-.259.29c-.104.124-.197.166-.332.29a1.447 1.447 0 0 1-.321.186c-.414.125-1.233-.394-1.71-.56"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .062-.186.301-.394.466a2.07 2.07 0 0 1-.259.28c-.104.124-.208.166-.332.28a1.451 1.451 0 0 1-.321.187c-.425.124-1.233-.352-1.71-.529"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .052-.186.29-.394.456a3.012 3.012 0 0 1-.259.269c-.114.114-.208.166-.332.27a1.08 1.08 0 0 1-.321.176c-.425.135-1.223-.311-1.71-.487"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .052-.176.28-.394.435a2.152 2.152 0 0 1-.259.27c-.114.114-.208.155-.342.269a1.593 1.593 0 0 1-.321.166c-.425.135-1.212-.28-1.699-.456"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .052-.176.27-.383.425-.083.083-.176.166-.269.259-.114.104-.208.155-.342.259a1.593 1.593 0 0 1-.321.166c-.435.135-1.202-.249-1.699-.425"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .042-.176.259-.383.415-.083.073-.176.166-.269.249-.114.104-.218.145-.342.249a1.593 1.593 0 0 1-.321.166c-.435.135-1.192-.218-1.699-.394"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .042-.176.239-.383.394a3.353 3.353 0 0 1-.28.249c-.104.093-.207.145-.342.238a1.066 1.066 0 0 1-.311.155c-.446.135-1.192-.166-1.699-.352"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .031-.166.228-.383.384-.083.073-.176.156-.28.228-.104.103-.207.155-.342.238a1.773 1.773 0 0 1-.311.156c-.456.135-1.181-.135-1.699-.321"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .031-.166.218-.383.373a3.252 3.252 0 0 1-.28.218c-.104.093-.207.145-.342.238a2.687 2.687 0 0 1-.311.145c-.456.135-1.171-.104-1.699-.29"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .031-.166.208-.383.353a3.463 3.463 0 0 1-.28.218c-.104.093-.217.145-.342.228a2.687 2.687 0 0 1-.311.145c-.466.135-1.171-.073-1.699-.259"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .021-.155.187-.383.342-.083.062-.176.135-.28.207-.114.093-.217.135-.352.218a1.556 1.556 0 0 1-.3.135c-.477.145-1.161-.031-1.699-.218"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .021-.155.176-.383.332-.083.062-.176.135-.28.197-.114.083-.217.135-.352.207a1.391 1.391 0 0 1-.311.135c-.466.145-1.15 0-1.689-.186"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.406c0 .01-.155.166-.383.311-.083.062-.176.135-.28.197-.114.083-.228.135-.352.197-.093.052-.207.093-.311.135-.477.145-1.14.042-1.689-.155"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.397c0 .021-.155.166-.383.311a3.485 3.485 0 0 1-.28.187c-.114.073-.228.124-.352.197l-.311.124c-.487.145-1.13.073-1.689-.124"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064374",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.397c0 .021-.145.156-.383.301-.083.052-.176.114-.28.176-.114.073-.228.124-.363.187a2.484 2.484 0 0 1-.3.114c-.487.156-1.13.114-1.689-.083"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064374",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.397c0 .01-.145.135-.383.28a2.38 2.38 0 0 1-.29.176c-.104.062-.218.114-.352.176a2.437 2.437 0 0 1-.301.114c-.497.156-1.119.145-1.689-.052"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.397c0 .01-.145.125-.383.27a5.51 5.51 0 0 1-.29.166c-.104.062-.228.114-.352.166a2.437 2.437 0 0 1-.301.114 2.85 2.85 0 0 1-1.689-.021"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.007 784.397s-1.544 1.213-3.016.695"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.069 779.63s-.3 1.938-.414 2.218c-.104.249-.715 1.358-1.648 1.617"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.069 779.63s-.321 1.917-.446 2.197c-.104.249-.674 1.305-1.627 1.627"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.059 779.62s-.332 1.907-.456 2.197c-.104.249-.643 1.243-1.606 1.637"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.059 779.62s-.352 1.896-.477 2.176c-.114.249-.601 1.191-1.585 1.648"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.048 779.62s-.363 1.875-.487 2.156c-.124.259-.57 1.14-1.575 1.658"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.048 779.62s-.383 1.865-.518 2.145c-.114.259-.529 1.067-1.544 1.668"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.048 779.608s-.404 1.855-.539 2.135c-.124.259-.487 1.016-1.523 1.679"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.038 779.608s-.414 1.845-.549 2.124c-.124.259-.456.953-1.503 1.689"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.038 779.608s-.435 1.824-.57 2.104c-.135.259-.425.901-1.492 1.699"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.028 779.599s-.445 1.824-.591 2.093c-.135.269-.373.84-1.461 1.72"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.028 779.599s-.477 1.803-.611 2.083c-.135.259-.342.777-1.44 1.72"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 779.599s-.487 1.793-.622 2.062c-.145.269-.311.725-1.43 1.73"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M389.017 779.587s-.508 1.782-.643 2.052c-.145.269-.28.674-1.409 1.751"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.945 778.438s-.249 2.736-2.197 3.492"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.945 778.438c-.01.01-.114.881-.508 1.73-.311.653-.829 1.399-1.689 1.751"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.935 778.438c0 .01-.124.901-.518 1.72-.29.601-.808 1.378-1.668 1.762"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.935 778.438c-.01.021-.155.932-.539 1.699-.28.56-.788 1.368-1.648 1.772"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.923 778.438c0 .021-.176.953-.56 1.689-.249.518-.756 1.347-1.617 1.772"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.923 778.438c-.01.031-.207.974-.58 1.668-.228.477-.746 1.337-1.596 1.793"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.914 778.438c0 .031-.228.995-.591 1.658-.218.425-.725 1.316-1.575 1.793"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.914 778.429c-.01.052-.259 1.036-.612 1.658-.197.373-.705 1.295-1.554 1.792"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.914 778.429c-.021.052-.29 1.057-.632 1.637-.186.342-.684 1.285-1.534 1.803"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.902 778.429c-.01.062-.311 1.078-.642 1.627-.166.29-.663 1.264-1.513 1.813"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.902 778.429c-.02.062-.342 1.099-.674 1.606-.145.249-.632 1.254-1.482 1.823"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.892 778.429c-.01.073-.363 1.13-.684 1.596-.124.197-.612 1.233-1.461 1.824"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.892 778.429c-.021.073-.394 1.15-.705 1.575-.114.155-.591 1.223-1.44 1.844"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.923 777.681s-.57 2.197-2.156 2.736"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022847",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.923 777.681s-.218.777-.736 1.534c-.342.508-.839 1.005-1.42 1.202"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032A4A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.923 777.671s-.228.767-.746 1.523c-.363.518-.87 1.036-1.409 1.223"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.923 777.662s-.238.756-.767 1.513c-.373.529-.891 1.067-1.388 1.233"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.914 777.65s-.238.746-.777 1.513c-.383.529-.922 1.088-1.368 1.244"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033156",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.914 777.65s-.249.726-.798 1.492c-.394.539-.943 1.119-1.358 1.254"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.914 777.64s-.259.726-.808 1.482c-.414.56-.984 1.15-1.347 1.275"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.914 777.628s-.269.715-.829 1.471c-.425.57-1.005 1.181-1.327 1.295"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.902 777.628s-.259.694-.839 1.461c-.435.57-1.036 1.202-1.306 1.295"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043963",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.902 777.619s-.269.684-.86 1.451c-.445.58-1.057 1.244-1.285 1.316"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.902 777.609s-.28.674-.87 1.44c-.456.591-1.098 1.275-1.275 1.337"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.902 777.597s-.29.663-.891 1.44c-.466.601-1.119 1.295-1.254 1.337"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.892 777.597s-.29.643-.902 1.42c-.477.611-1.15 1.326-1.233 1.358"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.892 777.588s-.301.632-.922 1.409c-.487.622-1.171 1.358-1.223 1.378"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M388.892 777.578s-.311.622-.933 1.399c-.508.632-1.213 1.389-1.213 1.389M384.687 780.676l-1.089.198M384.572 781.505l-.974-.413"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.696 780.707-1.089.167"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.696 780.748-1.099.136"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.687 780.791-1.099.093"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.687 780.831-1.111.062"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.687 780.874-1.12.019"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.675 780.915-1.118-.009"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.675 780.946-1.13-.041"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.675 780.986-1.139-.072"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.665 781.029-1.139-.115"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.581 781.455-.994-.385"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.593 781.411-1.018-.363"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053B67",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.593 781.371-1.027-.332"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.603 781.328-1.046-.31"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.613 781.287-1.068-.279"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.613 781.247-1.077-.26"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032F53",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.625 781.194-1.099-.217"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.634 781.153-1.12-.198"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.634 781.11-1.13-.165"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m384.644 781.07-1.149-.146"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.65 789.04s.58.031.632.052c.062.01 2.363-.042 2.363-.042"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.638 789.049s.57.052.653.073c.093.01 2.331-.062 2.331-.062"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.638 789.059s.549.072.663.093c.125.021 2.3-.083 2.3-.083"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.629 789.071s.539.083.684.114c.155.031 2.28-.104 2.28-.104"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.629 789.071s.518.114.705.145c.176.041 2.238-.124 2.238-.124"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.629 789.08s.497.124.715.166c.207.052 2.207-.145 2.207-.145"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.619 789.09s.487.145.736.197c.238.042 2.176-.176 2.176-.176"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.619 789.102s.477.166.746.218c.269.052 2.156-.187 2.156-.187"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.607 789.111s.466.176.767.238c.3.062 2.124-.208 2.124-.208"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.607 789.121s.446.197.777.259c.332.073 2.093-.228 2.093-.228"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M386.459 789.164s-1.699.321-2.062.249c-.363-.073-.798-.28-.798-.28"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022A49",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.215 790.353s-1.088.166-1.13.156c-.021 0-.632-.042-.653-.042-.01 0-.529-.125-.529-.125"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032D4F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.277 790.334s-1.119.176-1.202.156c-.041-.01-.601-.042-.632-.042-.031 0-.497-.114-.497-.114"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.34 790.303s-1.15.197-1.264.166c-.062-.01-.57-.042-.622-.042-.042 0-.456-.104-.456-.104"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.402 790.272s-1.171.207-1.337.176c-.083-.01-.539-.042-.601-.042l-.415-.083"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.464 790.251s-1.202.217-1.399.176c-.104-.021-.518-.042-.591-.052-.073 0-.373-.062-.373-.062"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.526 790.22s-1.233.238-1.471.186c-.124-.021-.477-.042-.57-.052-.083 0-.332-.052-.332-.052"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053D6A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.588 790.188s-1.254.259-1.533.207c-.155-.031-.456-.052-.56-.062-.104-.01-.29-.042-.29-.042"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064171",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.65 790.167s-1.285.269-1.606.207a2.653 2.653 0 0 0-.539-.062l-.259-.021"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.047,
    d: "m383.152 790.386-1.057.146-.673-.032-.57-.146"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M383.712 790.136s-1.316.29-1.679.218c-.352-.073-.736-.073-.736-.073M378.51 790.291l-1.026-.373c-.643-.239-.715-.881-.715-.881"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.582 790.086s-.415-.166-.756-.29c-.912-.342-.808-.777-.808-.777"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.644 790.126s-.539-.207-.819-.311a2.359 2.359 0 0 1-.425-.197 1.119 1.119 0 0 1-.321-.29c-.083-.124-.083-.3-.083-.3"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.706 790.179s-.674-.259-.881-.332a3.768 3.768 0 0 1-.414-.187c-.093-.062-.311-.238-.342-.29-.062-.104-.103-.342-.103-.342"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.768 790.22s-.808-.301-.943-.353a5.217 5.217 0 0 1-.404-.166 4.178 4.178 0 0 1-.363-.3c-.042-.062-.114-.373-.114-.373"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.83 790.272s-.932-.352-1.005-.373c-.031-.021-.383-.145-.404-.166a3.524 3.524 0 0 1-.373-.301c-.021-.031-.135-.394-.135-.394"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053E6C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m378.582 790.303-1.109-.415a1.252 1.252 0 0 1-.497-.373c-.135-.197-.187-.477-.187-.477"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043862",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.666 790.303s-.995-.363-1.202-.446a1.386 1.386 0 0 1-.466-.352c-.104-.145-.176-.466-.176-.466"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043258",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.737 790.313s-1.15-.435-1.285-.477a1.942 1.942 0 0 1-.446-.342c-.073-.104-.166-.456-.166-.456"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032C4D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.811 790.313s-1.295-.487-1.368-.508a4.723 4.723 0 0 1-.425-.321c-.031-.052-.155-.446-.155-.446"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#022743",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "m378.893 790.312-1.461-.538-.394-.299-.145-.437"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032B4C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.194 789.04s.601.031.663.052c.062.01 2.456-.042 2.456-.042"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#032E50",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.182 789.049s.591.052.684.073c.093.01 2.425-.062 2.425-.062"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#033054",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.182 789.059s.57.072.694.093c.125.021 2.394-.083 2.394-.083"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043359",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.182 789.071s.549.083.705.114c.156.031 2.363-.104 2.363-.104"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#04355C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.173 789.071s.539.114.725.145c.187.041 2.332-.124 2.332-.124"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#043760",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.173 789.08s.518.124.736.166c.217.052 2.311-.145 2.311-.145"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053A65",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.163 789.09s.508.145.756.197c.259.042 2.28-.176 2.28-.176"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053C68",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.163 789.102s.487.166.777.218c.28.052 2.238-.187 2.238-.187"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#053F6E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.151 789.111s.487.176.798.238c.311.062 2.207-.208 2.207-.208"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#064172",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.151 789.121s.466.197.808.259c.342.073 2.176-.228 2.176-.228"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00209F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M380.127 789.164s-1.782.321-2.156.249a4.566 4.566 0 0 1-.829-.28"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M385.866 779.09c.031-.3.041-.601.041-.767-.01-1.233.155-2.166.021-3.461-.104-1.016-.352-2.352-.3-3.451.021-.311-.041-.622-.052-.922l-5.005 5.617M387.775 788.115c.135-.083.363-.321.435-.529.145-.414.114-.404.217-.86.062-.259.062-.549.125-.819.052-.269.435-1.13.445-1.482.041-1.129.415-1.896.321-3.13-.062-.953-.28-2.249-.176-3.244.031-.269-.01-.581-.021-.85l-5.627 3.72M376.676 789.018c-.042.124.083.363.124.446l.114.155c.062.135.052.104.166.207.031.021.166.135.207.155.083.062.166.145.259.156.425.073.601.166 1.005.28.383.114.176.093.466.166.145.031.435.145.58.166.259.042.3.083.57.145.694.155 1.368.114 2.052.073.28-.021.964-.166 1.202-.332.425-.3 1.358-.414 1.772-.704.062-.042.321-.166.373-.218.404-.332.726-.425 1.15-.694"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.035,
    d: "m383.359 780.728 5.71-3.731.104.156-5.679 3.772z"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M389.162 776.936c.041-.218-.021-.508-.176-.539-.01 0-.124-.041-.197-.021-.093 0-.114.031-.155.103-.083.197.155.321.321.384.042.01.155.031.176.083.031.083.011.052.031.083-.031-.01-.042-.042-.072-.062-.125-.072-.249-.093-.425-.176-.135-.062-.156-.332-.062-.414.103-.083.425-.073.497.01.155.176.166.415.135.653 0-.052-.083-.042-.073-.104z"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M389.255 777.038c.218-.01.497.083.508.238 0 .021.021.145 0 .207-.01.093-.041.114-.124.135-.207.062-.3-.186-.332-.363-.01-.042-.01-.155-.062-.187-.083-.041-.062-.021-.083-.041.01.031.042.052.052.073.052.135.062.269.124.456.042.135.311.187.394.104.104-.083.135-.404.062-.487-.156-.176-.394-.218-.632-.218.042.011.031.094.093.083z"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M389.296 776.945c.062.031.062.114.031.166-.021.052-.114.062-.155.041-.083-.052-.135-.145-.083-.228.051-.072.134-.01.207.021z"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M390.5 776.188s-.601.238-1.088.249c0 0-.021.425-.124.549 0 0 .435-.083.632.021 0 0 .259-.591.58-.819z"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M390.012 776.489s-.238.104-.435.104c0 0-.01.166-.052.218 0 0 .176-.031.249.011 0-.001.104-.24.238-.333z"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M389.255 777.411s-.114-.197-.145-.269c-.021-.041.01.238-.093.269-.135.176-.166.539-.166.632.155.052.29.145.529.031.083-.052.021-.207-.01-.332-.021-.062-.042-.238-.115-.331z"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M389.141 777.256c0 .031-.021.155-.01.135 0-.052-.062.052-.072.073-.083.155-.114.269-.145.57M389.091 777.516c-.052.238-.094.228-.094.56l-.021-.021M389.1 777.734c-.041.166-.031.249-.041.332.01 0 .062.041.072.041"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.035,
    d: "m380.416 775.961 5.099-5.668.103.124-5.046 5.689z"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M385.472 770.294c-.01-.228-.135-.497-.29-.487-.011 0-.135-.01-.197.021-.093.021-.104.062-.124.145-.041.207.218.269.394.29.042 0 .166-.01.197.042.052.073.021.052.052.073-.031 0-.062-.031-.083-.042-.145-.041-.27-.041-.466-.072-.135-.021-.218-.29-.145-.383.073-.104.383-.176.477-.114.197.135.259.363.28.611-.012-.053-.084-.033-.095-.084z"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M385.587 770.365c.218-.062.508-.031.56.114 0 .01.052.135.041.197.01.093-.01.124-.093.166-.176.104-.332-.114-.404-.28-.021-.042-.052-.145-.104-.166-.083-.021-.062 0-.083-.021.01.031.041.041.062.062.083.124.125.238.228.414.073.114.342.114.414.01.072-.114.021-.425-.062-.487-.187-.145-.435-.135-.663-.062.042-.008.052.074.104.053z"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M385.609 770.263c.073.01.083.104.073.155-.01.052-.093.093-.145.073-.083-.031-.166-.103-.135-.197.03-.083.134-.041.207-.031z"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M386.592 769.245s-.518.373-.984.497c0 0 .073.425 0 .56 0 0 .415-.176.622-.124 0 0 .103-.632.362-.933z"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M386.198 769.661s-.207.145-.394.197c0 0 .031.166 0 .218 0 0 .166-.062.249-.042 0 0 .042-.259.145-.373z"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M385.68 770.729s-.155-.166-.207-.228c-.031-.042.073.228-.021.29-.093.197-.031.549-.01.653.166.01.311.062.508-.104.073-.062-.021-.197-.083-.311-.031-.062-.094-.228-.187-.3z"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M385.534 770.614c0 .021.01.104.01.124-.01.062-.062.083-.072.156-.031.176.01.29.021.518M385.556 770.822c-.052.218-.01.394.021.601.01 0-.021 0-.021-.01M385.587 771.185c.031.083.031.135.041.228.01-.01.052.031.062.021"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.118,
    d: "m376.293 768.925-12.01 20.093h24.03l-12.02-20.093z"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.035,
    d: "m376.293 770.231-10.839 18.135h21.688l-10.849-18.135z"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "#007E93",
    stroke: "#007E93",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.071,
    d: "m368.666 782.976-3.212 5.39h21.688l-3.222-5.39h-15.254z"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#086AAD",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.407 773.401c.508-.456 1.13-.642 1.855-.653h.052c.705.01 1.42.176 1.875.653"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0863AA",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.395 773.423c.497-.466 1.14-.643 1.865-.653h.052c.725 0 1.44.176 1.896.663"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#095FA8",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.386 773.454c.497-.487 1.15-.663 1.886-.674h.052c.725.01 1.451.186 1.906.684"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0A58A5",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.364 773.475c.497-.487 1.171-.674 1.907-.674h.062c.736 0 1.461.186 1.917.705"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0A52A2",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.355 773.494c.487-.497 1.181-.674 1.927-.684h.052c.756.01 1.482.197 1.938.726"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0B4D9F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.336 773.516c.487-.508 1.192-.684 1.948-.684h.062c.767.01 1.492.197 1.958.736"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C479D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.324 773.547c.487-.518 1.202-.705 1.969-.705h.052c.788.01 1.503.207 1.979.756"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#270A7F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.19 773.764c.57-.601 1.275-.777 2.114-.777h.052c.922.01 1.71.321 2.166.964"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#241183",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.199 773.733c.56-.58 1.264-.756 2.104-.767h.052c.901.01 1.679.311 2.145.943"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#221786",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.221 773.712c.549-.58 1.244-.756 2.073-.756h.052c.891.01 1.668.29 2.135.922"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F1F8A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.23 773.692c.539-.57 1.244-.746 2.052-.756h.052c.881.01 1.648.28 2.124.901"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1A258D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.252 773.661c.518-.549 1.223-.736 2.031-.736h.041c.871 0 1.637.249 2.114.87"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#172D91",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.262 773.64c.508-.549 1.223-.725 2.01-.735h.052c.85.01 1.616.238 2.083.85"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#143393",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.271 773.618c.497-.539 1.213-.725 1.99-.725h.052c.839 0 1.596.217 2.073.818"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#113B97",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.293 773.587c.487-.529 1.202-.705 1.969-.715h.042c.829 0 1.585.207 2.062.808"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF0A00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.1 772.221c.352-.249.725-.321 1.192-.321.446 0 .839.073 1.181.3"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F10",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.09 772.24c.352-.249.736-.321 1.202-.321.446 0 .85.073 1.192.301"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF1500",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.081 772.262c.363-.249.746-.332 1.212-.332.446 0 .86.083 1.213.311"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF1A00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.071 772.293c.363-.259.746-.342 1.223-.342.456 0 .87.083 1.223.311"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF2000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.059 772.314c.363-.259.756-.342 1.233-.342.456 0 .881.083 1.233.311"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF2700",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.05 772.333c.363-.259.767-.352 1.243-.352.456 0 .891.094 1.244.332"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF2F00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.038 772.355c.363-.259.767-.352 1.254-.352.456 0 .901.093 1.254.331"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F30",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.028 772.376c.363-.269.777-.352 1.264-.352.466 0 .912.093 1.275.332"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF3C00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.019 772.395c.363-.269.787-.363 1.275-.363.466 0 .922.104 1.285.342"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4100",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M375.007 772.417c.373-.269.798-.363 1.285-.363.466 0 .933.104 1.295.342"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4600",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.997 772.439c.373-.269.798-.363 1.296-.363.477 0 .943.104 1.306.342"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF500",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.718 772.904c.404-.311 1.047-.466 1.585-.466.57 0 1.192.155 1.596.477"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFEB00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.739 772.873c.393-.311 1.026-.456 1.565-.456.56 0 1.171.145 1.575.477"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFE000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.749 772.852c.404-.311 1.016-.456 1.554-.456.549 0 1.161.145 1.565.466"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD600",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.77 772.821c.394-.3.995-.445 1.534-.445.549 0 1.15.145 1.544.456"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFCF00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.78 772.802c.394-.3.984-.445 1.523-.445s1.13.145 1.534.445"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFC400",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.801 772.771c.394-.3.974-.435 1.503-.435.539 0 1.119.135 1.513.446"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFBA00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.811 772.749c.394-.301.964-.435 1.492-.435s1.099.135 1.492.435"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFB000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.832 772.718c.383-.29.943-.425 1.471-.425.529 0 1.088.135 1.482.425"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFA600",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.842 772.697c.394-.301.933-.425 1.461-.425.518 0 1.078.135 1.461.425"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF9C00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.863 772.666c.383-.29.912-.415 1.44-.415.508 0 1.057.124 1.44.415"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF9100",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.873 772.646c.383-.29.912-.415 1.43-.415.508 0 1.047.125 1.43.404"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF8700",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.894 772.613c.383-.28.891-.404 1.409-.404.497 0 1.036.124 1.41.394"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF7D00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.904 772.594c.383-.29.881-.404 1.399-.404.497 0 1.016.124 1.399.394"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF7500",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.925 772.563c.373-.28.86-.393 1.378-.393.487 0 1.005.124 1.378.383"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF6B00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.935 772.541c.383-.28.85-.394 1.368-.394.487 0 .984.114 1.357.373"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF6100",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.956 772.51c.373-.28.839-.383 1.347-.383.476 0 .974.114 1.347.373"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF5700",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.966 772.489c.384-.28.829-.383 1.337-.383.466 0 .964.114 1.327.363"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#EBF605",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.665 772.957c.425-.332 1.078-.487 1.637-.487.58 0 1.212.166 1.627.497"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D6EC09",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.656 772.988c.445-.352 1.078-.497 1.648-.497.58 0 1.233.166 1.648.508"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C2E30E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.634 773.019c.466-.373 1.078-.518 1.668-.518.591 0 1.244.176 1.658.518"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ADD912",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.615 773.05c.497-.394 1.088-.529 1.689-.529.591 0 1.254.176 1.668.529"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#99CF16",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.603 773.081c.508-.404 1.088-.539 1.689-.539.611 0 1.275.176 1.699.529"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#85C61A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.584 773.112c.539-.425 1.088-.56 1.71-.56.622 0 1.295.187 1.71.549"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70BC1F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.572 773.143c.549-.445 1.088-.57 1.72-.57.622 0 1.306.186 1.73.549"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5CB323",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.551 773.174c.58-.466 1.099-.591 1.741-.591.632 0 1.316.197 1.741.57"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#47A928",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.531 773.193c.601-.477 1.098-.591 1.762-.591.632 0 1.326.197 1.762.57"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0D74A4",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.438 773.36c.529-.466 1.14-.632 1.865-.632.684 0 1.399.176 1.855.622"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#127A97",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.448 773.348c.539-.477 1.13-.643 1.855-.643.684 0 1.389.187 1.845.622"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#17808B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.46 773.329c.549-.477 1.13-.632 1.845-.632.674 0 1.389.186 1.834.611"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1A847D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.469 773.308c.56-.477 1.119-.622 1.834-.622.663 0 1.378.187 1.813.601"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1E8A6D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.479 773.298c.57-.487 1.119-.632 1.814-.632.674 0 1.378.197 1.813.601"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#238F5E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.491 773.277c.58-.487 1.109-.622 1.803-.622.663 0 1.368.197 1.803.601"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2B944E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.5 773.267c.591-.497 1.109-.622 1.793-.622.653 0 1.358.197 1.793.591"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2F9B3E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.51 773.246c.601-.497 1.099-.612 1.782-.612.643 0 1.358.197 1.782.58"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.464 772.178c-.342-.228-.736-.301-1.171-.301-.466 0-.829.083-1.181.321"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2A007C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.551 773.993c-.477-.674-1.285-.995-2.238-.995-.86 0-1.554.187-2.145.788"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0671B0",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.169 773.36c-.456-.445-1.171-.622-1.865-.622-.736 0-1.357.176-1.876.642"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0C419A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.346 773.64c-.487-.591-1.233-.777-2.052-.777-.767 0-1.503.176-1.989.705"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF0",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.92 772.945c-.414-.332-1.047-.487-1.616-.487-.549 0-1.213.155-1.617.466"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FF4D00",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M377.608 772.439c-.363-.238-.839-.352-1.316-.352-.497 0-.933.104-1.306.383"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#33A02C",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M378.064 773.193c-.425-.373-1.13-.58-1.772-.58-.674 0-1.161.114-1.772.611"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEF2EC",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M374.097 773.888c.674-.332 1.378-.539 2.197-.539.777 0 1.606.29 2.259.643l2.3 3.844c0 2.518-2.052 4.601-4.559 4.601-2.518 0-4.549-2.031-4.57-4.58l2.373-3.969z"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEF2EA",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.294 773.401c.767 0 1.585.301 2.228.643.01 0 2.269 3.782 2.269 3.793 0 2.477-2.02 4.539-4.497 4.539-2.487 0-4.486-2-4.507-4.518 0-.01 2.331-3.907 2.342-3.907.662-.332 1.357-.55 2.165-.55z"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEF0E6",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 773.525c.756 0 1.554.28 2.176.622.021.01 2.207 3.658 2.207 3.689 0 2.414-1.969 4.424-4.383 4.424-2.404 0-4.363-1.958-4.373-4.404 0-.031 2.249-3.793 2.269-3.803.653-.32 1.327-.528 2.104-.528z"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEEDE3",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 773.649c.736 0 1.513.269 2.114.601.042.021 2.156 3.544 2.156 3.596 0 2.342-1.917 4.29-4.269 4.29-2.342 0-4.238-1.896-4.259-4.28 0-.052 2.176-3.669 2.218-3.699.631-.311 1.284-.508 2.04-.508z"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEE8DC",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 773.826c.705 0 1.451.259 2.031.58.062.042 2.052 3.358 2.052 3.441 0 2.238-1.835 4.104-4.083 4.104-2.238 0-4.062-1.813-4.072-4.093 0-.083 2.042-3.502 2.114-3.534.601-.301 1.243-.498 1.958-.498z"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEE6D5",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 773.95c.684 0 1.409.249 1.969.56.083.052 1.99 3.233 1.99 3.337 0 2.176-1.782 3.989-3.959 3.989-2.176 0-3.938-1.772-3.948-3.979 0-.104 1.958-3.378 2.052-3.43.58-.29 1.202-.477 1.896-.477z"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEE3CF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.127c.653 0 1.347.249 1.876.539.114.062 1.896 3.046 1.896 3.181 0 2.083-1.689 3.803-3.772 3.803-2.073 0-3.762-1.679-3.772-3.782 0-.145 1.844-3.212 1.958-3.285.56-.28 1.151-.456 1.814-.456z"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEE0CC",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.251c.642 0 1.295.228 1.823.518.125.073 1.835 2.922 1.835 3.078 0 2.01-1.648 3.679-3.658 3.679s-3.637-1.627-3.647-3.658c0-.166 1.762-3.099 1.886-3.171.549-.28 1.119-.446 1.761-.446z"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEDEC6",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.375c.622 0 1.254.218 1.762.497.135.083 1.772 2.808 1.772 2.984 0 1.938-1.586 3.554-3.534 3.554-1.938 0-3.513-1.575-3.523-3.544 0-.187 1.679-2.984 1.824-3.068.518-.257 1.077-.423 1.699-.423z"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDCDAA",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.164c.487 0 .974.166 1.368.383.249.145 1.368 2.01 1.368 2.321a2.75 2.75 0 0 1-2.736 2.746c-1.503 0-2.725-1.223-2.736-2.746 0-.311 1.15-2.228 1.41-2.373a2.847 2.847 0 0 1 1.326-.331z"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDCDAA",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.216c.477 0 .953.166 1.337.383.259.155 1.337 1.948 1.337 2.269 0 1.471-1.202 2.684-2.673 2.684a2.674 2.674 0 0 1-2.674-2.674c0-.332 1.109-2.176 1.378-2.332a2.76 2.76 0 0 1 1.295-.33z"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDC59E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.515c.425 0 .85.145 1.192.342.301.176 1.181 1.637 1.181 2.01a2.387 2.387 0 0 1-2.373 2.383 2.379 2.379 0 0 1-2.373-2.373c0-.383.912-1.886 1.223-2.062a2.38 2.38 0 0 1 1.15-.3z"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDC59E",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.577c.414 0 .829.135 1.161.332.311.186 1.15 1.575 1.15 1.959a2.321 2.321 0 0 1-2.311 2.321 2.306 2.306 0 0 1-2.311-2.311c0-.394.87-1.824 1.192-2.01a2.353 2.353 0 0 1 1.119-.291z"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEF0E9",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.294 773.463c.756 0 1.565.29 2.197.632.01.01 2.238 3.72 2.238 3.741 0 2.446-2 4.487-4.435 4.487-2.446 0-4.435-1.99-4.446-4.466 0-.021 2.29-3.844 2.3-3.855.664-.332 1.348-.539 2.146-.539z"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEEDE3",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 773.587c.746 0 1.533.28 2.145.612.031.021 2.186 3.606 2.186 3.648 0 2.373-1.948 4.352-4.332 4.352-2.373 0-4.301-1.927-4.321-4.342 0-.042 2.218-3.73 2.249-3.751.643-.322 1.306-.518 2.073-.519z"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEEBDF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 773.712c.725 0 1.492.269 2.083.591.052.031 2.124 3.482 2.124 3.544 0 2.311-1.896 4.228-4.207 4.228s-4.176-1.876-4.197-4.218c0-.062 2.124-3.617 2.176-3.648.632-.311 1.275-.497 2.021-.497z"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEEBDD",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 773.764c.715 0 1.471.269 2.062.591.052.031 2.083 3.42 2.083 3.492 0 2.28-1.865 4.166-4.145 4.166-2.269 0-4.114-1.845-4.135-4.156 0-.073 2.083-3.554 2.145-3.596.612-.3 1.254-.497 1.99-.497z"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEE8D9",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 773.888c.694 0 1.43.259 2 .57.073.042 2.021 3.295 2.021 3.388 0 2.207-1.803 4.042-4.021 4.042-2.207 0-4-1.782-4.01-4.031 0-.094 2-3.441 2.083-3.482.59-.3 1.222-.487 1.927-.487z"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEE6D3",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.012c.674 0 1.389.249 1.937.549.094.052 1.959 3.171 1.959 3.285 0 2.145-1.751 3.927-3.896 3.927-2.135 0-3.876-1.741-3.896-3.907 0-.125 1.928-3.337 2.021-3.389.58-.289 1.191-.465 1.875-.465z"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEE3D2",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.075c.663 0 1.368.238 1.906.539.104.062 1.928 3.109 1.928 3.233 0 2.114-1.72 3.865-3.834 3.865-2.104 0-3.813-1.71-3.834-3.844 0-.135 1.886-3.275 1.99-3.337.569-.28 1.17-.456 1.844-.456z"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEE0CC",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.189c.653 0 1.316.238 1.844.529.124.073 1.875 2.984 1.875 3.13 0 2.052-1.679 3.741-3.72 3.741-2.042 0-3.699-1.658-3.71-3.72 0-.156 1.803-3.161 1.927-3.223.551-.28 1.131-.457 1.784-.457z"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEDEC8",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.313c.632 0 1.275.228 1.793.508.124.083 1.803 2.87 1.803 3.036 0 1.969-1.617 3.606-3.596 3.606-1.969 0-3.575-1.596-3.586-3.596 0-.176 1.72-3.047 1.855-3.119a3.766 3.766 0 0 1 1.731-.435z"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDDBC5",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.438c.611 0 1.233.217 1.73.487.145.094 1.741 2.746 1.741 2.933 0 1.907-1.565 3.492-3.471 3.492-1.907 0-3.45-1.555-3.461-3.482 0-.197 1.637-2.922 1.793-3.016a3.613 3.613 0 0 1 1.668-.414z"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDDBC2",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.49c.601 0 1.212.218 1.699.487.156.093 1.71 2.684 1.71 2.881 0 1.875-1.533 3.43-3.409 3.43s-3.399-1.523-3.409-3.42c0-.207 1.606-2.87 1.772-2.964.497-.248 1.036-.414 1.637-.414z"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD9BF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.552c.591 0 1.192.207 1.668.477.166.103 1.679 2.622 1.679 2.829 0 1.844-1.503 3.368-3.347 3.368s-3.336-1.492-3.347-3.357c0-.218 1.565-2.808 1.731-2.912.497-.249 1.025-.405 1.616-.405z"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD9BF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.614c.58 0 1.171.207 1.637.466.176.104 1.648 2.56 1.648 2.777 0 1.814-1.471 3.306-3.285 3.306-1.803 0-3.275-1.461-3.285-3.295 0-.228 1.523-2.746 1.699-2.85.488-.248 1.006-.404 1.586-.404z"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD6BC",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.677c.57 0 1.15.197 1.606.456.187.114 1.617 2.497 1.617 2.725 0 1.772-1.451 3.244-3.223 3.244-1.772 0-3.212-1.44-3.223-3.233 0-.238 1.482-2.694 1.668-2.798a3.295 3.295 0 0 1 1.555-.394z"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD6B9",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.739c.56 0 1.13.197 1.575.446.197.114 1.586 2.435 1.586 2.674 0 1.741-1.419 3.181-3.16 3.181s-3.15-1.409-3.161-3.171c0-.249 1.43-2.632 1.638-2.746a3.26 3.26 0 0 1 1.522-.384z"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD4B8",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.801c.549 0 1.109.186 1.554.435.197.124 1.555 2.373 1.555 2.622 0 1.71-1.399 3.13-3.109 3.13s-3.088-1.389-3.099-3.119c0-.259 1.388-2.58 1.596-2.694a3.223 3.223 0 0 1 1.503-.374z"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD4B6",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.853c.539 0 1.088.197 1.523.435.207.125 1.523 2.311 1.523 2.57 0 1.679-1.368 3.067-3.046 3.067s-3.036-1.358-3.036-3.057c0-.269 1.347-2.518 1.565-2.642.455-.228.932-.373 1.471-.373z"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD2B2",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.915c.528 0 1.067.186 1.492.425.218.124 1.492 2.248 1.492 2.518 0 1.647-1.347 3.005-2.984 3.005s-2.974-1.337-2.984-2.995c0-.269 1.316-2.456 1.544-2.591a3.208 3.208 0 0 1 1.44-.362z"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD1B0",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 774.977c.518 0 1.047.176 1.461.415.228.135 1.461 2.186 1.461 2.477 0 1.606-1.316 2.933-2.922 2.933s-2.912-1.306-2.922-2.933c0-.28 1.275-2.404 1.513-2.529a2.937 2.937 0 0 1 1.409-.363z"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD0B0",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.039c.508 0 1.016.176 1.43.404.238.135 1.43 2.125 1.43 2.425a2.874 2.874 0 0 1-2.86 2.87c-1.575 0-2.849-1.275-2.86-2.87 0-.29 1.233-2.342 1.482-2.477a2.93 2.93 0 0 1 1.378-.352z"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDD0AD",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.101c.497 0 .995.166 1.399.394.249.145 1.399 2.073 1.399 2.373 0 1.534-1.254 2.808-2.798 2.808a2.802 2.802 0 0 1-2.798-2.808c0-.3 1.192-2.28 1.44-2.425a2.88 2.88 0 0 1 1.358-.342z"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDCAA6",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.278c.466 0 .932.156 1.316.373.259.155 1.295 1.886 1.295 2.217 0 1.44-1.171 2.632-2.612 2.632a2.616 2.616 0 0 1-2.611-2.622c0-.342 1.067-2.124 1.347-2.28.384-.195.798-.32 1.265-.32z"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDCAA4",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.34c.456 0 .912.155 1.285.363.269.166 1.264 1.824 1.264 2.166 0 1.409-1.14 2.57-2.549 2.57a2.566 2.566 0 0 1-2.56-2.56c0-.352 1.036-2.062 1.316-2.228a2.666 2.666 0 0 1 1.244-.311z"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDC8A4",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.403c.446 0 .891.145 1.254.352.28.166 1.243 1.762 1.243 2.114 0 1.378-1.119 2.508-2.497 2.508s-2.487-1.119-2.497-2.497c0-.363.994-2 1.285-2.166a2.514 2.514 0 0 1 1.212-.311z"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDC8A1",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.465c.435 0 .87.145 1.223.342.29.176 1.213 1.699 1.213 2.063a2.447 2.447 0 0 1-2.435 2.445 2.445 2.445 0 0 1-2.435-2.435c0-.373.953-1.948 1.254-2.114a2.512 2.512 0 0 1 1.18-.301z"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDC39B",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.639c.404 0 .808.135 1.13.321.321.186 1.119 1.513 1.119 1.907a2.255 2.255 0 0 1-2.248 2.259 2.247 2.247 0 0 1-2.249-2.249c0-.404.829-1.772 1.15-1.958.331-.177.694-.28 1.098-.28z"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDC398",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.701c.394 0 .787.124 1.099.311.332.197 1.088 1.451 1.088 1.865a2.203 2.203 0 0 1-2.187 2.197 2.189 2.189 0 0 1-2.186-2.197c0-.414.788-1.71 1.119-1.906a2.29 2.29 0 0 1 1.067-.27z"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDC097",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.763c.383 0 .767.124 1.078.3.332.197 1.047 1.389 1.047 1.813a2.136 2.136 0 0 1-2.124 2.135 2.13 2.13 0 0 1-2.125-2.135c0-.425.736-1.658 1.088-1.855a2.17 2.17 0 0 1 1.036-.258z"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDC095",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.828c.373 0 .746.114 1.047.29.342.207 1.015 1.337 1.015 1.762a2.07 2.07 0 0 1-2.062 2.073 2.08 2.08 0 0 1-2.073-2.073c0-.435.705-1.596 1.067-1.793a2.045 2.045 0 0 1 1.006-.259z"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDBE92",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.878c.363 0 .715.124 1.016.29.352.207.984 1.275.984 1.71 0 1.109-.891 2.01-2 2.01s-2-.901-2.01-2.01c0-.445.663-1.534 1.026-1.741.3-.156.621-.259.984-.259z"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDBE90",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 775.94c.352 0 .694.114.984.28.352.218.953 1.213.953 1.658a1.95 1.95 0 0 1-1.938 1.948 1.945 1.945 0 0 1-1.948-1.948c0-.456.622-1.482.995-1.689.291-.156.602-.249.954-.249z"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDBB8F",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 776.002c.342 0 .674.104.953.269.363.218.932 1.15.932 1.606a1.885 1.885 0 1 1-3.772 0c0-.466.58-1.42.964-1.637.281-.145.581-.238.923-.238z"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDBB8D",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 776.064c.331 0 .653.104.922.259.373.228.901 1.088.901 1.554a1.826 1.826 0 0 1-1.823 1.824 1.82 1.82 0 0 1-1.824-1.824c0-.477.539-1.357.933-1.585a1.81 1.81 0 0 1 .891-.228z"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDB98A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 776.126c.321 0 .632.093.891.249.383.228.87 1.026.87 1.503a1.77 1.77 0 0 1-1.762 1.772 1.77 1.77 0 0 1-1.762-1.772c0-.487.497-1.306.901-1.534.251-.135.541-.218.862-.218z"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FDB98A",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 776.188c.311 0 .611.093.86.238.394.238.839.964.839 1.451a1.71 1.71 0 0 1-1.7 1.71 1.702 1.702 0 0 1-1.699-1.71c0-.497.456-1.243.86-1.471.249-.145.529-.218.84-.218z"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FCB687",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 776.241c.3 0 .591.093.839.238.394.238.798.901.798 1.399 0 .912-.736 1.648-1.637 1.648a1.651 1.651 0 0 1-1.647-1.648c0-.508.425-1.192.839-1.419a1.62 1.62 0 0 1 .808-.218z"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FCB685",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 776.303c.29 0 .57.083.808.228.404.249.767.839.767 1.347 0 .881-.705 1.586-1.575 1.586s-1.585-.705-1.585-1.586c0-.518.383-1.13.808-1.368.228-.135.487-.207.777-.207z"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FCB485",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 776.365c.28 0 .549.083.777.218.415.249.736.777.736 1.295a1.517 1.517 0 1 1-3.036.01c0-.539.342-1.078.777-1.326.218-.124.466-.197.746-.197z"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FCB482",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.049,
    d: "M376.282 779.338a1.455 1.455 0 1 0-.009-2.91 1.455 1.455 0 0 0 .009 2.91z"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.294 779.35a1.455 1.455 0 1 0-.009-2.913 1.455 1.455 0 0 0 .009 2.913z"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.037,
    d: "m376.604 776.458.165-.776M376.449 776.439l.081-.788M376.294 776.427v-.788M376.148 776.439l-.083-.788M375.993 776.458l-.167-.776M375.847 776.501l-.248-.757M375.702 776.551l-.32-.724M375.568 776.613l-.404-.683M375.432 776.697l-.466-.633M375.32 776.8l-.54-.59M375.205 776.905l-.59-.53M375.112 777.029l-.643-.466M375.019 777.153l-.683-.394M374.956 777.287l-.726-.32M374.894 777.433l-.748-.248M374.852 777.578l-.767-.167M374.832 777.734l-.788-.084M374.82 777.889h-.786M374.832 778.034l-.788.081M374.852 778.19l-.776.165M374.894 778.333l-.757.251M374.947 778.479l-.726.322M375.019 778.615l-.841.518M375.1 778.749l-1.72 1.223M375.195 778.863l-1.834 1.627M375.298 778.975l-1.514 1.691M375.422 779.071l-1.151 1.543M375.547 779.164l-1.201 2.083M375.683 779.226l-.664 1.512M375.826 779.288l-.674 2.083M375.971 779.329l-.289 1.4M376.127 779.35l-.208 2.154M376.428 779.35l.084.786M376.583 779.329l.466 2.03M376.729 779.288l.394 1.201M376.872 779.236l.924 1.999M377.018 779.164l.984 1.698M377.142 779.08l1.421 1.865M377.266 778.987l1.244 1.44M377.371 778.885l1.844 1.677M377.464 778.758l1.005.726M377.557 778.634l.683.394M377.62 778.5l.726.32M377.682 778.354l.745.248M377.722 778.209l.767.167M377.744 778.053l.788.083M377.753 777.898h.788M377.744 777.753l.788-.081M377.722 777.597l.779-.165M377.682 777.454l.757-.248M377.629 777.308l.726-.322M377.567 777.163l.685-.394M377.483 777.038l.633-.466M377.381 776.914l.59-.528M377.278 776.812l.528-.592M377.154 776.707l.466-.631M377.03 776.625l.392-.685M376.893 776.563l.322-.726M376.748 776.501l.251-.748M376.294 774.571v-.611M375.609 774.645l-.124-.602M374.947 774.853l-.251-.549M374.345 775.204l-.363-.497M373.827 775.66l-.456-.404M373.423 776.231l-.54-.31M373.132 776.862l-.58-.196M372.986 777.535l-.611-.062M372.986 778.23l-.611.062M373.132 778.916l-.59.186M379.162 779.558l.53.31M379.442 778.925l.58.186M379.588 778.252l.611.062M379.588 777.557l.611-.062M379.442 776.874l.592-.186M379.162 776.241l.53-.31M378.759 775.682l.456-.416M378.253 775.216l.351-.499M377.651 774.863l.248-.559M376.987 774.645l.124-.59"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "#E60000",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M377.142 778.572s-.207-.114-.332-.114c-.124 0-.674-.031-.891.031-.124.042-.228.145-.228.145s.145.145.435.176c.301.021.487 0 .643-.052.176-.052.373-.186.373-.186z"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "#E60000",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M375.733 778.354s.021-.404.301-.912c0 0-.093.145-.145.269 0 0-.156.083-.249-.031-.093-.093-.041-.135.031-.28.062-.114.052-.228.135-.3.072-.073.134-.083.331-.083s.321.021.487.249c.145.197.228.384.301.487.166.259.166.57.166.57l.052.249s-.207-.114-.331-.114-.674-.031-.891.031c-.124.042-.228.145-.228.145s-.085-.186.04-.28z"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M375.733 778.354s.156-.093.684-.083c.612.01.632.052.673.094"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.26 780.635v-2.145s.073-.062.238 0v2.124s.052 1.627-.125 1.617c-.206 0-.113-.373-.113-1.596z"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "#E60000",
    d: "m374.044 778.832.042.083-.414.176.062.145-.062.021c-.042-.093-.073-.124-.176-.103l-.031-.062.579-.26zM373.598 778.655a.187.187 0 0 1-.073-.114c-.021-.104.021-.217.155-.249.062-.021.218-.021.27.176.021.083.01.186-.125.238l-.021-.083c.072-.021.093-.083.072-.155-.021-.083-.093-.114-.176-.093-.083.021-.114.093-.104.166.01.042.041.083.093.104l.01.062-.352.031-.072-.321.083-.01.062.259.178-.011zM373.433 777.495c-.104 0-.145.073-.145.145-.01.062 0 .155.093.166.062 0 .083-.042.093-.073l.062-.187c.021-.083.083-.135.176-.124.155.01.186.155.176.269-.01.114-.052.166-.073.186a.2.2 0 0 1-.176.052l.01-.083c.114.01.156-.083.166-.166.01-.062 0-.166-.093-.176-.073-.01-.093.021-.124.125l-.042.135c-.021.042-.052.135-.166.124-.103-.01-.197-.083-.186-.238.021-.228.155-.238.228-.238v.083h.001zM373.402 777.091l.186.062.114-.342.073.031-.114.332.207.073.125-.373.072.021-.145.456-.622-.197.145-.456.083.031-.124.362zM373.828 776.133a.212.212 0 0 0-.127.097l-.142.246.545.343.052-.067-.239-.149.104-.172c.072-.125.023-.225-.06-.276a.174.174 0 0 0-.133-.022zm.037.097c.014.002.029.012.045.022.062.042.064.095.022.157l-.082.134-.179-.104.097-.149c.023-.039.055-.066.097-.06zM374.583 776.168l-.052.062-.415-.393-.155.156-.052-.052.363-.383.062.052-.156.166.405.392zM374.801 775.982l-.383-.518.062-.052.394.518-.073.052zM374.79 775.298l.093.176.321-.166.031.072-.311.166.093.186.352-.176.031.062-.425.228-.301-.58.425-.218.031.073-.34.177zM375.993 775.474l-.083-.373a.651.651 0 0 0-.031-.156l-.062.57-.083.021-.301-.497c.01.062.031.145.042.155l.083.384-.083.01-.145-.632.124-.021.301.497.062-.58.124-.031.135.643-.083.01zM376.209 774.812l-.03.649.276.007c.145.01.231-.068.231-.172.01-.114-.07-.143-.112-.164a.141.141 0 0 0 .09-.134c.01-.093-.047-.169-.172-.179l-.287-.007h.004zm.097.09.142.015c.093 0 .127.028.127.09-.01.073-.051.093-.134.082h-.149l.014-.187zm-.015.269.157.015c.062 0 .134.022.134.104 0 .062-.051.104-.134.104l-.164-.015.007-.208zM376.933 774.872l-.172.634.082.022.067-.269.209.06c.104.031.092.09.082.142a.363.363 0 0 0-.03.157l.104.03v-.008c-.021-.021-.018-.033-.007-.075l.015-.112c.031-.083.001-.114-.03-.134.041-.021.106-.034.127-.127.041-.135-.053-.193-.157-.224l-.29-.096zm.082.112.187.067c.041.01.106.026.075.119-.021.083-.08.078-.142.067l-.179-.052.059-.201zM377.702 775.246l-.104.166.311.187-.042.062-.311-.176-.104.186.332.197-.031.062-.414-.239.321-.56.415.238-.042.073-.331-.196zM378.485 775.723l-.493.411.164.209c.145.155.319.086.433-.007.145-.114.181-.283.067-.418l-.171-.195zm-.008.141.097.119c.073.083.062.173-.052.276-.114.093-.219.09-.291.008l-.097-.112.343-.291zM378.935 776.448l-.186.093.166.311-.073.042-.155-.321-.197.093.176.352-.073.031-.218-.425.58-.29.218.425-.073.031-.165-.342zM378.706 777.609l-.01-.083.446-.062-.021-.145.062-.01c.031.103.041.135.145.145l.01.062-.632.093zM378.91 777.805c-.031 0-.087-.003-.149.06a.253.253 0 0 0-.052.157c-.01.145.093.216.187.216.052.01.123-.007.164-.09.01.031.044.082.127.082.083.01.172-.042.172-.187.01-.145-.092-.202-.164-.202-.062 0-.106.028-.127.09-.022-.071-.075-.116-.158-.126zm0 .105c.052 0 .107.044.097.127 0 .062-.029.112-.112.112-.094 0-.104-.075-.104-.127 0-.094.067-.112.119-.112zm.284.029c.042 0 .092.021.082.104 0 .083-.051.104-.082.104a.121.121 0 0 1-.097-.119c0-.051.045-.089.097-.089zM379.1 778.376c.207.052.186.207.176.269-.031.104-.124.176-.238.145-.104-.021-.135-.104-.166-.218l-.021-.073c-.021-.093-.062-.124-.094-.135l-.083.342-.073-.021.104-.425c.135.042.187.114.218.207l.021.093c.021.072.041.135.124.145.042.021.114 0 .135-.093.031-.114-.073-.145-.114-.156l.011-.08zM378.47 778.997l.041-.083.404.197.062-.135.062.021c-.042.104-.052.145.031.207l-.021.062-.579-.269z"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.083,
    d: "m376.293 770.231-10.839 18.135h21.688l-10.849-18.135z"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M376.872 786.126c.28.073.622.114.964.021.466-.114.901-.383 1.451-.332.394.041.933.383 1.586.383.643 0 .86-.228 1.42-.342.394-.083.591-.041 1.016.052.487.093.736.373 1.554.311"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.135,
    d: "M368.511 786.905c.362-.28 1.005-.394 1.492-.28.642.135.922.3 1.606.29.508-.01.943-.352 1.461-.352.86 0 .891.176 1.648.321.197.041.446.041.643 0a2.82 2.82 0 0 0 .756-.259c.238-.124.839-.104 1.14-.073.539.052.756.259.87.29.29.073.622.114.964.021.466-.135.901-.435 1.461-.373.394.042.932.425 1.575.425.643 0 .87-.259 1.42-.383.404-.094.601-.042 1.026.052.477.114.736.425 1.555.352"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.098,
    d: "M367.288 786.293c.363-.238 1.005-.342 1.492-.249.643.124.922.28 1.606.269.508-.01.943-.321 1.461-.321.86 0 .891.166 1.648.29.197.031.446.031.643 0 .28-.041.529-.135.756-.238.228-.104.839-.083 1.14-.062.539.052.756.228.87.259.29.062.622.103.963.021.466-.124.902-.384 1.461-.332.394.041.933.383 1.575.373.643 0 .871-.228 1.42-.342.404-.083.601-.031 1.026.052.477.104.736.384 1.555.311"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.171,
    d: "M366.167 788.065c.363-.3 1.005-.425 1.503-.311.632.156.912.342 1.596.332.508-.01.953-.394 1.461-.394.87 0 .891.197 1.648.363.197.041.445.041.653 0a2.49 2.49 0 0 0 .746-.301c.238-.124.839-.104 1.15-.072.529.062.746.28.86.321.29.072.622.124.974.021.466-.156.902-.477 1.451-.415.394.052.933.477 1.586.477.632 0 .86-.29 1.409-.435.404-.104.601-.042 1.026.062.487.124.735.477 1.554.394"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.098,
    d: "M366.459 787.048c.373-.249 1.016-.342 1.503-.249.643.124.922.269 1.606.259.228 0 .435-.062.653-.135"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.086,
    d: "M369.743 785.992c.104-.031.404-.176.839-.176.87 0 .321.01 1.078.145.197.031.746.042.902-.114M380.149 788.304c.28-.052.518-.135.756-.239.228-.103.829-.093 1.14-.062.539.052.746.228.87.249.29.073.622.114.963.021.466-.114.902-.384 1.461-.332.394.042.933.383 1.575.383"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.098,
    d: "M381.484 785.909c.643 0 .86-.228 1.42-.342.394-.083.591-.031 1.015.052.487.093.736.384 1.554.311"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.037,
    d: "M366.198 788.127c.373-.238 1.016-.342 1.503-.249.643.125.922.28 1.606.269.508-.01.943-.321 1.461-.321.86 0 .891.166 1.648.29.197.031.446.031.643 0a2.97 2.97 0 0 0 .756-.238c.228-.104.829-.083 1.14-.052.539.042.746.218.87.249"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.171,
    d: "M367.567 787.339c.373-.249 1.015-.342 1.502-.249.643.124.922.269 1.596.259.518-.01.953-.321 1.461-.311.87 0 .902.156 1.658.29.197.031.445.031.643 0 .28-.052.518-.135.756-.238.228-.104.829-.093 1.14-.062.528.052.746.228.87.249.28.073.622.114.964.021.466-.114.901-.384 1.461-.332.425.041.964.383 1.575.383.643 0 .87-.228 1.42-.342.394-.083.591-.041 1.026.052.476.093.736.373 1.544.3"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeWidth: 0.073,
    d: "M367.858 784.323c.104.021.352-.176.425-.228.104-.062.155-.218.238-.301.083-.093.332-.207.445-.28.497-.311.725-.487 1.067-.943.466-.642 1.016-1.171 1.699-1.554.218-.125.549-.083.787.021.072.031.166.114.249.176.29.228.684.394 1.161.539.456.135.56.435.922.756.176.155.373.29.591.393.021.01.072.093.093.104.207.156.435.28.612.435.332.301.643.601.953.922.052.052.073.155.125.197.238.228.466.466.756.601.29.145.549.332.819.497-2.757.104-5.295-.073-8.062.01-.073.01-.094 0-.508 0-.207-.01-.332.01-.539.01-.839-.01-1.637-.01-2.622-.021l.789-1.334z"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeWidth: 0.073,
    d: "M378.687 785.589c-.228-.145-.456-.3-.705-.425-.29-.135-.518-.373-.756-.601-.052-.042-.073-.145-.125-.197a20.216 20.216 0 0 0-.953-.922c-.176-.155-.404-.28-.611-.435-.021-.01-.072-.093-.093-.104a2.539 2.539 0 0 1-.591-.394c-.238-.218-.363-.415-.56-.57l.01-.01c.114-.083.238-.166.373-.228.176-.104.456-.072.653.021a.787.787 0 0 1 .207.135c.238.197.57.332.964.456.384.114.477.363.777.622.145.135.301.249.487.332.01.01.052.072.072.093.176.125.363.228.518.363.27.249.529.498.788.767.042.041.052.124.104.166.197.186.393.383.632.497.238.114.445.27.674.404-.622.031-1.233.031-1.845.031h-.02v-.001z"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeWidth: 0.073,
    d: "M376.229 782.231c.083.021.176.052.269.083.384.114.477.363.777.622.145.135.301.249.487.332.01.01.052.072.072.093.176.125.363.228.518.363.269.249.529.497.787.767.042.042.052.125.104.166.197.187.393.384.632.497.207.093.383.228.57.342.508 0 1.015-.01 1.544-.031-.208-.125-.394-.27-.622-.373-.218-.104-.383-.28-.57-.456-.042-.031-.052-.104-.093-.145-.239-.249-.477-.466-.726-.694-.135-.125-.3-.218-.456-.332-.021-.01-.062-.073-.073-.083a1.886 1.886 0 0 1-.446-.3c-.269-.238-.352-.466-.705-.57-.352-.104-.653-.239-.87-.404-.062-.052-.135-.114-.187-.135-.187-.083-.435-.114-.601-.021a3.03 3.03 0 0 0-.411.279z"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeWidth: 0.073,
    d: "M378.759 782.821c.073.083.145.166.249.259.135.124.28.218.446.3.01.01.052.073.073.083.155.114.321.207.456.332.249.228.487.446.726.694.041.042.052.114.093.145.187.176.352.352.57.456.145.072.269.155.404.238h-.011c.601 0 1.202 0 1.814-.021-.166-.104-.311-.218-.498-.301-.176-.093-.311-.238-.466-.373-.031-.031-.041-.083-.073-.124-.197-.197-.383-.373-.58-.56-.114-.104-.249-.176-.373-.27-.021-.01-.052-.052-.062-.062a1.652 1.652 0 0 1-.363-.239c-.217-.197-.28-.383-.56-.466-.29-.093-.539-.186-.715-.332-.052-.041-.104-.083-.145-.103-.155-.062-.352-.094-.487-.021a2.78 2.78 0 0 0-.497.352l-.001.013z"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    stroke: "#000",
    strokeWidth: 0.073,
    d: "M383.454 785.226a2.238 2.238 0 0 0-.373-.218c-.176-.093-.311-.238-.466-.373-.031-.031-.041-.083-.073-.124-.197-.197-.383-.373-.58-.56-.114-.104-.249-.176-.373-.27-.021-.01-.052-.052-.062-.062a1.652 1.652 0 0 1-.363-.239c-.186-.166-.259-.321-.445-.425l.01.01a1.9 1.9 0 0 1 .301-.197c.124-.073.29-.041.425.011.031.01.083.062.125.093.156.114.352.207.612.28.238.072.29.228.477.394.093.083.197.155.311.207.01.01.031.052.052.062.104.073.228.135.321.228.166.155.332.311.498.477.031.031.031.083.062.104.124.114.249.238.394.311.155.083.29.176.435.259-.435.021-.86.021-1.285.021l-.003.011z"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00633B",
    strokeWidth: 0.037,
    d: "M371.474 781.194c.135-.021.073-.052.197.031M371.226 781.359c.145-.021.197-.114.301.01M371.09 781.455c.062 0 .104-.073.3.041M370.946 781.619a.487.487 0 0 1 .321.021M370.779 781.743c.145-.042.207.062.363.031M370.603 781.92c.093 0 .124-.031.207 0 .104.031.083.01.186.021M370.407 782.106c.104 0 .135-.021.228-.01.124.021.094.031.218.01M370.292 782.262c.207-.021.269-.01.414.042M370.013 782.644c.176-.052.259-.052.414.011M367.132 785.608c.57-.093 1.244.01 1.813-.073M370.096 782.458c.145-.052.114-.031.259-.021.145.021.207.042.249.021M369.867 782.79c.145-.073.321-.031.466.01M370.242 782.945c-.155-.041-.321-.01-.487 0M370.118 783.112a.849.849 0 0 0-.508-.021M369.38 783.236c.207 0 .404-.052.611.021M369.205 783.401c.218-.073.435-.01.663.01M368.998 783.525c.228-.01.445-.01.674-.021.031 0 .104-.031.145.021M369.743 783.649c-.342.073-.684.021-1.026.031M369.557 783.826c-.114.01-.29.052-.446.042-.031-.01-.062-.031-.093-.031-.176-.01-.352-.01-.518.052M368.427 784.012a.294.294 0 0 1 .228-.031c.218.031.425 0 .632.052.052.021.104.052.166.052M368.303 784.096c.155 0 .311-.021.466.01.197.052.383.093.591.104h-.021M368.157 784.211c.166 0 .321.031.487.062.218.042.435-.021.643.042M367.961 784.313c.218.093.446.01.674.052.217.041.414.031.622.073M367.816 784.478c.332.01.663 0 1.005.062.093.021.238.062.363.042M367.703 784.624c.321.062.653.01.974.093.145.031.301.062.456.062h-.021M367.567 784.872c.031-.01.072-.031.103-.031.259 0 .508.042.777.01.207-.01.435-.031.643.042h-.021M367.452 785.039c.518-.052 1.047.021 1.565 0M367.359 785.195c.549.062 1.098.01 1.637.052M367.278 785.359c.238.052.477-.021.715.031.176.031.332.062.508.031.155-.042.3.01.445-.01M371.164 783.143h.052M371.111 783.205c.021.01.052-.031.062.01M371.049 783.289h.114M370.997 783.36h.145M370.904 783.454c.083.01.156.021.238.021h-.021M370.822 783.578c.093-.031.197 0 .29-.031h-.021M370.698 783.723h.394-.021M370.634 783.816c.145 0 .28-.021.415.01h-.011M370.553 783.95c.155-.021.321 0 .487.021M370.459 784.096c.104-.01.187.052.29.073.083.021.155 0 .228-.01M370.428 784.211c.155.052.321.062.477.073M370.335 784.335c.135-.01.259.021.394.062.062.021.124.01.176.01h-.01M370.158 784.531c.166-.073.363-.021.539.031.062.021.125-.01.197-.01h-.021M370.137 784.655a.83.83 0 0 1 .591.021c.031.01.072 0 .103 0M370.013 784.8c.259.052.528-.031.787.042M369.941 784.915c.207.083.435 0 .663.062a.316.316 0 0 0 .218-.01M369.795 785.07c.093-.031.187-.052.28-.031.249.062.477.042.705.073M369.681 785.235c.052-.01.104.031.145.021.321-.052.643 0 .953-.021M369.6 785.359c.249.093.508 0 .777.073a.58.58 0 0 0 .352 0M369.506 785.536c.383.01.746-.01 1.192.042M371.682 783.339c.042-.01.073.031.114.021M371.63 783.454c.052-.01.093-.031.145-.021M371.589 783.556c.072.01.135-.01.207.021M371.537 783.702c.083 0 .176 0 .259.021M371.465 783.848c.114-.031.218.01.332-.021M371.453 783.95c.104.041.207.01.321.021v-.021M371.391 784.115c.104-.01.197-.021.29.021.031.01.073 0 .114-.021M371.381 784.261c.135-.052.269.031.415 0M371.319 784.437c.156-.01.3.021.456 0M371.267 784.571c.062-.021.135-.062.197-.031.093.042.207.021.311.031M371.235 784.729c.176-.062.363.042.539-.052M371.214 784.894a.443.443 0 0 1 .259.01c.093.021.207.01.321-.01M371.164 785.049c.207-.042.425 0 .643-.01l-.01.01M371.04 785.195c.269-.021.549-.052.818-.052M371.071 785.359c.3-.052.611-.031.922-.042M371.018 785.527c.3.042.363-.021.663-.031.052 0 .311-.052.363-.062.041-.01.135 0 .176 0M371.018 785.608c.456-.042.922.042 1.388-.073M369.038 785.558h.362M370.801 785.608c.042.021.093-.021.124.021M372.532 785.577c.373-.042.756.073 1.129 0M372.344 785.452c.238-.072.456-.02.684.021.021 0 .021.052.041.062.207.031.404 0 .612-.01M371.018 785.433h-.238M369.537 785.381c-.166.01-.332.01-.497.031M372.657 781.889h.073M372.688 781.992c.031.01.062 0 .093-.01M372.707 782.159c.011-.01.011-.031.021-.031.031-.01.072-.01.104-.01M372.75 782.262c.052-.031.114-.01.176-.01M372.945 782.355a.3.3 0 0 0-.166.031M372.852 782.532a.229.229 0 0 1 .166-.031M373.091 782.625h-.238M372.924 782.749c.083 0 .166.021.228-.031M373.215 782.894c-.093 0-.176 0-.259.021M373.017 783.069c.093.01.187-.01.28-.052M373.318 783.112c-.083.042-.176.052-.269.073M373.101 783.339c.114-.062.249-.01.363-.052M373.495 783.432c-.093 0-.186-.021-.28.01-.031.01-.052.031-.093.031M373.194 783.702c.073-.031.145-.083.228-.073.01-.052.062 0 .083-.031.021-.01.062 0 .104 0M373.66 783.754c-.135-.01-.28.021-.414.042M373.287 783.972c.155-.062.311-.062.477-.083M373.299 784.167c.176-.041.363-.031.528-.104M373.951 784.189c-.197.031-.394 0-.58.093M373.411 784.459c.031.01.052.031.083.021.187-.073.373-.135.56-.114M374.106 784.5c-.186.104-.404.062-.612.073-.02 0-.041.021-.072.031M373.495 784.729c.228-.031.446-.042.674-.073M374.314 784.8c-.187.031-.363-.01-.539.031-.083.01-.156.042-.238.062M373.567 785.039c.031 0 .072.01.093-.01.228-.135.487-.094.736-.104M374.469 785.07c-.207 0-.425-.052-.632.021-.072.031-.145.072-.228.072M373.681 785.319c.114-.021.218-.073.321-.093.238-.031.477-.01.715-.01M374.718 785.34a.759.759 0 0 0-.404 0c-.207.052-.394.104-.601.114M373.827 785.558c.166-.021.321-.072.487-.114.135-.031.269-.01.404-.01M373.836 785.651c.249-.041.497 0 .746-.083.083-.031.176.021.269.01M374.852 785.484c.414.031.829-.052 1.233.041M374.935 785.608c.052.01.093-.031.124-.031.342 0 .684.01 1.026.031M375.962 784.729h.052M375.981 784.841c.042.021.083-.052.124 0M376.012 784.965h.218M376.074 785.142c.073-.083.176 0 .249-.052M376.127 785.309c.093-.083.228.01.321-.073M376.148 785.433c.135-.042.28.01.414-.073M376.198 785.558c.207-.093.445.042.643-.104M376.22 785.66c.259-.083.529 0 .788-.01M377.173 785.651c.456-.021.922-.031 1.378 0M376.977 785.484c.404.041 1.015 0 1.523.041M374.739 782.364c.031 0 .311-.052.331-.052M374.832 782.439c.083.01.28.01.352-.052M374.966 782.572c0-.01.238-.052.249-.052.031-.01.073 0 .114-.01M375.071 782.644c.041-.031.373-.01.435-.021M375.587 782.718c-.062 0-.332.01-.373.042M375.444 782.904c.042-.031.238-.062.311-.062M375.909 782.957c-.083 0-.259.021-.352.021M375.733 783.112c.093-.01.259-.031.311-.073M376.21 783.193c-.093 0-.217.01-.342.021M376.024 783.339c.114 0 .28 0 .363-.031M376.511 783.379c-.073.042-.218.052-.311.073M376.354 783.599c.093-.062.259-.021.373-.062M376.853 783.671c-.114 0-.228-.01-.311.01-.031.01-.042.031-.093.031M377.225 783.95c-.166-.01-.3.021-.446.041M376.924 784.148c.145-.062.321-.052.487-.083M377.288 784.583a.813.813 0 0 0 .217-.031c.249-.031.29-.083.518-.062M378.159 784.593c-.301.052-.414.062-.643.083a.45.45 0 0 0-.124.031M377.526 784.8c.228-.041.56-.031.787-.062M378.563 784.863c-.187.031-.404 0-.58.042-.083.01-.238.021-.321.042M377.878 785.089c.031 0 .073 0 .093-.01.187-.125.487-.104.756-.104M378.895 785.101c-.259 0-.363.01-.56.031-.073.01-.176.052-.269.052M378.284 785.319c.238-.042.694-.093.425-.073.249-.021.29-.021.56-.021M379.339 785.328a1.306 1.306 0 0 0-.456.01c-.104.031-.073.062-.425.073M378.604 785.484c.166-.021.187-.01.342-.052.125-.031.29-.021.446-.021M378.687 785.546c.259-.031.29-.021.56-.01.073 0 .135 0 .228-.01M374.656 782.262c.062-.031.104-.052.218-.042-.031-.042.052 0 .073-.021 0-.021.062-.01.104-.01M374.531 782.137c.062-.031.124-.031.228-.021-.031-.052.062 0 .072-.031.01-.01.073 0 .114 0M376.593 783.879c.073-.031.062-.052.166-.031-.031-.052.114 0 .125-.031.01-.021.124-.01.166-.01M377.03 784.292c.166-.042.373-.042.518-.114M377.796 784.366c-.197.031-.487.01-.643.093M374.789 781.961c-.187-.01-.218.052-.352.052M376.831 782.479c.031 0 .238-.042.269-.042M376.915 782.563c.124-.031.218 0 .29-.052M377.018 782.665c0-.01.197-.031.207-.031.031-.01.073-.01.104-.01M377.123 782.759c.042-.031.311-.021.373-.031M377.567 782.821a1.256 1.256 0 0 0-.352.052M377.35 782.988c.042-.031.311-.062.373-.052M377.868 783.038c-.083 0-.311.021-.394.031M377.608 783.174c.083 0 .342-.021.383-.062M378.138 783.255c-.083 0-.228.01-.342.021M377.899 783.391c.104 0 .332 0 .404-.042M378.417 783.422c-.062.042-.259.062-.342.083M378.262 783.618c.083-.052.249-.021.352-.052M378.728 783.692c-.093 0-.207-.01-.28.01-.031.01-.042.031-.083.021M379.069 783.95c-.145-.01-.269.021-.404.041M378.799 784.136c.134-.062.3-.062.456-.083M379.162 784.54c.042.01.145-.031.166-.031.239-.031.27-.083.487-.073M379.929 784.54a3.45 3.45 0 0 1-.581.073.442.442 0 0 0-.124.031M379.349 784.729c.207-.031.518-.031.725-.052M380.304 784.791c-.166.021-.363 0-.529.031-.073.021-.228.021-.301.042M379.681 784.996c.031 0 .062 0 .083-.01.166-.114.446-.093.705-.093M380.615 785.008c-.238 0-.342.01-.518.031-.114.01-.249.052-.28.052M379.991 785.204c.218-.042.695-.083.446-.062.228-.021.27-.021.518-.021M381.018 785.226c-.156-.021-.3-.031-.414 0-.083.021-.114.062-.456.073M380.273 785.371c.155-.021.249-.021.383-.052.114-.031.269-.021.415-.021M380.428 785.452c.218-.031.249-.052.508-.041.073 0 .124-.01.207-.021M376.707 782.395c.062-.031.041-.052.135-.042.073-.021.125.01.135-.021 0-.01.062-.01.093-.01M376.562 782.314c.062-.031.073-.062.166-.052.093-.01.135 0 .145-.031.01-.01.062 0 .104 0M378.52 783.879c.062-.031.031-.042.125-.031-.021-.042.104 0 .114-.021.01-.021.114-.01.155-.01M378.895 784.261c.155-.042.342-.042.477-.094M379.599 784.335c-.176.031-.404-.01-.539.062M376.841 782.116a.676.676 0 0 0-.425.145M378.966 783.028c.021 0 .27-.042.28-.042M379.05 783.09c.093-.021.228-.01.28-.052M379.143 783.162c-.01 0 .197-.031.207-.031.021-.01.052 0 .083 0M379.224 783.236c.031-.021.29-.021.332-.031M379.619 783.277a.82.82 0 0 0-.28.041M379.485 783.401a.88.88 0 0 1 .249-.042M379.836 783.444c-.052 0-.238.021-.301.021M379.65 783.547c.062 0 .249-.021.29-.052M380.053 783.609c-.073 0-.187.01-.27.01M379.867 783.711c.083 0 .249 0 .311-.031M380.273 783.743c-.052.031-.208.042-.27.052M380.096 783.888c.062-.042.249-.01.321-.031M380.509 783.941c-.083 0-.166-.01-.228.01-.021.01-.042.01-.073.01M380.77 784.148c-.114-.01-.259.031-.352.042M380.531 784.273c.093-.042.259-.031.373-.052M380.789 784.583c.021.01.156-.01.176-.01.176-.021.207-.062.373-.052M381.434 784.602a4.31 4.31 0 0 1-.456.052c-.021 0-.094.011-.114.011M380.946 784.738c.166-.031.435-.021.601-.042M381.713 784.791c-.124.021-.28 0-.404.021a2.167 2.167 0 0 1-.259.031M381.183 784.956c.021 0 .166-.042.176-.042.207-.021.28-.042.477-.052M381.95 784.956c-.186 0-.259.01-.394.021-.093.011-.249.062-.269.062M381.443 785.12c.135-.031.539-.072.373-.062.176-.01.207-.01.393-.021M382.263 785.12c-.114-.01-.228-.021-.321 0-.052.021-.114.042-.373.062M381.67 785.235c.124-.021.207-.01.311-.042.093-.031.218-.01.321-.021M381.775 785.297c.166-.021.228-.042.425-.031.052 0 .093 0 .166-.01M378.914 782.957c.052-.021.073-.052.145-.042.052-.01.093.01.093-.01.01-.01.052-.01.083-.01M378.83 782.883c.052-.021.062-.042.135-.042s.104 0 .114-.01c0-.021.052-.01.073-.01M380.304 784.084c.052-.021.062-.031.145-.021-.031-.031.073 0 .083-.021 0-.01.083 0 .114 0M380.634 784.385c.114-.031.259-.031.363-.083M381.173 784.437c-.135.021-.332-.01-.446.052M379.05 782.737c-.135-.01-.166.041-.249.104M380.903 783.112c.021 0 .238-.031.259-.031M380.977 783.183c.083-.021.218-.021.259-.052M381.059 783.246l.197-.031c.021-.01.052 0 .073 0M381.152 783.348a1.3 1.3 0 0 1 .29-.062M381.505 783.348a.85.85 0 0 0-.29.052M381.329 783.475a.761.761 0 0 1 .28-.042M381.713 783.506c-.062 0-.228.01-.311.031M381.505 783.599c.062 0 .259-.021.29-.052M381.909 783.649c-.062 0-.218.021-.3.031M381.732 783.754c.072 0 .238 0 .29-.031M382.107 783.774c-.052.031-.228.031-.29.052M381.95 783.919c.052-.041.218-.021.29-.041M382.325 783.962c-.073 0-.145 0-.207.01-.01.01-.062.01-.083.01M382.563 784.148c-.104-.01-.228.031-.322.042M382.325 784.282c.093-.042.259-.042.373-.062M382.583 784.562c.021 0 .145-.021.166-.021.166-.021.197-.052.342-.042M383.172 784.571a3.685 3.685 0 0 1-.415.052c-.021 0-.093 0-.104.01M382.719 784.717c.156-.021.415-.042.56-.052M383.442 784.748c-.124.01-.269 0-.383.021-.093.02-.228.02-.238.031M382.945 784.894c.021 0 .156-.031.166-.031.187-.021.259-.042.446-.052M383.66 784.894c-.176.01-.239.01-.363.021-.094.01-.228.062-.259.062M383.184 785.049c.135-.021.508-.073.352-.052.155-.021.186-.021.363-.021M383.951 785.049c-.114-.01-.228-.021-.3 0-.052.021-.104.042-.342.052M383.402 785.151c.104-.01.187-.01.29-.041.083-.021.187-.01.29-.01M383.485 785.214c.166-.021.218-.031.404-.031.052 0 .083 0 .145-.01M380.863 783.05c.042-.021.052-.042.124-.031.052-.01.083 0 .094-.01 0-.01.042-.01.072-.01M380.779 782.988c.052-.021.052-.042.125-.031.062-.01.093 0 .104-.021 0-.01.041-.01.073-.01M382.138 784.096c.042-.021.062-.021.124-.021-.021-.031.073 0 .083-.01.01-.01.083-.01.104-.01M382.427 784.366c.104-.021.259-.021.352-.062M382.945 784.416c-.135.021-.342-.01-.445.042M380.987 782.852c-.124-.01-.166.042-.238.093"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "m366.835 798.994.179 1.328c-.351-.115-.673.091-.829.382-.248.497-.029.872.449 1.111l.643.33 1.194-2.321-.478-.239-.478.931h-.01l-.103-1.23-.567-.292zm.179 1.753c.077.007.16.041.246.084l.06.029-.334.635-.06-.031c-.217-.112-.363-.248-.239-.506.083-.163.198-.22.327-.211zM364.625 798.903l.694.466.393-.58-.725-.487.249-.372 1.161.787-1.451 2.156-1.161-.778.249-.363.725.477.322-.477-.705-.467zM364.282 797.172l-.633.733-.203-.165c-.413-.363-.831-.346-1.194.067-.382.456-.241.855.196 1.218l.545.468 1.686-1.977-.397-.344zm-1.321.845c.091.007.191.069.299.162l.083.06-.47.547-.077-.062c-.196-.165-.308-.32-.11-.559.098-.114.184-.157.275-.148zM361.08 797.805l-.352-.394 1.078-.984c.238-.207.56-.539.259-.87-.3-.332-.663-.052-.901.166l-1.078.974-.352-.383 1.15-1.047c.477-.425 1.016-.539 1.503-.01.487.539.321 1.078-.155 1.503l-1.152 1.045zM360.126 792.883a.698.698 0 0 0-.463.134c-.227.165-.404.461-.268.762-.189-.084-.399-.026-.554.088-.425.291-.416.652-.127 1.068l.373.537 2.15-1.471-.471-.678c-.174-.254-.394-.421-.64-.44zm-.007.558c.155-.014.27.112.38.268l.067.084-.552.372-.045-.06c-.134-.196-.275-.428-.014-.604a.34.34 0 0 1 .164-.06zm-.762.755c.095-.002.177.062.253.179l.038.05-.509.351-.036-.05c-.115-.167-.148-.322.06-.456a.318.318 0 0 1 .194-.074zM358.967 791.132l.383-.208.611 1.119-2.289 1.244-.26-.467 1.907-1.024zM358.925 789.951l.208.487-2.384 1.047-.207-.487zM356.251 788.146a.802.802 0 0 0-.083.653c.166.477.674.612 1.109.477.414-.135.736-.56.58-1.026-.062-.218-.249-.394-.445-.487l.57-.186c.155.166.28.332.342.539.238.725-.187 1.451-.87 1.679-.705.228-1.492-.083-1.741-.839a1.398 1.398 0 0 1-.041-.622l.579-.188zM357.499 784.664l-2.448 1.486.074.404 2.813.566-.105-.545-.573-.126-.172-.927.516-.306-.105-.552zm-.793 1.082.112.628-.984-.119v-.017l.872-.492zM356.125 779.799c-.674.003-1.204.471-1.261 1.209l-.06.745 2.589.21.06-.748c.062-.767-.459-1.347-1.194-1.409-.045-.004-.088-.009-.134-.007zm-.098.597a.892.892 0 0 1 .179 0c.466.031.769.289.716.879v.076l-1.559-.129.007-.074c.036-.479.261-.725.657-.752zM356.822 777.754l-.166.819.694.145.176-.85.425.083-.279 1.378-2.55-.539.28-1.368.435.093-.176.85.559.114.177-.818zM357.91 774.531l-.311.788.652.248.322-.808.415.155-.508 1.306-2.435-.943.518-1.306.414.156-.321.819.528.207.311-.788zM359.474 772.946l.394.197-.58 1.139-2.321-1.191.238-.466 1.928.984zM359.858 769.527c-.166.01-.311.062-.415.197-.104.145-.104.342.031.446.352.259.85-.715 1.554-.187.414.311.508.798.176 1.243-.217.301-.549.394-.901.363l-.052-.466c.207.062.456.021.591-.166.135-.166.073-.383-.093-.497-.218-.166-.425 0-.622.124-.311.197-.601.301-.922.062a.771.771 0 0 1-.166-1.098c.145-.197.435-.394.674-.425l.145.404zM361.021 767.244l-.291.291 1.187 2.62.387-.404-.239-.537.65-.671.545.225.389-.404-2.628-1.12zm.411.74.829.38-.404.425-.432-.798.007-.007zM364.759 766.915l.28.342-.995.808-1.637-2.031.415-.332 1.357 1.679zM365.392 763.899l.487-.3.538 2.818-.259.166-2.311-1.699.477-.311 1.492 1.14.01-.011zM367.723 762.632l-.373.179.134 2.873.509-.232-.024-.604.85-.38.418.418.516-.232-2.03-2.022zm.105.85.643.664-.54.239-.103-.888v-.015zM370.627 761.729c-.134 0-.277.024-.418.067l-.716.21.731 2.491.709-.201c.745-.217 1.111-.915.903-1.619-.17-.582-.633-.953-1.209-.948zm-.016.545c.325.012.542.201.65.576.136.444-.005.812-.573.977l-.076.029-.432-1.5.074-.028c.132-.037.249-.059.357-.054zM373.754 760.975c-.048.002-.101.01-.148.014-.779.105-1.24.805-1.137 1.531.093.736.724 1.283 1.502 1.18.786-.105 1.242-.795 1.149-1.531-.089-.681-.647-1.216-1.366-1.194zm-.06.582c.413-.052.762.289.814.671.041.353-.208.841-.614.903-.404.053-.776-.363-.829-.716-.04-.382.204-.805.629-.858zM375.91 760.855l-.029 2.606h.528l.01-1.046h.007l.643 1.061.64.007-.752-1.103c.363-.052.559-.385.559-.716.009-.561-.361-.788-.889-.8l-.717-.009zm.538.463h.074c.248 0 .444.06.435.351 0 .289-.186.365-.456.365h-.06l.007-.716zM382.013 763.091l-.82-.207-.165.684.849.217-.113.425-1.358-.342.634-2.528 1.356.342-.104.435-.849-.218-.134.56.808.197zM384.428 764.272l.652-1.627.487.197-.983 2.467-.353-.146-.652-2.217h-.013l-.652 1.637-.486-.186.995-2.488.351.135.644 2.228zM387.525 766.448l-.237.373-1.08-.673 1.391-2.208.444.281-1.151 1.834zM390.047 765.558l-2.508 1.412.432.349.516-.289.724.604-.179.559.439.351.896-2.725-.32-.261zm-.39.754-.299.865-.454-.365.753-.5zM393.949 769.632l-2.775.709.32.449.583-.136.545.755-.32.499.334.456 1.56-2.403-.247-.329zm-.559.628-.516.759-.344-.478.86-.281zM394.128 775.246l-.24-.477 1.348-.922-1.753.187-.081-.156 1.202-1.274v-.011l-1.556.519-.236-.477 2.59-.798.175.332-1.232 1.367 1.813-.197.175.342zM395.817 776.707l-.272-.798-.662.228.279.829-.424.145-.445-1.336 2.467-.829.454 1.326-.424.145-.279-.829-.539.187.269.787zM397.472 777.239l-2.536.537.103.514 1.025-.215h.014l-.896.872.141.621.91-.972c.136.344.494.454.814.382.549-.115.697-.516.583-1.046l-.158-.693zm-.32.626.014.067c.052.248.036.456-.253.509-.279.062-.389-.108-.442-.365l-.014-.06.695-.151zM395.422 780.614l-.062-.518 2.59-.301.062.519zM397.443 783.131a.78.78 0 0 0 .269-.601c-.01-.508-.466-.788-.912-.777-.435 0-.87.311-.86.808a.82.82 0 0 0 .28.591l-.601.01c-.093-.197-.166-.394-.166-.611-.011-.767.611-1.337 1.326-1.347.746-.01 1.399.518 1.42 1.316 0 .207-.052.425-.145.601l-.611.01zM395.525 783.621l-.06.552.514.284-.112.932-.581.134-.06.561 2.775-.681.053-.418-2.529-1.364zm.872 1.065.814.375v.007l-.888.201.074-.583zM395.618 791.091a.83.83 0 0 0 .477-.456c.186-.477-.125-.912-.539-1.078-.404-.155-.922-.041-1.109.415a.818.818 0 0 0 .042.663l-.57-.218c-.01-.218 0-.425.083-.632a1.334 1.334 0 0 1 1.741-.736c.694.269 1.099 1.015.808 1.751a1.38 1.38 0 0 1-.363.508l-.57-.217zM393.898 792.749l.395-.736-.622-.343-.415.778-.383-.218.662-1.232 2.292 1.242-.665 1.233-.392-.218.424-.765-.508-.269-.403.735zM392.147 794.801l1.42 1.025-.311.434-2.146-1.572.22-.302 2.309-.084h.01l-1.43-1.047.311-.424 2.156 1.575-.218.311-2.311.072zM391.982 796.996l.382-.392.312.301-1.119 1.17-.311-.301.373-.395-1.566-1.501.363-.383zM389.285 796.644l-.411.327.671.814v.007l-1.177-.382-.494.404 1.292.351c-.239.279-.179.652.038.91.351.425.791.365 1.194.024l.545-.456-1.658-1.999zm.499 1.462.456.552-.052.038c-.196.165-.372.241-.559.021-.186-.227-.088-.401.119-.566l.036-.045zM387.658 797.994l-.478.299.105.583-.8.492-.461-.351-.478.299 2.29 1.725.344-.215-.522-2.832zm-.298 1.366.232.867h-.014l-.716-.554.498-.313zM384.117 800.458l-.188-.395 1.151-.548 1.119 2.363-.477.218-.921-1.949z"
  })));
};
export default SvgBandera;